<script setup>
const animatedImg = ref(null)

onMounted(() => {
  restartAnimations(get(animatedImg))
})

function restartAnimations(element) {
  for (const animation of document.getAnimations()) {
    if (element.contains(animation.effect.target)) {
      animation.cancel()
      animation.play()
    }
  }
}
</script>

<template>
  <div class="animated-loading w-full">
    <svg
      id="eBN9jzcwViv1"
      ref="animatedImg"
      class="mx-auto w-full md:max-w-2xl"
      viewBox="0 0 500 500"
      shape-rendering="geometricPrecision"
      text-rendering="geometricPrecision"
      style="background-color: transparent"
    >
      <g transform="translate(-.000008-46.964409)">
        <g
          id="eBN9jzcwViv3_ts"
          transform="translate(250,359.717066) scale(0,1)"
        >
          <rect
            width="222.910082"
            height="7.937451"
            rx="0"
            ry="0"
            transform="translate(-111.455041,-3.968726)"
            fill="#d2dbed"
            stroke-width="0"
          />
        </g>
        <g
          id="eBN9jzcwViv4_ts"
          transform="translate(249.999917,363.685791) scale(-1,0)"
        >
          <rect
            width="222.910082"
            height="7.937451"
            rx="0"
            ry="0"
            transform="translate(-111.455132,-0.000002)"
            fill="#64676c"
            stroke-width="0"
          />
        </g>
        <g
          id="eBN9jzcwViv5_ts"
          transform="translate(249.999978,326.305353) scale(0,1)"
        >
          <line
            x1="154.150155"
            y1="0"
            x2="-154.150156"
            y2="0"
            transform="translate(-0.000028,0)"
            fill="none"
            stroke="#d2dbed"
            stroke-width="3"
            stroke-opacity="0.6"
          />
        </g>
        <g
          id="eBN9jzcwViv6_ts"
          transform="translate(249.999978,296.305353) scale(0,1)"
        >
          <line
            x1="154.150155"
            y1="0"
            x2="-154.150156"
            y2="0"
            transform="translate(-0.000028,0)"
            fill="none"
            stroke="#d2dbed"
            stroke-width="3"
            stroke-opacity="0.6"
          />
        </g>
        <g
          id="eBN9jzcwViv7_ts"
          transform="translate(249.999978,266.305353) scale(0,1)"
        >
          <line
            x1="154.150155"
            y1="0"
            x2="-154.150156"
            y2="0"
            transform="translate(-0.000028,0)"
            fill="none"
            stroke="#d2dbed"
            stroke-width="3"
            stroke-opacity="0.6"
          />
        </g>
        <g
          id="eBN9jzcwViv8_ts"
          transform="translate(249.999907,236.305353) scale(0,1)"
        >
          <line
            x1="154.150155"
            y1="0"
            x2="-154.150156"
            y2="0"
            transform="translate(-0.000028,0)"
            fill="none"
            stroke="#d2dbed"
            stroke-width="3"
            stroke-opacity="0.6"
          />
        </g>
        <g transform="translate(.330734 5.723071)">
          <g
            id="eBN9jzcwViv10_ts"
            transform="translate(174.338506,350.02528) rotate(-180) scale(0.666176,0.857603)"
          >
            <rect
              id="eBN9jzcwViv10"
              width="25.164873"
              height="0"
              rx="0"
              ry="0"
              transform="translate(-12.582499,-0.000009)"
              fill="#455eef"
              stroke-width="0"
            />
          </g>
          <g
            id="eBN9jzcwViv11_ts"
            transform="translate(224.338523,350.025258) rotate(-180) scale(0.666176,0.857603)"
          >
            <rect
              id="eBN9jzcwViv11"
              width="25.164873"
              height="0"
              rx="0"
              ry="0"
              transform="translate(-12.582499,0.000004)"
              fill="#455eef"
              stroke-width="0"
            />
          </g>
          <g
            id="eBN9jzcwViv12_ts"
            transform="translate(273.580329,350.025277) rotate(-180) scale(0.666176,0.857603)"
          >
            <rect
              id="eBN9jzcwViv12"
              width="25.164873"
              height="0"
              rx="0"
              ry="0"
              transform="translate(-12.582491,0.000062)"
              fill="#455eef"
              stroke-width="0"
            />
          </g>
          <g
            id="eBN9jzcwViv13_ts"
            transform="translate(325.449488,350.025228) rotate(-180) scale(0.666176,0.857603)"
          >
            <rect
              id="eBN9jzcwViv13"
              width="25.164873"
              height="0"
              rx="0"
              ry="0"
              transform="translate(-12.582492,-0.000031)"
              fill="#455eef"
              stroke-width="0"
            />
          </g>
        </g>
        <g
          id="eBN9jzcwViv14"
          transform="translate(0 4.100656)"
          opacity="0"
        >
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 308.926442)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 308.926442)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 298.025006)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 298.025006)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 298.025006)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 320.474725)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 320.474725)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 320.474725)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 331.376161)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 331.376161)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 308.926442)"
            fill="#3a4fcb"
            stroke-width="0"
          />
        </g>
        <g
          id="eBN9jzcwViv26"
          transform="translate(50.000009 50.648937)"
          opacity="0"
        >
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 232.204698)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 276.025006)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 276.025006)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 286.926442)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 232.204698)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 232.204698)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 243.106134)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 243.106134)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 243.106134)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 265.106134)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 254.204698)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 254.204698)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 254.204698)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 265.106134)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 265.106134)"
            fill="#3a4fcb"
            stroke-width="0"
          />
        </g>
        <g
          id="eBN9jzcwViv42"
          transform="translate(99.241804 0.000001)"
          opacity="0"
        >
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 232.204698)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 276.025006)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 308.926442)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 276.025006)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 276.025006)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 286.926442)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 286.926442)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 286.926442)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 308.926442)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 298.025006)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 298.025006)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 298.025006)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 320.474725)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 308.926442)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 232.204698)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 232.204698)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 243.106134)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 243.106134)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 243.106134)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 265.106134)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 254.204698)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 254.204698)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 254.204698)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 265.106134)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 265.106134)"
            fill="#3a4fcb"
            stroke-width="0"
          />
        </g>
        <g
          id="eBN9jzcwViv68"
          transform="translate(151.110964 28.82863)"
          opacity="0"
        >
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 232.204698)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 276.025006)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 276.025006)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 276.025006)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 286.926442)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 286.926442)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 286.926442)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 298.025006)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 298.025006)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 232.204698)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 232.204698)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 243.106134)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 243.106134)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 243.106134)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 265.106134)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 254.204698)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 163.487238 254.204698)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 254.204698)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 181.487238 265.106134)"
            fill="#3a4fcb"
            stroke-width="0"
          />
          <rect
            width="6.07122"
            height="8.582484"
            rx="0"
            ry="0"
            transform="matrix(.718828 0 0 0.795647 172.487238 265.106134)"
            fill="#3a4fcb"
            stroke-width="0"
          />
        </g>
      </g>
      <g
        id="eBN9jzcwViv89"
        transform="translate(12.022652 46.589623)"
        opacity="0"
      >
        <text
          dx="0"
          dy="0"
          font-family="&quot;eBN9jzcwViv1:::Montserrat&quot;"
          font-size="25"
          font-weight="300"
          transform="translate(155.696635 228.96899)"
          fill="#d2dbed"
          stroke-width="0"
        >
          <tspan
            y="0"
            font-weight="300"
            stroke-width="0"
          >
            <![CDATA[IS LOADING... ]]>
          </tspan>
        </text>
        <text
          dx="0"
          dy="0"
          font-family="&quot;eBN9jzcwViv1:::Montserrat&quot;"
          font-size="30"
          font-weight="800"
          transform="translate(159.003489 200.653525)"
          fill="#455eef"
          stroke-width="0"
          stroke-dasharray="5"
        >
          <tspan
            y="0"
            font-weight="800"
            stroke-width="0"
          >
            <![CDATA[CITY DIVE ]]>
          </tspan>
        </text>
      </g>
      <g
        id="eBN9jzcwViv94_ts"
        transform="translate(319.382454,309.388723) scale(0,0)"
      >
        <g transform="translate(-60.118374,-81.4289)">
          <g clip-path="url(#eBN9jzcwViv98)">
            <g transform="matrix(.133847 0 0 0.133847 40.905682 65.328143)">
              <path
                d="M281.447,111.614c-.845,1.262-2.034,2.291-2.487,3.8-.809.074-1.617.2-2.426.2q-46.048.037-92.085.012c-.907,0-1.813-.159-2.72-.245-.441.49-.858.527-1.25-.061-1.594937.395824-3.260411.412605-4.863.049-.4.551-.833.515-1.274.049-4.373.074-8.747.208-13.12.208q-76.882.018-153.764.073c-2.891,0-4.043-.992-5.01-3.528-6.983-18.3,1.544-42.7,18.253-51.88.58869-.840549,1.49628-1.402958,2.511-1.556.600621-.540862,1.353572-.883112,2.156-.98c1.887-1.825,4.716-1.8,6.738-3.369-.177993-.664664-.103909-1.371671.208-1.985-.404043-1.115122-.184657-2.360973.576-3.271l.147-1.029c-.00786-1.994608.594784-3.943865,1.727-5.586.025475-.842611.322176-1.654507.846-2.315.466-1.556.919-3.136,2.291-4.214l.294-.662c-.020941-.576026.337094-1.098058.882-1.286.428962-1.156126,1.17135-2.169985,2.144-2.928.008742-.573953.417032-1.063902.98-1.176c1.750705-2.523893,4.007564-4.655769,6.627-6.26.16745-.583931.703552-.984678,1.311-.98.392-.27.8-.551,1.2-.821.550931-.858893,1.450157-1.433652,2.461-1.573l.625-.257c3.61709-2.525731,7.840715-4.044276,12.238-4.4.429-.1.87-.208,1.3-.306.279593-.340871.78046-.395536,1.127-.123.747-.037,1.495-.086,2.242-.135c2.305963-.912754,4.873037-.912754,7.179,0l2.279.147c1.233335-.26527,2.521411-.003159,3.553.723.441.086.87.172,1.3.257c1.691-.257,3.222,1.2,4.949.453L90.58,16.5l.159-.037c.021647-.580869.432557-1.073961,1-1.2.221-.233.441-.466.662-.711.090351-.606008.559962-1.085302,1.164-1.188.206246-.588448.671608-1.049385,1.262-1.25.127551-.581524.608928-1.018774,1.2-1.09c1.147784-1.378824,2.59247-2.480285,4.226-3.222.187942-.544906.709974-.902941,1.286-.882.409554-.538084,1.019615-.887309,1.691-.968.632579-.811312,1.574909-1.321983,2.6-1.409.38-.135.747-.27,1.127-.4c1.629658-1.221683,3.568153-1.963901,5.597-2.143.564-.11,1.127-.221,1.678-.331.429758-.651487,1.28729-.864565,1.972-.49l1.556-.147c4.587012-1.369746,9.473657-1.373916,14.063-.012.539.074,1.066.147,1.6.208.625-.429,1.029-.086,1.384.417c1.651517.058732,3.264203.516804,4.7,1.335c1.139628-.139234,2.269924.322575,2.986,1.22c7.317378,2.912771,13.558592,8.01106,17.873,14.6c1.6,2.34,2.609,2.377,4.839.674c8.529845-6.604764,19.830684-8.424271,30.002542-4.8306s17.821674,12.108357,20.309458,22.6056c.674,2.781,1.409,3.222,4.153,2.144c11.711-4.594,22.92-3.283,33.455,3.565.968017.739039,2.053044,1.310622,3.21,1.691.125946.705468.510291,1.338675,1.078,1.776c3.885365,3.586044,6.916203,7.998513,8.869,12.912.634886,1.626281,1.865768,2.949425,3.442,3.7c17.763,9.506,22.308,32.806,11.723,48.572"
                transform="translate(0-.001)"
                fill="#678c22"
              />
            </g>
            <clipPath id="eBN9jzcwViv98">
              <rect
                width="287.086"
                height="115.768"
                rx="0"
                ry="0"
                fill="none"
              />
            </clipPath>
          </g>
        </g>
      </g>
      <g
        id="eBN9jzcwViv100_ts"
        transform="translate(194.586327,309.388723) scale(0,0)"
      >
        <g transform="translate(-60.118374,-81.4289)">
          <g clip-path="url(#eBN9jzcwViv104)">
            <g transform="matrix(.133847 0 0 0.133847 40.905682 65.328143)">
              <path
                d="M281.447,111.614c-.845,1.262-2.034,2.291-2.487,3.8-.809.074-1.617.2-2.426.2q-46.048.037-92.085.012c-.907,0-1.813-.159-2.72-.245-.441.49-.858.527-1.25-.061-1.594937.395824-3.260411.412605-4.863.049-.4.551-.833.515-1.274.049-4.373.074-8.747.208-13.12.208q-76.882.018-153.764.073c-2.891,0-4.043-.992-5.01-3.528-6.983-18.3,1.544-42.7,18.253-51.88.58869-.840549,1.49628-1.402958,2.511-1.556.600621-.540862,1.353572-.883112,2.156-.98c1.887-1.825,4.716-1.8,6.738-3.369-.177993-.664664-.103909-1.371671.208-1.985-.404043-1.115122-.184657-2.360973.576-3.271l.147-1.029c-.00786-1.994608.594784-3.943865,1.727-5.586.025475-.842611.322176-1.654507.846-2.315.466-1.556.919-3.136,2.291-4.214l.294-.662c-.020941-.576026.337094-1.098058.882-1.286.428962-1.156126,1.17135-2.169985,2.144-2.928.008742-.573953.417032-1.063902.98-1.176c1.750705-2.523893,4.007564-4.655769,6.627-6.26.16745-.583931.703552-.984678,1.311-.98.392-.27.8-.551,1.2-.821.550931-.858893,1.450157-1.433652,2.461-1.573l.625-.257c3.61709-2.525731,7.840715-4.044276,12.238-4.4.429-.1.87-.208,1.3-.306.279593-.340871.78046-.395536,1.127-.123.747-.037,1.495-.086,2.242-.135c2.305963-.912754,4.873037-.912754,7.179,0l2.279.147c1.233335-.26527,2.521411-.003159,3.553.723.441.086.87.172,1.3.257c1.691-.257,3.222,1.2,4.949.453L90.58,16.5l.159-.037c.021647-.580869.432557-1.073961,1-1.2.221-.233.441-.466.662-.711.090351-.606008.559962-1.085302,1.164-1.188.206246-.588448.671608-1.049385,1.262-1.25.127551-.581524.608928-1.018774,1.2-1.09c1.147784-1.378824,2.59247-2.480285,4.226-3.222.187942-.544906.709974-.902941,1.286-.882.409554-.538084,1.019615-.887309,1.691-.968.632579-.811312,1.574909-1.321983,2.6-1.409.38-.135.747-.27,1.127-.4c1.629658-1.221683,3.568153-1.963901,5.597-2.143.564-.11,1.127-.221,1.678-.331.429758-.651487,1.28729-.864565,1.972-.49l1.556-.147c4.587012-1.369746,9.473657-1.373916,14.063-.012.539.074,1.066.147,1.6.208.625-.429,1.029-.086,1.384.417c1.651517.058732,3.264203.516804,4.7,1.335c1.139628-.139234,2.269924.322575,2.986,1.22c7.317378,2.912771,13.558592,8.01106,17.873,14.6c1.6,2.34,2.609,2.377,4.839.674c8.529845-6.604764,19.830684-8.424271,30.002542-4.8306s17.821674,12.108357,20.309458,22.6056c.674,2.781,1.409,3.222,4.153,2.144c11.711-4.594,22.92-3.283,33.455,3.565.968017.739039,2.053044,1.310622,3.21,1.691.125946.705468.510291,1.338675,1.078,1.776c3.885365,3.586044,6.916203,7.998513,8.869,12.912.634886,1.626281,1.865768,2.949425,3.442,3.7c17.763,9.506,22.308,32.806,11.723,48.572"
                transform="translate(0-.001)"
                fill="#678c22"
              />
            </g>
            <clipPath id="eBN9jzcwViv104">
              <rect
                width="287.086"
                height="115.768"
                rx="0"
                ry="0"
                fill="none"
              />
            </clipPath>
          </g>
        </g>
      </g>
      <g
        id="eBN9jzcwViv106_ts"
        transform="translate(236.70978,308.67752) scale(0.102782,0)"
      >
        <g
          transform="translate(-46.724999,-259.658963)"
          clip-path="url(#eBN9jzcwViv119)"
        >
          <g>
            <path
              d="M34.225,259.659h25l-12.5-213.5Z"
              fill="#b2682b"
            />
            <path
              d="M47.106,0L0,166.061h7.629L0,192.953h7.267L0,218.569h93.452L86.3,192.953h7.149l-7.5-26.892h7.5Z"
              fill="#779b27"
            />
            <g>
              <g>
                <g
                  style="mix-blend-mode: multiply; isolation: isolate"
                  opacity="0.3"
                >
                  <g>
                    <g clip-path="url(#eBN9jzcwViv117)">
                      <g>
                        <path
                          d="M18.267,184.209h-7.267l7.628-26.892h-7.628L47.106,0L0,166.061h7.628L0,192.953h7.267L0,218.569h93.451L11,209.825Z"
                          fill="#a7ce5d"
                        />
                      </g>
                      <clipPath id="eBN9jzcwViv117">
                        <rect
                          width="93.451"
                          height="218.569"
                          rx="0"
                          ry="0"
                          fill="none"
                        />
                      </clipPath>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <clipPath id="eBN9jzcwViv119">
            <rect
              width="93.452"
              height="259.659"
              rx="0"
              ry="0"
              fill="none"
            />
          </clipPath>
        </g>
      </g>
      <g
        id="eBN9jzcwViv121_ts"
        transform="translate(352.338838,308.67752) scale(0.102782,0)"
      >
        <g
          transform="translate(-46.724999,-259.658963)"
          clip-path="url(#eBN9jzcwViv134)"
        >
          <g>
            <path
              d="M34.225,259.659h25l-12.5-213.5Z"
              fill="#b2682b"
            />
            <path
              d="M47.106,0L0,166.061h7.629L0,192.953h7.267L0,218.569h93.452L86.3,192.953h7.149l-7.5-26.892h7.5Z"
              fill="#779b27"
            />
            <g>
              <g>
                <g
                  style="mix-blend-mode: multiply; isolation: isolate"
                  opacity="0.3"
                >
                  <g>
                    <g clip-path="url(#eBN9jzcwViv132)">
                      <g>
                        <path
                          d="M18.267,184.209h-7.267l7.628-26.892h-7.628L47.106,0L0,166.061h7.628L0,192.953h7.267L0,218.569h93.451L11,209.825Z"
                          fill="#a7ce5d"
                        />
                      </g>
                      <clipPath id="eBN9jzcwViv132">
                        <rect
                          width="93.451"
                          height="218.569"
                          rx="0"
                          ry="0"
                          fill="none"
                        />
                      </clipPath>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <clipPath id="eBN9jzcwViv134">
            <rect
              width="93.452"
              height="259.659"
              rx="0"
              ry="0"
              fill="none"
            />
          </clipPath>
        </g>
      </g>
      <g
        id="eBN9jzcwViv136_ts"
        transform="translate(282.813442,308.67752) scale(0.102782,0)"
      >
        <g
          transform="translate(-46.724999,-259.658963)"
          clip-path="url(#eBN9jzcwViv149)"
        >
          <g>
            <path
              d="M34.225,259.659h25l-12.5-213.5Z"
              fill="#b2682b"
            />
            <path
              d="M47.106,0L0,166.061h7.629L0,192.953h7.267L0,218.569h93.452L86.3,192.953h7.149l-7.5-26.892h7.5Z"
              fill="#779b27"
            />
            <g>
              <g>
                <g
                  style="mix-blend-mode: multiply; isolation: isolate"
                  opacity="0.3"
                >
                  <g>
                    <g clip-path="url(#eBN9jzcwViv147)">
                      <g>
                        <path
                          d="M18.267,184.209h-7.267l7.628-26.892h-7.628L47.106,0L0,166.061h7.628L0,192.953h7.267L0,218.569h93.451L11,209.825Z"
                          fill="#a7ce5d"
                        />
                      </g>
                      <clipPath id="eBN9jzcwViv147">
                        <rect
                          width="93.451"
                          height="218.569"
                          rx="0"
                          ry="0"
                          fill="none"
                        />
                      </clipPath>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <clipPath id="eBN9jzcwViv149">
            <rect
              width="93.452"
              height="259.659"
              rx="0"
              ry="0"
              fill="none"
            />
          </clipPath>
        </g>
      </g>
      <g
        id="eBN9jzcwViv151_ts"
        transform="translate(149.606197,308.67752) scale(0.102782,0)"
      >
        <g
          transform="translate(-46.724999,-259.658963)"
          clip-path="url(#eBN9jzcwViv164)"
        >
          <g>
            <path
              d="M34.225,259.659h25l-12.5-213.5Z"
              fill="#b2682b"
            />
            <path
              d="M47.106,0L0,166.061h7.629L0,192.953h7.267L0,218.569h93.452L86.3,192.953h7.149l-7.5-26.892h7.5Z"
              fill="#779b27"
            />
            <g>
              <g>
                <g
                  style="mix-blend-mode: multiply; isolation: isolate"
                  opacity="0.3"
                >
                  <g>
                    <g clip-path="url(#eBN9jzcwViv162)">
                      <g>
                        <path
                          d="M18.267,184.209h-7.267l7.628-26.892h-7.628L47.106,0L0,166.061h7.628L0,192.953h7.267L0,218.569h93.451L11,209.825Z"
                          fill="#a7ce5d"
                        />
                      </g>
                      <clipPath id="eBN9jzcwViv162">
                        <rect
                          width="93.451"
                          height="218.569"
                          rx="0"
                          ry="0"
                          fill="none"
                        />
                      </clipPath>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <clipPath id="eBN9jzcwViv164">
            <rect
              width="93.452"
              height="259.659"
              rx="0"
              ry="0"
              fill="none"
            />
          </clipPath>
        </g>
      </g>
      <g
        id="eBN9jzcwViv166_ts"
        transform="translate(254.704712,309.388723) scale(0,0)"
      >
        <g transform="translate(-60.118374,-81.4289)">
          <g clip-path="url(#eBN9jzcwViv170)">
            <g transform="matrix(.133847 0 0 0.133847 40.905682 65.328143)">
              <path
                d="M281.447,111.614c-.845,1.262-2.034,2.291-2.487,3.8-.809.074-1.617.2-2.426.2q-46.048.037-92.085.012c-.907,0-1.813-.159-2.72-.245-.441.49-.858.527-1.25-.061-1.594937.395824-3.260411.412605-4.863.049-.4.551-.833.515-1.274.049-4.373.074-8.747.208-13.12.208q-76.882.018-153.764.073c-2.891,0-4.043-.992-5.01-3.528-6.983-18.3,1.544-42.7,18.253-51.88.58869-.840549,1.49628-1.402958,2.511-1.556.600621-.540862,1.353572-.883112,2.156-.98c1.887-1.825,4.716-1.8,6.738-3.369-.177993-.664664-.103909-1.371671.208-1.985-.404043-1.115122-.184657-2.360973.576-3.271l.147-1.029c-.00786-1.994608.594784-3.943865,1.727-5.586.025475-.842611.322176-1.654507.846-2.315.466-1.556.919-3.136,2.291-4.214l.294-.662c-.020941-.576026.337094-1.098058.882-1.286.428962-1.156126,1.17135-2.169985,2.144-2.928.008742-.573953.417032-1.063902.98-1.176c1.750705-2.523893,4.007564-4.655769,6.627-6.26.16745-.583931.703552-.984678,1.311-.98.392-.27.8-.551,1.2-.821.550931-.858893,1.450157-1.433652,2.461-1.573l.625-.257c3.61709-2.525731,7.840715-4.044276,12.238-4.4.429-.1.87-.208,1.3-.306.279593-.340871.78046-.395536,1.127-.123.747-.037,1.495-.086,2.242-.135c2.305963-.912754,4.873037-.912754,7.179,0l2.279.147c1.233335-.26527,2.521411-.003159,3.553.723.441.086.87.172,1.3.257c1.691-.257,3.222,1.2,4.949.453L90.58,16.5l.159-.037c.021647-.580869.432557-1.073961,1-1.2.221-.233.441-.466.662-.711.090351-.606008.559962-1.085302,1.164-1.188.206246-.588448.671608-1.049385,1.262-1.25.127551-.581524.608928-1.018774,1.2-1.09c1.147784-1.378824,2.59247-2.480285,4.226-3.222.187942-.544906.709974-.902941,1.286-.882.409554-.538084,1.019615-.887309,1.691-.968.632579-.811312,1.574909-1.321983,2.6-1.409.38-.135.747-.27,1.127-.4c1.629658-1.221683,3.568153-1.963901,5.597-2.143.564-.11,1.127-.221,1.678-.331.429758-.651487,1.28729-.864565,1.972-.49l1.556-.147c4.587012-1.369746,9.473657-1.373916,14.063-.012.539.074,1.066.147,1.6.208.625-.429,1.029-.086,1.384.417c1.651517.058732,3.264203.516804,4.7,1.335c1.139628-.139234,2.269924.322575,2.986,1.22c7.317378,2.912771,13.558592,8.01106,17.873,14.6c1.6,2.34,2.609,2.377,4.839.674c8.529845-6.604764,19.830684-8.424271,30.002542-4.8306s17.821674,12.108357,20.309458,22.6056c.674,2.781,1.409,3.222,4.153,2.144c11.711-4.594,22.92-3.283,33.455,3.565.968017.739039,2.053044,1.310622,3.21,1.691.125946.705468.510291,1.338675,1.078,1.776c3.885365,3.586044,6.916203,7.998513,8.869,12.912.634886,1.626281,1.865768,2.949425,3.442,3.7c17.763,9.506,22.308,32.806,11.723,48.572"
                transform="translate(0-.001)"
                fill="#678c22"
              />
            </g>
            <clipPath id="eBN9jzcwViv170">
              <rect
                width="287.086"
                height="115.768"
                rx="0"
                ry="0"
                fill="none"
              />
            </clipPath>
          </g>
        </g>
      </g>
      <g
        display="none"
        transform="matrix(.097792 0 0 0.097792 29.019236 252.123559)"
        opacity="0"
      >
        <g transform="translate(1120 492.687)">
          <g clip-path="url(#eBN9jzcwViv188)">
            <g>
              <path
                d="M219.33,89.97l-4.38-11.51-.8-2.11c.03-.01.07-.02.1-.03l-4.15-10.7-.09-.22L186.33,3.55c-.909753-2.135848-2.99856-3.529694-5.32-3.55h-18.64c-3.106374-.00221-5.626688,2.513627-5.63,5.62-.051289,1.508308.525384,2.970314,1.592535,4.037465s2.529157,1.643824,4.037465,1.592535h14.79l10.36,26.93h-81.67l-2.37-6.22c5.62-.89,10.65-1.77,11.54-2.07c2.37-.3,4.73-2.07,4.73-4.74v-2.66c.01416-.553218-.199378-1.087998-.59069-1.47931s-.926092-.60485-1.47931-.59069h-36.39c-.953979-.039505-1.88106.321465-2.557152.995658s-1.039669,1.600256-1.002848,2.554342-.59,12.43,4.74,11.54c1.78-.3,5.33-.89,9.77-1.78l3.55,9.18L81.28,63.76l-.2.29-3.44,5.01-7.19,10.45.18.09-.66.95-7.16,10.31-8.29,11.93c3.953808.171169,7.666613,1.948114,10.28,4.92l7.68-11.22l6.94-10.12.38-.55c4.810472,4.406953,8.587247,9.822834,11.06,15.86.04.09.08.18.11.26.13.29.24.58.35.88c1.136441,3.012932,1.937929,6.141757,2.39,9.33h-26.2c1.385881,3.645441,1.26718,7.692062-.33,11.25h63.82c1.658908.127871,3.252379-.672713,4.14-2.08l58-67.76l4.88,12.53.27.7l1.07,2.75h-.01l.15.4l3.96,10.28c.01-.01.03-.01.04-.02l.99,2.61l2.67,7.01l1.77,4.65l5.06,13.3.01.01c.024387-.040921.054718-.077992.09-.11.030558-.039097.063984-.075865.1-.11.08-.09.16-.18.24-.26s.16-.17.24-.25c.160157-.170146.330468-.330439.51-.48.17-.16.35-.32.53-.46.14-.12.29-.24.44-.35.17-.13.35-.26.53-.39s.36-.24.55-.36.37-.23.56-.34.39-.21.58-.31.37-.18.55-.27c.22-.1.44-.19.66-.28.35-.14.71-.27,1.07-.38.712872-.221944,1.44166-.389097,2.18-.5.46-.07.91-.11,1.38-.14ZM104.96,112.15c-1.408816-13.797607-8.089963-26.518653-18.65-35.51l1.01-1.46l13.49-19.55l22.2,56.52Zm28.11-5.32L110.28,49.12h71.91Zm-87.19,8.58l.49-.89c-.188181.282292-.352101.580024-.49.89"
                fill="#92c13a"
              />
              <path
                d="M81.35,112.15C78.541281,97.508827,64.725722,87.656941,49.96833,89.771706s-25.250175,15.450088-23.834074,30.290827s14.241481,25.951045,29.132508,25.236763s26.594108-13.001152,26.583236-27.909296c.001977-1.75867-.165463-3.51344-.5-5.24M64.19,127.72c-4.178654,4.185882-10.468174,5.440752-15.933251,3.178963s-9.028312-7.594341-9.026749-13.508963c.003837-2.915716.877803-5.763939,2.51-8.18.518188-.778768,1.114621-1.502529,1.78-2.16c2.735121-2.746654,6.453799-4.287403,10.33-4.28.23,0,.45.01.67.02c3.953808.171169,7.666613,1.948114,10.28,4.92c1.056836,1.180007,1.908614,2.528656,2.52,3.99.068571.146428.12867.296676.18.45h.01c2.065987,5.390169.765016,11.491413-3.32,15.57"
                fill="#92c13a"
              />
              <path
                d="M107.45,112.15c-1.404419-14.54768-8.67259-27.896128-20.13-36.97-3.00299-2.374001-6.247533-4.425303-9.68-6.12-21.073249-10.376366-46.440739-5.899136-62.688668,11.064226s-19.628588,42.500124-8.354355,63.10698s34.60287,31.530674,57.650213,26.995169s40.497345-23.484187,43.12281-46.826375c.229565-1.995064.34309-4.001774.34-6.01c0-1.77-.09-3.51-.26-5.24m-53.6,45.43c-20.12009-.009607-37.132595-14.896334-39.811884-34.837235s9.800391-38.790241,29.204372-44.110359s39.752005,4.528633,47.617512,23.047594c.04.09.08.18.11.26.13.29.24.58.35.88c1.175754,3.000386,1.978434,6.133858,2.39,9.33.48469,3.736724.451039,7.522482-.1,11.25-2.983328,19.654661-19.880213,34.180203-39.76,34.18"
                fill="#92c13a"
              />
              <path
                d="M81.35,112.15C78.541281,97.508827,64.725722,87.656941,49.96833,89.771706s-25.250175,15.450088-23.834074,30.290827s14.241481,25.951045,29.132508,25.236763s26.594108-13.001152,26.583236-27.909296c.001977-1.75867-.165463-3.51344-.5-5.24M64.19,127.72c-4.178654,4.185882-10.468174,5.440752-15.933251,3.178963s-9.028312-7.594341-9.026749-13.508963c.003837-2.915716.877803-5.763939,2.51-8.18.518188-.778768,1.114621-1.502529,1.78-2.16c2.735121-2.746654,6.453799-4.287403,10.33-4.28.23,0,.45.01.67.02c3.953808.171169,7.666613,1.948114,10.28,4.92c1.056836,1.180007,1.908614,2.528656,2.52,3.99.068571.146428.12867.296676.18.45h.01c2.065987,5.390169.765016,11.491413-3.32,15.57"
                fill="#92c13a"
              />
              <path
                d="M81.35,112.15C78.541281,97.508827,64.725722,87.656941,49.96833,89.771706s-25.250175,15.450088-23.834074,30.290827s14.241481,25.951045,29.132508,25.236763s26.594108-13.001152,26.583236-27.909296c.001977-1.75867-.165463-3.51344-.5-5.24M64.19,127.72c-4.178654,4.185882-10.468174,5.440752-15.933251,3.178963s-9.028312-7.594341-9.026749-13.508963c.003837-2.915716.877803-5.763939,2.51-8.18.518188-.778768,1.114621-1.502529,1.78-2.16c2.735121-2.746654,6.453799-4.287403,10.33-4.28.23,0,.45.01.67.02c3.953808.171169,7.666613,1.948114,10.28,4.92c1.056836,1.180007,1.908614,2.528656,2.52,3.99.068571.146428.12867.296676.18.45h.01c2.065987,5.390169.765016,11.491413-3.32,15.57"
                fill="#92c13a"
              />
              <path
                d="M46.37,114.52l-.49.89c.137899-.309976.301819-.607708.49-.89"
                fill="#92c13a"
              />
              <path
                d="M225,89.39c-1.904847-.000793-3.804765.193554-5.67.58-3.740921.763504-7.282421,2.295883-10.4,4.5-11.305479,7.935143-15.132321,22.930921-9.011714,35.313107s20.35855,18.448405,33.528506,14.285159s21.333999-17.311116,19.225261-30.961522-13.859728-23.721766-27.672053-23.716744m8.75,39.71c-.372457.280532-.759679.540906-1.16.78-.005523,0-.01.004477-.01.01-2.283709,1.390109-4.906479,2.123654-7.58,2.12-.501365.00052-1.002294-.029536-1.5-.09-.245414-.009634-.489595-.039738-.73-.09-.935656-.13509-1.854201-.369755-2.74-.7-.909352-.328959-1.783669-.747694-2.61-1.25-.2-.12-.4-.24-.59-.38-.18-.12-.36-.24-.53-.37-.027494-.026388-.057656-.049848-.09-.07-.173393-.124701-.340278-.25821-.5-.4-.365519-.291822-.712835-.605743-1.04-.94-.170148-.160155-.330441-.330467-.48-.51-.16-.16-.3-.33-.44-.5-.605672-.735117-1.141334-1.525218-1.6-2.36-.11-.21-.22-.42-.32-.63-.211276-.425731-.398243-.8631-.56-1.31-.592717-1.607124-.894101-3.307065-.89-5.02-.002827-1.235227.155167-2.465566.47-3.66.06-.24.13-.47.2-.7q.075-.27.18-.54c.05-.15.11-.3.17-.45.360633-.924747.816416-1.809501,1.36-2.64.09-.14.19-.28.29-.42s.2-.29.31-.43c.12-.16.24-.31.37-.46.081151-.111032.167931-.217838.26-.32.030783-.035789.064211-.069217.1-.1.030558-.039097.063984-.075865.1-.11.071938-.093775.15227-.180801.24-.26.08-.09.16-.17.24-.25.160157-.170146.330468-.330439.51-.48.17-.16.35-.32.53-.46.14-.12.29-.24.44-.35.17-.13.35-.26.53-.39s.36-.24.55-.36.37-.23.56-.34.39-.21.58-.31.37-.18.55-.27c.22-.1.44-.19.66-.28.35-.14.71-.27,1.07-.38.712872-.221944,1.44166-.389097,2.18-.5.46-.07.91-.11,1.38-.14.26-.01.52-.02.79-.02c6.297938-.00117,11.888643,4.031467,13.874778,10.008029s-.078845,12.55334-5.124778,16.321971"
                fill="#92c13a"
              />
              <path
                d="M225,63.53c-29.741993.002761-53.85092,24.114673-53.85,53.856667s24.11134,53.852412,53.853333,53.853333s53.853906-24.108007,53.856667-53.85c.002122-14.285211-5.671716-27.985946-15.772885-38.087115s-23.801904-15.775007-38.087115-15.772885m0,94.05c-18.103605-.003238-33.971666-12.106977-38.76072-29.565657s2.68252-35.964664,18.25072-45.204343c3.259761-1.944624,6.782587-3.409661,10.46-4.35c15.085947-3.900744,31.067274,1.267887,41.011925,13.263949s12.061157,28.658533,5.43146,42.759906-20.811294,23.101366-36.393385,23.096145"
                fill="#92c13a"
              />
              <path
                d="M225,89.39c-1.904847-.000793-3.804765.193554-5.67.58-3.740921.763504-7.282421,2.295883-10.4,4.5-11.305479,7.935143-15.132321,22.930921-9.011714,35.313107s20.35855,18.448405,33.528506,14.285159s21.333999-17.311116,19.225261-30.961522-13.859728-23.721766-27.672053-23.716744m8.75,39.71c-.372457.280532-.759679.540906-1.16.78-.005523,0-.01.004477-.01.01-2.283709,1.390109-4.906479,2.123654-7.58,2.12-.501365.00052-1.002294-.029536-1.5-.09-.245414-.009634-.489595-.039738-.73-.09-.935656-.13509-1.854201-.369755-2.74-.7-.909352-.328959-1.783669-.747694-2.61-1.25-.2-.12-.4-.24-.59-.38-.18-.12-.36-.24-.53-.37-.027494-.026388-.057656-.049848-.09-.07-.173393-.124701-.340278-.25821-.5-.4-.365519-.291822-.712835-.605743-1.04-.94-.170148-.160155-.330441-.330467-.48-.51-.16-.16-.3-.33-.44-.5-.605672-.735117-1.141334-1.525218-1.6-2.36-.11-.21-.22-.42-.32-.63-.211276-.425731-.398243-.8631-.56-1.31-.592717-1.607124-.894101-3.307065-.89-5.02-.002827-1.235227.155167-2.465566.47-3.66.06-.24.13-.47.2-.7q.075-.27.18-.54c.05-.15.11-.3.17-.45.360633-.924747.816416-1.809501,1.36-2.64.09-.14.19-.28.29-.42s.2-.29.31-.43c.12-.16.24-.31.37-.46.081151-.111032.167931-.217838.26-.32.030783-.035789.064211-.069217.1-.1.030558-.039097.063984-.075865.1-.11.071938-.093775.15227-.180801.24-.26.08-.09.16-.17.24-.25.160157-.170146.330468-.330439.51-.48.17-.16.35-.32.53-.46.14-.12.29-.24.44-.35.17-.13.35-.26.53-.39s.36-.24.55-.36.37-.23.56-.34.39-.21.58-.31.37-.18.55-.27c.22-.1.44-.19.66-.28.35-.14.71-.27,1.07-.38.712872-.221944,1.44166-.389097,2.18-.5.46-.07.91-.11,1.38-.14.26-.01.52-.02.79-.02c6.297938-.00117,11.888643,4.031467,13.874778,10.008029s-.078845,12.55334-5.124778,16.321971"
                fill="#92c13a"
              />
              <path
                d="M225,89.39c-1.904847-.000793-3.804765.193554-5.67.58-3.740921.763504-7.282421,2.295883-10.4,4.5-11.305479,7.935143-15.132321,22.930921-9.011714,35.313107s20.35855,18.448405,33.528506,14.285159s21.333999-17.311116,19.225261-30.961522-13.859728-23.721766-27.672053-23.716744m8.75,39.71c-.372457.280532-.759679.540906-1.16.78-.005523,0-.01.004477-.01.01-2.283709,1.390109-4.906479,2.123654-7.58,2.12-.501365.00052-1.002294-.029536-1.5-.09-.245414-.009634-.489595-.039738-.73-.09-.935656-.13509-1.854201-.369755-2.74-.7-.909352-.328959-1.783669-.747694-2.61-1.25-.2-.12-.4-.24-.59-.38-.18-.12-.36-.24-.53-.37-.027494-.026388-.057656-.049848-.09-.07-.173393-.124701-.340278-.25821-.5-.4-.365519-.291822-.712835-.605743-1.04-.94-.170148-.160155-.330441-.330467-.48-.51-.16-.16-.3-.33-.44-.5-.605672-.735117-1.141334-1.525218-1.6-2.36-.11-.21-.22-.42-.32-.63-.211276-.425731-.398243-.8631-.56-1.31-.592717-1.607124-.894101-3.307065-.89-5.02-.002827-1.235227.155167-2.465566.47-3.66.06-.24.13-.47.2-.7q.075-.27.18-.54c.05-.15.11-.3.17-.45.360633-.924747.816416-1.809501,1.36-2.64.09-.14.19-.28.29-.42s.2-.29.31-.43c.12-.16.24-.31.37-.46.081151-.111032.167931-.217838.26-.32.030783-.035789.064211-.069217.1-.1.030558-.039097.063984-.075865.1-.11.071938-.093775.15227-.180801.24-.26.08-.09.16-.17.24-.25.160157-.170146.330468-.330439.51-.48.17-.16.35-.32.53-.46.14-.12.29-.24.44-.35.17-.13.35-.26.53-.39s.36-.24.55-.36.37-.23.56-.34.39-.21.58-.31.37-.18.55-.27c.22-.1.44-.19.66-.28.35-.14.71-.27,1.07-.38.712872-.221944,1.44166-.389097,2.18-.5.46-.07.91-.11,1.38-.14.26-.01.52-.02.79-.02c6.297938-.00117,11.888643,4.031467,13.874778,10.008029s-.078845,12.55334-5.124778,16.321971"
                fill="#92c13a"
              />
              <path
                d="M45.88,115.41c.137899-.309976.301819-.607708.49-.89Z"
                fill="#92c13a"
              />
              <path
                d="M67.51,112.15h-.01c-.05133-.153324-.111429-.303572-.18-.45.07.15.13.3.19.45"
                fill="#92c13a"
              />
            </g>
            <clipPath id="eBN9jzcwViv188">
              <rect
                width="278.86"
                height="171.24"
                rx="0"
                ry="0"
                fill="#92c13a"
              />
            </clipPath>
          </g>
        </g>
      </g>
      <g
        display="none"
        transform="matrix(.086564 0 0 0.086564 73.881643 259.578421)"
        opacity="0"
      >
        <g transform="translate(746 436.471)">
          <g clip-path="url(#eBN9jzcwViv201)">
            <g>
              <path
                d="M292.8,131.525v-.007c-.177-3.876-8.615-31.073-37.647-36.3-5.1-17-11.494-31.609-18.777-42.948h5.936c4.108354.067141,7.724646-2.697017,8.738-6.679.254-1.109,5.951-27.654-10.755-42.2-1.386442-1.17755-3.084763-1.927535-4.889-2.159-2.166941-.297534-4.3625-.324071-6.536-.079-8.23.7-24.136,4.651-38.055,23.5-.510401.699219-.905412,1.475737-1.17,2.3C174.268,35.7,170.434,53.607,170.28,54.44c-.220953,1.29506.093601,2.624322.871541,3.683005s1.952531,1.755975,3.254459,1.931995c.309299.061875.623607.095348.939.1c2.416715.043684,4.53086-1.618296,5.059-3.977.023-.153,2.548-12.252,11.817-19.265c4.766,9.013,16.953,35.587,9.354,59.64-4.358,13.787-14.766,24.843-30.956,32.885h-38.54c-1.779-6.738-3.988-18.982-.262-28.067c8.669-2.224,15.1-9.614,15.1-18.467c0-10.607-9.177-19.206-20.425-19.206l-78.766-.007c-11.263,0-20.409,8.621-20.409,19.206.036065,4.801922,1.944824,9.400164,5.32,12.816C17.214,108.356,1,128.519,1,157.737c.157718,4.78082,4.149491,8.53526,8.931,8.4h4.488l1.3-9.679h-4.426c.509-26.393,16.268-44.368,30.41-55.286c1.948094.604592,3.973395.924234,6.013.949h73.115c-3.234,12.686.308,27.125,2.363,33.559.713555,2.102722,2.70696,3.500978,4.927,3.456h43.76c.812653.003978,1.615567-.176917,2.348-.529c19.409-9.332,31.942-22.539,37.224-39.275c9.777-30.965-8.608-64.487-11.7-69.79c15.013-19.815,31.426-18.982,33.836-18.757c10.586,9.571,8.33,27.386,7.56,31.791h-14.42c-1.906079-.021634-3.671216,1.001378-4.6,2.666-.874481,1.633726-.6833,3.632649.485,5.071c6.443,8.122,15.767,23.474,23.481,50.461.60299,1.951575,2.323052,3.347126,4.357,3.535c22.943,2.594,30.379,22.394,31.8,26.763l-6.544,2.333l5.2,8.505l6.121-2.159c3.547635-1.14048,5.905829-4.498885,5.774-8.223M126.474,92.4h-78.735c-5.581,0-10.116-4.274-10.116-9.513s4.527-9.519,10.116-9.519h78.735c5.589,0,10.131,4.26,10.131,9.519s-4.542,9.513-10.131,9.513"
                fill="#312683"
                stroke="#312683"
              />
              <path
                d="M292.8,131.525v-.007c-.177-3.876-8.615-31.073-37.647-36.3-5.1-17-11.494-31.609-18.777-42.948h5.936c4.108354.067141,7.724646-2.697017,8.738-6.679.254-1.109,5.951-27.654-10.755-42.2-1.386442-1.17755-3.084763-1.927535-4.889-2.159-2.166941-.297534-4.3625-.324071-6.536-.079-8.23.7-24.136,4.651-38.055,23.5-.510401.699219-.905412,1.475737-1.17,2.3C174.268,35.7,170.434,53.607,170.28,54.44c-.220953,1.29506.093601,2.624322.871541,3.683005s1.952531,1.755975,3.254459,1.931995c.309299.061875.623607.095348.939.1c2.416715.043684,4.53086-1.618296,5.059-3.977.023-.153,2.548-12.252,11.817-19.265c4.766,9.013,16.953,35.587,9.354,59.64-4.358,13.787-14.766,24.843-30.956,32.885h-38.54c-1.779-6.738-3.988-18.982-.262-28.067c8.669-2.224,15.1-9.614,15.1-18.467c0-10.607-9.177-19.206-20.425-19.206l-78.766-.007c-11.263,0-20.409,8.621-20.409,19.206.036065,4.801922,1.944824,9.400164,5.32,12.816C17.214,108.356,1,128.519,1,157.737c.157718,4.78082,4.149491,8.53526,8.931,8.4h4.488l1.3-9.679h-4.426c.509-26.393,16.268-44.368,30.41-55.286c1.948094.604592,3.973395.924234,6.013.949h73.115c-3.234,12.686.308,27.125,2.363,33.559.713555,2.102722,2.70696,3.500978,4.927,3.456h43.76c.812653.003978,1.615567-.176917,2.348-.529c19.409-9.332,31.942-22.539,37.224-39.275c9.777-30.965-8.608-64.487-11.7-69.79c15.013-19.815,31.426-18.982,33.836-18.757c10.586,9.571,8.33,27.386,7.56,31.791h-14.42c-1.906079-.021634-3.671216,1.001378-4.6,2.666-.874481,1.633726-.6833,3.632649.485,5.071c6.443,8.122,15.767,23.474,23.481,50.461.60299,1.951575,2.323052,3.347126,4.357,3.535c22.943,2.594,30.379,22.394,31.8,26.763l-6.544,2.333l5.2,8.505l6.121-2.159c3.547547-1.141865,5.904595-4.501608,5.771-8.226ZM126.474,92.4h-78.735c-5.581,0-10.116-4.274-10.116-9.513s4.527-9.519,10.116-9.519h78.735c5.589,0,10.131,4.26,10.131,9.519s-4.542,9.513-10.131,9.513Z"
                fill="#312683"
                stroke="#312683"
                stroke-width="2"
                stroke-miterlimit="10"
              />
              <path
                d="M67.8,119.746c-29.741993.002761-53.85092,24.114673-53.85,53.856667s24.11134,53.852412,53.853333,53.853333s53.853906-24.108007,53.856667-53.85c.001857-14.285129-5.672066-27.98571-15.773178-38.086822s-23.801693-15.775035-38.086822-15.773178m0,94.05c-16.260292-.000001-30.919303-9.795498-37.140913-24.818437s-2.780435-32.314459,8.718758-43.810791s28.791569-14.933205,43.812959-8.707858s24.813241,20.886794,24.809196,37.147086c.002389,10.661883-4.232381,20.887682-11.772034,28.426209s-17.766083,11.771771-28.427966,11.767791"
                fill="#312683"
                stroke="#312683"
              />
              <path
                d="M67.8,145.606c-15.463973,0-28,12.536027-28,28s12.536027,28,28,28s28-12.536027,28-28-12.536027-28-28-28m0,42.62c-8.074403,0-14.62-6.545597-14.62-14.62s6.545597-14.62,14.62-14.62s14.62,6.545597,14.62,14.62c-.003311,8.073031-6.546969,14.616689-14.62,14.62"
                fill="#312683"
                stroke="#312683"
              />
              <path
                d="M238.957,119.746c-29.741993.002761-53.85092,24.114673-53.85,53.856667s24.11134,53.852412,53.853333,53.853333s53.853906-24.108007,53.856667-53.85c.001857-14.285129-5.672066-27.98571-15.773178-38.086822s-23.801693-15.775035-38.086822-15.773178m0,94.05c-16.260292-.000001-30.919303-9.795498-37.140913-24.818437s-2.780435-32.314459,8.718758-43.810791s28.791569-14.933205,43.812959-8.707858s24.813241,20.886794,24.809196,37.147086c.001327,10.66119-4.233911,20.885961-11.773449,28.423623s-17.765361,11.770357-28.426551,11.766377"
                fill="#312683"
                stroke="#312683"
              />
              <path
                d="M238.957,145.606c-15.463973,0-28,12.536027-28,28s12.536027,28,28,28s28-12.536027,28-28-12.536027-28-28-28m0,42.62c-8.074403,0-14.62-6.545597-14.62-14.62s6.545597-14.62,14.62-14.62s14.62,6.545597,14.62,14.62c-.003311,8.073031-6.546969,14.616689-14.62,14.62"
                fill="#312683"
                stroke="#312683"
              />
              <rect
                width="71.369"
                height="10.196"
                rx="0"
                ry="0"
                transform="translate(117.889 157.323)"
                fill="#312683"
                stroke="#312683"
              />
            </g>
            <clipPath id="eBN9jzcwViv201">
              <rect
                width="293.817"
                height="227.456"
                rx="0"
                ry="0"
                fill="#312683"
                stroke="#312683"
              />
            </clipPath>
          </g>
        </g>
        <path
          d="M783.875,531.985L764.53,558.841L753,590.255l11.533,7.008L780.779,577.9l27.715-19.055l15.41,4.716l30.606,21.5l5.718,16.665h75.245L951.712,577.9L980.2,563.557l25.374,4.885l9.913,4.289l15.189-4.289-4.121-19.235-31.481-13.99-21.135-51.707h17.7c0,0,2.859-21.85,0-31.929s-11.435-8.389-11.435-8.389l-25.666,4.626-12.194,15.642l9.367,25.879l2.826,32.413-12.194,32.226-21.208,16.7h-47.235v-35.461Z"
          fill="#312683"
        />
      </g>
      <g
        display="none"
        transform="matrix(.126386 0 0 0.126386-48.002173 233.617706)"
        opacity="0"
      >
        <g transform="translate(1476.01 477.961)">
          <g clip-path="url(#eBN9jzcwViv214)">
            <g>
              <path
                d="M58.253,140.8h-4.739v.074h4.745c.001247-.024823-.000771-.049702-.006-.074"
                fill="#1ec7d3"
                stroke="#1ec7d3"
                stroke-width="4"
              />
              <path
                d="M150.511,162.279h-102.074c-1.179158,2.705947-2.708567,5.245324-4.549,7.553h111.172c-1.840433-2.307676-3.369842-4.847053-4.549-7.553m8.031-136.431c1.011016-.692241,1.944119-1.491899,2.783-2.385c2.826946-3.282512,4.000877-7.675916,3.188-11.931C163.318,4.776,156.948,0,149.793,0h-9.546v7.553h9.153c3.182,0,6.364,2.385,6.762,5.175.420238,1.94117-.015118,3.969308-1.195,5.567-1.256697,1.557703-3.168318,2.439734-5.169,2.385h-9.546v7.964h10.742l17.1,72.786c-18.914,2.758-33.53,21.507-35.743,39.256h-66.1c-2.06-21.832-23.9-40.458-48.514-40.458-2.197541,0-3.979,1.781459-3.979,3.979s1.781459,3.979,3.979,3.979c19.735,0,37.907,15.272,40.513,32.616h6.192v.074h-6.183c.018.11.037.214.049.325h-8.108c.655826,2.601831.987342,5.274787.987,7.958h96.58c-.000349-2.681237.331171-5.352208.987-7.952h-8.5c1.987-14.322,14.316-30.232,29.435-32.224l4.479,18.994c2.568489-.791132,5.225009-1.261372,7.909-1.4Z"
                fill="#1ec7d3"
                stroke="#1ec7d3"
                stroke-width="4"
              />
              <path
                d="M26.923,125.116c-14.869486.001657-26.922552,12.056514-26.922,26.926s12.054514,26.923448,26.924,26.924s26.924343-12.052514,26.926-26.922c.001061-7.142075-2.835647-13.991934-7.885857-19.042143s-11.900068-7.886918-19.042143-7.885857m0,47.021c-8.130328,0-15.45996-4.897966-18.570647-12.409681s-1.389734-16.157632,4.360277-21.90564s14.396528-7.465952,21.907159-4.352648s12.406042,10.444641,12.403211,18.574969c.000531,5.330371-2.117194,10.442474-5.886992,14.210958s-8.882638,5.88443-14.213008,5.882042"
                fill="#1ec7d3"
                stroke="#1ec7d3"
                stroke-width="4"
              />
              <path
                d="M26.923,138.045c-7.731986,0-14,6.268014-14,14s6.268014,14,14,14s14-6.268014,14-14-6.268014-14-14-14m0,21.308c-2.956801.000404-5.622662-1.780472-6.754368-4.512122s-.506357-5.876054,1.584417-7.966829s5.235178-2.716123,7.966829-1.584417s4.512526,3.797567,4.512122,6.754368c-.001656,4.035963-3.273037,7.307344-7.309,7.309"
                fill="#1ec7d3"
              />
              <path
                d="M173.056,125.116c-14.869486.001657-26.922552,12.056514-26.922,26.926s12.054514,26.923448,26.924,26.924s26.924343-12.052514,26.926-26.922c.001061-7.142075-2.835647-13.991934-7.885857-19.042143s-11.900068-7.886918-19.042143-7.885857m0,47.021c-8.130328,0-15.45996-4.897966-18.570647-12.409681s-1.389734-16.157632,4.360277-21.90564s14.396528-7.465952,21.907159-4.352648s12.406042,10.444641,12.403211,18.574969c.000531,5.330371-2.117194,10.442474-5.886992,14.210958s-8.882638,5.88443-14.213008,5.882042"
                fill="#1ec7d3"
                stroke="#1ec7d3"
                stroke-width="4"
              />
              <path
                d="M173.056,138.045c-7.731986,0-14,6.268014-14,14s6.268014,14,14,14s14-6.268014,14-14-6.268014-14-14-14m0,21.308c-2.956801.000404-5.622662-1.780472-6.754368-4.512122s-.506357-5.876054,1.584417-7.966829s5.235178-2.716123,7.966829-1.584417s4.512526,3.797567,4.512122,6.754368c-.001656,4.035963-3.273037,7.307344-7.309,7.309"
                fill="#1ec7d3"
              />
            </g>
            <clipPath id="eBN9jzcwViv214">
              <rect
                width="215.983"
                height="192.966"
                rx="0"
                ry="0"
                transform="translate(-8-7)"
                fill="#089da7"
                stroke="#089da7"
                stroke-width="4"
              />
            </clipPath>
          </g>
        </g>
        <rect
          width="97"
          height="21"
          rx="0"
          ry="0"
          transform="translate(1529 620)"
          fill="#1ec7d3"
        />
      </g>
      <g
        display="none"
        transform="matrix(.085372 0 0 0.085372 118.508785 259.994794)"
        opacity="0"
      >
        <g transform="translate(203.06 415.536)">
          <g clip-path="url(#eBN9jzcwViv225)">
            <g>
              <path
                d="M105.04,164.927c-16.118427-.008282-29.191709,13.05157-29.199992,29.169997s13.051567,29.19171,29.169995,29.199995s29.191711-13.051565,29.199997-29.169992c-.011553-16.110218-13.059802-29.171887-29.17-29.2m0,42.73c-5.473077.006067-10.410333-3.286968-12.507592-8.342274s-.941071-10.876285,2.928981-14.746337s9.691032-5.02624,14.746337-2.928981s8.348341,7.034515,8.342274,12.507592c-.014855,7.455205-6.054795,13.495145-13.51,13.51"
                fill="#d60d52"
              />
              <path
                d="M378.78,164.927c-16.118427-.008282-29.191709,13.05157-29.199992,29.169997s13.051567,29.19171,29.169995,29.199995s29.191711-13.051565,29.199997-29.169992c-.011553-16.110218-13.059802-29.171887-29.17-29.2m0,42.73c-5.473077.006067-10.410333-3.286968-12.507592-8.342274s-.941071-10.876285,2.928981-14.746337s9.691032-5.02624,14.746337-2.928981s8.348341,7.034515,8.342274,12.507592c-.004413,7.459538-6.050462,13.505587-13.51,13.51"
                fill="#d60d52"
              />
              <path
                d="M481.85,158.167c-3.92-28.29-27.59-59.23-46.49-64.98-21.27-6.48-69.81-8.86-85.19-9.47-23.15-44.95-53.84-65.44-75.19-77C249.25,-7.233,74.24,1.6,50.82,23.5C14.37,57.57,11.22,134.51,11.13,158.8C4.557851,160.840827,0.058367,166.895524,0,173.777v12.19c-.001661,8.823913,7.146092,15.980617,15.97,15.99h35.07c3.768245,26.932279,26.805381,46.97056,54,46.97056s50.231755-20.038281,54-46.97056h165.74c3.768245,26.932279,26.805381,46.97056,54,46.97056s50.231755-20.038281,54-46.97056h47.19c8.819566-.019832,15.961206-7.170416,15.97-15.99v-12.19c-.078113-8.015914-6.123942-14.713954-14.09-15.61M51.04,186.237l-35.38-.27.31-12.51h38.4c-1.607925,4.11448-2.725625,8.404031-3.33,12.78m54,47.04c-15.841469.00809-30.127396-9.528889-36.194336-24.162564s-2.719682-31.481153,8.480499-42.684195s28.046804-14.554604,42.682028-8.491403s24.175852,20.346692,24.171809,36.188162c-.014334,21.612104-17.5279,39.130145-39.14,39.15m219.74-46.97h-165.74c-.565504-4.399861-1.673947-8.71271-3.3-12.84h172.34c-1.61681,4.13028-2.724956,8.441976-3.3,12.84m54,46.97c-15.841469.00809-30.127396-9.528889-36.194336-24.162564s-2.719682-31.481153,8.480499-42.684195s28.046804-14.554604,42.682028-8.491403s24.175852,20.346692,24.171809,36.188162c-.014334,21.612104-17.5279,39.130145-39.14,39.15m.02-93.99c-15.604929.047387-30.439619,6.787448-40.74,18.51l-192.28-.01c-10.270326-11.75864-25.122203-18.503731-40.734545-18.499898s-30.460904,6.756216-40.725455,18.519898h-37.5c.25-23.52,3.59-93.78,34.68-122.87C80.52,17.2,247.2,9.457,267.51,20.467c21.81,11.8,49.57,30.95,70.74,74.34c1.273324,2.6057,3.890757,4.286408,6.79,4.36.62.04,62.85,2.02,85.79,8.99c12.1,3.67,31.18,27.43,35.32,49.64h-46.61c-10.304076-11.717569-25.136393-18.456553-40.74-18.51m101.17,47.02h-47.19c-.569276-4.379687-1.677678-8.672226-3.3-12.78l50.79.25Z"
                fill="#d60d52"
              />
              <path
                d="M314,89.987c-18.07-32.3-40.43-47.59-56.43-56.66-4.71-2.09-19.93-4.28-48.61-4.28-53.88,0-104.37,7.38-118.28,17.8-9.54,9.4-16.79,24.13-22.14,45.05-.601656,2.336537-.08638,4.81999,1.39518,6.724295s3.762078,3.014387,6.17482,3.005705h231.06c2.781595.014541,5.360435-1.453344,6.768166-3.852464s1.431291-5.366365.061834-7.787536m-227.48-4c4.09-12.73,9.05-22.03,14.31-27.29c5.29-3.94,32.31-10.2,72.25-12.8l12.51,40.09Zm115.49-.01l-12.78-40.91c6.36-.22,12.91-.36,19.73-.36c28.09-.02,40.35,2.22,41.6,2.58h.01c12.6,7.19,28.26,17.94,42.54,38.69Z"
                fill="#d60d52"
              />
            </g>
            <clipPath id="eBN9jzcwViv225">
              <rect
                width="495.94"
                height="248.927"
                rx="0"
                ry="0"
                fill="#d60d52"
              />
            </clipPath>
          </g>
        </g>
        <path
          d="M390.479,452.8l-68.906,8.058L291.361,472.4l-10.837,37.575h115.954l30.41,70.855h-80.646L312.27,561.544l-39.329,12.931-18,6.353h-36.688l13.394-78.865l23.293-57.846l31.006-10.746L405.02,423.057l58.339,5.339v32.462Z"
          fill="#d60d52"
        />
        <path
          d="M451.03,453.9l47.855,36.467l3.141,17.214h-113.918l29.3,70.8l123.905,2.545l28.444-15.12l30.968,4.379l24.025,13.256l51.9-2.514v-21.568l-36.9-45.642-91.479-6.135L509.338,453.9l-48.853-30.984Z"
          fill="#d60d52"
        />
      </g>
      <g
        id="eBN9jzcwViv229_to"
        transform="translate(157.014118,301.09568)"
      >
        <g
          id="eBN9jzcwViv229"
          transform="scale(0.168306,0.168306) translate(-189.254999,-94.29545)"
          opacity="0"
          clip-path="url(#eBN9jzcwViv272)"
        >
          <g>
            <g>
              <g>
                <path
                  d="M378.507,131.075v9.2c-.021091,6.621622-5.363608,11.994897-11.985,12.054h-35.857c-.03.227-.068.454-.106.681-3.224727,20.025695-20.508828,34.749205-40.7925,34.749205s-37.567773-14.72351-40.7925-34.749205c-.038-.227-.075-.454-.106-.681h-125.525c-.03.227-.068.454-.106.681-3.226238,20.026358-20.511434,34.749781-40.796,34.749781s-37.569762-14.723423-40.796-34.749781c-.038-.227-.076-.454-.106-.681h-26.561c-6.667377.007186-12.079411-5.389629-12.091-12.057v-9.2c-.000854-.541334.036908-1.08204.113-1.618.686769-4.517225,3.875281-8.254464,8.228-9.644.03-.008.06-.023.091-.031c0-.469.007-.962.015-1.484.128048-13.108961,1.227056-26.190426,3.288-39.137.1-.6.2-1.2.3-1.811c1.216043-7.208441,2.873155-14.335494,4.962-21.341.508-1.705,1.061-3.394,1.636-5.069.001708-.018437.006793-.036402.015-.053.311-.886.629-1.765.947-2.636.002136-.017194.008303-.033641.018-.048q.488-1.317,1.007-2.621c0-.007.008-.015.008-.03q.5-1.239,1.023-2.455c.386-.916.787-1.825,1.2-2.719.076-.167.152-.326.228-.493.227-.47.447-.939.674-1.409.273-.568.553-1.129.841-1.69s.576-1.113.871-1.666.6-1.1.909-1.644c.606-1.083,1.243-2.152,1.9-3.19q.489-.783,1-1.545c.333-.508.682-1.015,1.03-1.515c2.366561-3.411066,5.081135-6.567011,8.1-9.417.189-.174.386-.348.6-.515.265-.22.561-.44.871-.652.25-.174.508-.348.781-.515s.545-.333.841-.508h.007c3.093815-1.661957,6.354585-2.992343,9.728-3.969C62.032,9.194,72.63,7.088,84.623,5.368c.007,0,.015-.007.023,0c1.431-.2,2.886-.409,4.356-.606q3.33-.443,6.773-.841c5.272-.621,10.719-1.166,16.25-1.644c6.583-.56,13.28-1.03,19.932-1.394q3.874-.2,7.72-.371c9.273-.379,18.334-.553,26.758-.5l2.03.023q4.693.057,9.076.2l1.859.073c.016962.007056.036038.007056.053,0c.614.03,1.22.053,1.826.083.947.045,1.879.1,2.795.144.591.03,1.167.068,1.735.106h.046c.575.03,1.144.068,1.7.114.014189.006975.030811.006975.045,0c.561.038,1.114.083,1.652.128.015,0,.03.008.045,0c.97.076,1.917.159,2.841.243.561.053,1.106.106,1.644.159.811.083,1.606.174,2.371.265c6.932.826,12.16,1.993,15,3.523c16.167,8.72,39.41,24.174,56.948,58.077c11.645.462,48.41,2.257,64.517,7.144c6.712,2.038,14.212,8.235,20.591,16.447c4.577215,5.876496,8.293889,12.37512,11.038,19.3c1.606818,4.007124,2.767805,8.178897,3.462,12.44.046.273.084.545.122.818c1.024525.129641,2.02933.384201,2.992.758c4.598112,1.72208,7.654861,6.105065,7.682,11.015"
                  fill="#ef3061"
                />
                <path
                  d="M100.206,109.658c-.035597-.018927-.072334-.035626-.11-.05-11.155501-5.422394-24.179204-5.440815-35.35-.05-4.12413,1.984732-7.894304,4.633313-11.16,7.84h57.58c-3.217637-3.14744-6.917634-5.760394-10.96-7.74m272.71,11.99c-1.544008-.962325-3.276167-1.582902-5.08-1.82-.06-.45-.14-.91-.22-1.37-.693099-4.040282-1.802338-7.998017-3.31-11.81-2.822543-7.166948-6.669216-13.886837-11.42-19.95-6.32-8.03-13.68-14.09-20.27-16.09-16.12-4.91-52.89-6.72-64.54-7.18-17.54-34.05-40.79-49.58-56.97-58.33-2.65-1.43-7.4-2.56-13.67-3.39-.42-.06-.85-.11-1.28-.16-.77-.09-1.56-.18-2.37-.26-.54-.06-1.09-.11-1.65-.16-.92-.09-1.87-.17-2.84-.24h-.04c-.54-.05-1.09-.1-1.65-.13h-.05c-.55-.05-1.12-.09-1.7-.12h-.04c-.57-.04-1.15-.07-1.74-.1-.91-.05-1.85-.1-2.79-.15-.61-.03-1.21-.05-1.83-.08-.015133.010111-.034867.010111-.05,0-.62-.02-1.24-.05-1.87-.07-2.91-.1-5.94-.17-9.07-.2l-2.03-.03c-8.43-.05-17.49.13-26.76.5-2.56.12-5.14.24-7.72.38-6.65.36-13.35.83-19.93,1.39-5.53.48-10.98,1.02-16.25,1.64-2.3.27-4.55.55-6.77.84-1.47.2-2.93.41-4.36.61-.002633-.002688-.006237-.004202-.01-.004202s-.007367.001514-.01.004202L82.4,5.7c-2.95.45-5.8.91-8.55,1.4-.01-.01-.01,0-.02,0-6.640985,1.130119-13.209165,2.652788-19.67,4.56-2.651747.790731-5.244775,1.766458-7.76,2.92-.72.34-1.39.69-2.01,1.04h-.01q-.435.255-.84.51c-.27.16-.53.34-.78.51-.31.22-.6.43-.87.65-.21.17-.41.35-.6.52-3.016561,2.853283-5.730912,6.009972-8.1,9.42-.34.5-.69,1-1.03,1.51s-.67,1.02-1,1.55c-.66,1.03-1.29,2.1-1.9,3.19-.31.54-.61,1.09-.91,1.64s-.58,1.11-.87,1.67-.57,1.12-.84,1.69c-.23.47-.45.94-.67,1.41-.08.16-.16.32-.23.49-.41.89-.81,1.8-1.2,2.72-.35.81-.69,1.63-1.02,2.45.0005.010894-.003064.021585-.01.03-.35.87-.68,1.75-1.01,2.62c0,.02-.01.03-.01.05-.32.87-.64,1.75-.95,2.64-.00907.014987-.012608.032677-.01.05q-.87,2.505-1.64,5.07c-.27.88-.53,1.77-.78,2.66-1.727549,6.149806-3.136094,12.384789-4.22,18.68-.05.34-.11.67-.17,1.01-2.164115,13.216785-3.32742,26.57808-3.48,39.97-.01.52-.01,1.01-.01,1.48-.01.17-.01.33-.01.5-4.199978,1.327192-7.34791,4.830511-8.22,9.148-.141575.72473-.21191,1.461573-.21,2.2v9.24c.012636,6.679026,5.420987,12.091846,12.1,12.11h26.57c2.758878,19.285083,18.571219,34.048816,38,35.48.32.03.64.04.96.06l.84.03c.37.01.74.01,1.11.01s.74,0,1.11-.01l.84-.03c.31-.02.64-.03.96-.06c19.427336-1.434488,35.237925-16.196586,38-35.48h125.56c1.727214,11.944278,8.548985,22.552678,18.7,29.08.029997.010628.057302.027694.08.05c6.605009,4.228786,14.287267,6.467853,22.13,6.45h.65c20.326527-.389702,37.374118-15.455605,40.26-35.58h35.75c3.210853.000001,6.290052-1.276189,8.55953-3.547543s3.543124-5.351605,3.54047-8.562457v-9.24c-.004361-4.079505-2.119096-7.866356-5.59-10.01m-6.51,19.5h-35.75c-.428163-3.317956-1.267962-6.569657-2.5-9.68l2.43.02l28.37.13l7.68.04-.18,7.48Zm-76.66,35.59c-14.0869-.016139-26.222948-9.929682-29.05-23.73-.402983-1.950837-.604043-3.93798-.6-5.93.003314-16.377191,13.282141-29.650945,29.659333-29.647999s29.651243,13.281474,29.648666,29.658666-13.280808,29.651542-29.657999,29.649333m-40.91-35.59h-125.564c-.430418-3.330485-1.270093-6.595145-2.5-9.72h130.56c-1.220689,3.127834-2.060072,6.391353-2.5,9.72m-166.47,35.59c-14.088143-.012659-26.22611-9.927769-29.05-23.73-.402969-1.950839-.604029-3.937981-.6-5.93c0-16.375243,13.274757-29.65,29.65-29.65s29.65,13.274757,29.65,29.65c.004029,1.992019-.197031,3.979161-.6,5.93-2.827404,13.800106-14.963238,23.713474-29.05,23.73M41.456,141.1l-1.7-.02-25.1-.18.23-9.48h29.09c-1.215543,3.117054-2.06132,6.365912-2.52,9.68m7.92-114.62c3.82-3.56,15.5-6.59,30.89-8.97c42.67-6.59,113.87-8.12,125.18-2c16.53,8.94,37.56,23.45,53.6,56.32.215424.449596.487647.869693.81,1.25c1.090432,1.2637,2.661589,2.011179,4.33,2.06.03,0,.22,0,.56.02c5.4.2,48.09,1.82,64.43,6.79c5.37,1.62,12.53,8.46,18.19,17.22c1.96048,3.019678,3.672762,6.19342,5.12,9.49c1.254561,2.818633,2.255193,5.743557,2.99,8.74.17.72.33,1.44.46,2.15h-35.31c-.5-.56-1.01-1.1-1.54-1.63-.17-.18-.35-.35-.52-.52-4.824307-4.736192-10.726849-8.229673-17.2-10.18-3.764014-1.123962-7.671759-1.69328-11.6-1.69-10.789373.020358-21.137749,4.283989-28.81,11.87-.17.17-.35.34-.51.52h-.01c-.021363.028777-.048642.052646-.08.07-.017452.025402-.037566.048868-.06.07-.47.49-.94.99-1.4,1.49h-145.67c-.5-.56-1-1.1-1.53-1.63-.18-.18-.35-.35-.53-.52-3.217637-3.14744-6.917634-5.760394-10.96-7.74-.035597-.018927-.072334-.035626-.11-.05-11.155501-5.422394-24.179204-5.440815-35.35-.05-4.12413,1.984732-7.894304,4.633313-11.16,7.84-.18.17-.35.34-.52.52-.53.53-1.05,1.08-1.55,1.64h-28.41c.01-.51.02-1.07.02-1.64c0-.17.01-.34.01-.52.38-19.62,3.58-69.72,26.24-90.92m50.83,83.18c-.035597-.018927-.072334-.035626-.11-.05-11.155501-5.422394-24.179204-5.440815-35.35-.05-4.12413,1.984732-7.894304,4.633313-11.16,7.84h57.58c-3.217637-3.14744-6.917634-5.760394-10.96-7.74m201.16-2.44c-3.764014-1.123962-7.671759-1.69328-11.6-1.69-10.789373.020358-21.137749,4.283989-28.81,11.87-.17.17-.35.34-.51.52.18-.18.36-.34.55-.52h57.57c-4.824307-4.736192-10.726849-8.229673-17.2-10.18m-201.16,2.44c-.035597-.018927-.072334-.035626-.11-.05-11.155501-5.422394-24.179204-5.440815-35.35-.05-4.12413,1.984732-7.894304,4.633313-11.16,7.84h57.58c-3.217637-3.14744-6.917634-5.760394-10.96-7.74m201.16-2.44c-3.764014-1.123962-7.671759-1.69328-11.6-1.69-10.789373.020358-21.137749,4.283989-28.81,11.87-.17.17-.35.34-.51.52.18-.18.36-.34.55-.52h57.57c-4.824307-4.736192-10.726849-8.229673-17.2-10.18"
                  fill="#db285b"
                />
                <path
                  d="M378.507,134.12v2.167c-.00552,7.40922-4.880968,13.933411-11.985,16.038-1.540583.451453-3.137632.681095-4.743.682h-345.051C7.495244,153.000388,0.011028,145.519752,0,136.287v-2.167c.00078-7.120991,4.509076-13.461097,11.235-15.8.032273-.013242.065767-.02329.1-.03c1.73583-.595664,3.558814-.897804,5.394-.894h345.05c1.994448-.002741,3.973067.353959,5.841,1.053.031333.006665.061846.016725.091.03c1.090285.414927,2.134004.943155,3.114,1.576.739541.471965,1.43891,1.004101,2.091,1.591c3.560663,3.166246,5.595726,7.70519,5.591,12.47"
                  fill="#c6b3b9"
                />
                <path
                  d="M125.449,147.272c.002704,1.689674-.1062,3.377681-.326,5.053-.022.227-.053.455-.091.682-2.772,19.2-19.318,34.182-39.758,35.485-.318.023-.644.038-.962.053-.28.016-.553.023-.833.031-.372.007-.743.015-1.114.015s-.743-.008-1.114-.015c-.28-.008-.553-.015-.833-.031-.318-.015-.644-.03-.962-.053-20.448-1.3-36.993-16.288-39.766-35.485-.038-.227-.068-.455-.091-.682-.219797-1.675319-.328701-3.363326-.326-5.053.002494-5.45433,1.121461-10.85042,3.288-15.856c1.905701-4.379058,4.561987-8.391408,7.849-11.856.523-.561,1.076-1.114,1.636-1.645.182-.174.364-.34.553-.515c3.578164-3.278109,7.683792-5.928984,12.144-7.841c11.292909-4.823918,24.069684-4.807292,35.35.046.039051.014551.076844.032277.113.053c4.373836,1.902594,8.401039,4.518908,11.917,7.742.189.175.371.341.553.515.561.531,1.106,1.069,1.629,1.629c3.290917,3.471594,5.949603,7.491774,7.856,11.879c1.355691,3.107294,2.302915,6.3772,2.818,9.728.31393,2.025201.471063,4.071613.47,6.121"
                  fill="#404040"
                />
                <path
                  d="M333.847,147.272c.002704,1.689674-.1062,3.377681-.326,5.053-.023.227-.053.455-.091.682-2.9,20.106-20.9,35.584-42.667,35.584-.121,0-.25,0-.371-.008-8.036834-.03463-15.911553-2.263853-22.774-6.447-.024558-.022118-.052603-.040026-.083-.053-10.476827-6.32496-17.601857-16.977881-19.447-29.076-.038-.227-.068-.455-.091-.682-.2198-1.675319-.328704-3.363326-.326-5.053.005589-5.451751,1.124448-10.844935,3.288-15.849c1.906885-4.384568,4.565569-8.402036,7.856-11.871.477-.508.97-1.008,1.478-1.493l.068-.068c.02672-.023577.051779-.04897.075-.076h.008c.182-.174.364-.34.553-.515c8.13509-7.413966,18.759465-11.499743,29.766-11.447c3.571183-.003334,7.129894.421362,10.6,1.265c7.146754,1.714346,13.740085,5.218171,19.16,10.182.189.175.371.341.553.515.568.531,1.106,1.076,1.629,1.637c3.310417,3.482221,5.980056,7.521547,7.886,11.932c2.152752,4.984962,3.261542,10.358067,3.258,15.788"
                  fill="#404040"
                />
                <path
                  d="M264.895,147.067c0,14.28595,11.58105,25.867,25.867,25.867s25.867-11.58105,25.867-25.867-11.58105-25.867-25.867-25.867c-6.860355,0-13.439728,2.725265-18.290731,7.576269s-7.576269,11.430376-7.576269,18.290731"
                  fill="#a8969b"
                />
                <path
                  d="M56.5,147.067c0,10.462498,6.302617,19.894735,15.968821,23.898279s20.792297,1.789923,28.189971-5.608609s9.610004-18.524882,5.605339-28.190621-13.437633-15.967263-23.900131-15.966049c-14.284778.001657-25.864,11.582222-25.864,25.867"
                  fill="#a8969b"
                />
                <line
                  x1="0"
                  y1="0"
                  x2="321.729"
                  y2="0"
                  transform="translate(23.105 117.918)"
                  fill="none"
                  stroke="#404040"
                  stroke-width="4"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                />
                <path
                  d="M290.77,129.923c-9.469588.00772-17.14428,7.682412-17.152,17.152-.003813,2.024863.355542,4.033998,1.061,5.932c3.010582,8.146706,11.638293,12.754491,20.083225,10.725808s14.038172-10.052693,13.01971-18.677956-8.326753-15.125875-17.011935-15.131852m0,25.1c-3.828859.001985-7.113198-2.730119-7.808258-6.495362s1.397369-7.489893,4.974585-8.855062s7.619108.018448,9.609278,3.28944s1.361083,7.496572-1.495605,10.045984c-1.452868,1.297219-3.332283,2.014458-5.28,2.015"
                  fill="#d3cbcd"
                />
                <path
                  d="M84.866,130.106c-9.370889-1.368903-18.080562,5.108541-19.466,14.477-.299379,2.002716-.235356,4.042995.189,6.023.176328.815536.410247,1.617546.7,2.4c2.326315,6.306065,8.124548,10.669803,14.82815,11.159632s13.074574-2.984708,16.29285-8.885632c.399043-.731308.743643-1.491033,1.031-2.273.415624-1.111517.71065-2.264464.88-3.439c1.379339-9.36509-5.09083-18.07643-14.455-19.462m1.871,23.606c-3.007557,1.981807-6.972049,1.692473-9.66-.705-.290915-.256534-.56171-.535019-.81-.833-2.789484-3.338953-2.371826-8.301058.936533-11.126759s8.27472-2.462139,11.136304.815233s2.552159,8.2474-.693837,11.144526c-.286238.255852-.589975.491423-.909.705"
                  fill="#d3cbcd"
                />
                <path
                  d="M135.648,32.988l10.178,32.618h-80.6c3.328-10.358,7.363-17.924,11.643-22.2c4.3-3.206,26.287-8.3,58.783-10.414"
                  fill="#423c3e"
                />
                <path
                  d="M233.306,65.6h-74.12l-10.4-33.285c5.175-.179,10.5-.293,16.053-.293c22.854-.016,32.829,1.807,33.846,2.1h.008c13.857525,7.617744,25.717758,18.403762,34.613,31.478"
                  fill="#423c3e"
                />
                <path
                  d="M365.029,117.4c-2.644859-.408481-5.174257-1.368589-7.424-2.818-2.057137-1.643246-3.79352-3.65185-5.122-5.925-1.93573-3.035155-3.647279-6.207588-5.121-9.492-1.53-3.409-2.53-6.334-2.53-7.5c0-3.16,4.4-5.228,8.053-4.963.022038.006556.045042.009262.068.008.083.008.167.015.258.03c4.576626,5.876891,8.29325,12.375427,11.038,19.3.022.2.045.409.06.606.341,3.621.569,7.295.72,10.75"
                  fill="#ffb073"
                />
                <path
                  d="M20.326,83.241v14.576h-7.652v-2.364l1.947-16.3.1-.8.121-1.008h.818c2.584,0,4.667,2.636,4.667,5.894"
                  fill="#ffb073"
                />
                <path
                  d="M15.66,111.247h-2.985v-13.43h7.656v7.534c0,3.256-2.091,5.9-4.671,5.9"
                  fill="#ff7445"
                />
                <g opacity="0.11">
                  <g>
                    <g clip-path="url(#eBN9jzcwViv253)">
                      <g>
                        <path
                          d="M374.992,149.424c-2.26736,2.293136-5.358191,3.583412-8.583,3.583h-32.978c-2.9,20.107-20.9,35.584-42.668,35.584-.121,0-.25,0-.371-.007-.212.007-.432.007-.644.007-7.842921.017371-15.525085-2.223159-22.129-6.454-.024655-.02199-.052678-.039884-.083-.053-10.477257-6.325166-17.60264-16.978435-19.448-29.077h-123.055c-2.773,19.2-19.319,34.183-39.758,35.486-.318.022-.644.038-.963.053-.28.015-.553.023-.833.03-.371.008-.742.015-1.113.015s-.743-.007-1.114-.015c-.28-.007-.553-.015-.833-.03-.319-.015-.644-.031-.963-.053-20.447-1.3-36.993-16.288-39.765-35.486h-24.8c-3.370405.002624-6.587787-1.406772-8.871-3.886-3.817289-3.168412-6.024102-7.873102-6.02-12.834v-2.166c.00078-7.120991,4.509076-13.461097,11.235-15.8.155216-13.391003,1.320187-26.751228,3.485-39.967l.122-1.007h.045c1.230455-7.208863,2.900233-14.335809,5-21.341.508-1.705,1.061-3.394,1.637-5.069.001247-.01852.006356-.036574.015-.053.31-.886.628-1.765.947-2.636.000848-.016875.005643-.033315.014-.048.326-.878.659-1.749,1.007-2.621c0-.007.008-.015.008-.03q.5-1.239,1.023-2.455c.386-.916.788-1.825,1.2-2.719.075-.167.151-.326.227-.493.227-.47.447-.939.674-1.409.273-.568.553-1.129.841-1.69s.576-1.113.871-1.666.6-1.1.91-1.644c.606-1.083,1.242-2.152,1.9-3.19q.489-.783,1-1.545c.333-.508.682-1.015,1.03-1.515c2.366863-3.410832,5.081412-6.566746,8.1-9.417.189-.174.386-.348.6-.515.266-.22.561-.44.872-.652.25-.174.507-.348.78-.515s.546-.333.841-.508h.008c3.093375-1.662149,6.353835-2.992545,9.727-3.969.012542.002966.025224.005303.038.007c8.121,1.75,16.879,3.7,26.114,5.849c21.152,4.917,44.849,10.864,69.471,17.834c26.447,7.5,53.955,16.182,80.517,26.046c10.038,3.727,19.939,7.621,29.6,11.689c1.645.689,3.273,1.379,4.895,2.083c29.1,12.523,55.773,26.615,76.978,42.244.235.174.462.348.7.515.735.545,1.455,1.091,2.174,1.636c5.152,3.932,9.955,7.955,14.364,12.069q3.978,3.7,7.493,7.515q4,4.307,7.379,8.742c.295.387.591.773.871,1.16.1.128.19.257.288.386"
                          fill="#423c3e"
                        />
                      </g>
                      <clipPath id="eBN9jzcwViv253">
                        <rect
                          width="374.992"
                          height="176.943"
                          rx="0"
                          ry="0"
                          transform="translate(0 11.648)"
                          fill="none"
                        />
                      </clipPath>
                    </g>
                  </g>
                </g>
                <path
                  d="M85.832,147.067c.000404,1.398003-.841475,2.658557-2.132984,3.193736s-2.778239.239563-3.766777-.748975-1.284155-2.475268-.748975-3.766777s1.795733-2.133388,3.193736-2.132984c.916323,0,1.795116.364008,2.443054,1.011946s1.011946,1.526731,1.011946,2.443054"
                  fill="#757575"
                />
                <path
                  d="M82.577,126.78c1.261899,1.364508,1.806008,3.244427,1.468,5.072-.399925.820352-.741765,1.667769-1.023,2.536-.106312.871295.050404,1.754475.45,2.536.727627,1.591104,1.083616,3.326933,1.041,5.076-.145892,1.841273-.817899,3.601823-1.936,5.072h-.4c-1.118101-1.470177-1.790108-3.230727-1.936-5.072-.042007-1.747724.313968-3.482117,1.041-5.072.399596-.781525.556312-1.664705.45-2.536-.281235-.868231-.623075-1.715648-1.023-2.536-.195235-.839552-.157197-1.716506.11-2.536.243252-.941807.708957-1.81149,1.358-2.536Z"
                  fill="#939393"
                />
                <path
                  d="M68.172,132.58c1.856914.073549,3.57065,1.017678,4.625,2.548.296553.863151.653778,1.704249,1.069,2.517.540828.691627,1.276449,1.205377,2.112,1.475c3.487,1.349,5.958,3.845,6.54,7.806l-.283.282c-1.830393-.248542-3.550731-1.018112-4.956-2.217-1.265282-1.206049-2.239838-2.683954-2.85-4.322-.269623-.835551-.783373-1.571172-1.475-2.112-.812923-.415137-1.653991-.772683-2.517-1.07-.731607-.455583-1.324672-1.102593-1.715-1.871-.493532-.837977-.779167-1.781979-.833-2.753Z"
                  fill="#939393"
                />
                <path
                  d="M62.089,146.867c1.364268-1.262324,3.244403-1.806495,5.072-1.468.820352.399925,1.667769.741765,2.536,1.023.871295.106312,1.754475-.050404,2.536-.45c1.589883-.727032,3.324276-1.083007,5.072-1.041c1.841273.145892,3.601823.817899,5.072,1.936v.4c-1.470177,1.118101-3.230727,1.790108-5.072,1.936-1.747724.042007-3.482117-.313968-5.072-1.041-.781525-.399596-1.664705-.556312-2.536-.45-.868238.281216-1.715656.623057-2.536,1.023-.839552.195235-1.716506.157197-2.536-.11-.941807-.243252-1.81149-.708957-2.536-1.358Z"
                  fill="#939393"
                />
                <path
                  d="M67.89,161.272c.071829-1.857392,1.016355-3.571848,2.548-4.625.862685-.296922,1.703425-.654137,2.516-1.069.691627-.540828,1.205377-1.276449,1.475-2.112c1.35-3.487,3.846-5.958,7.806-6.54l.283.283c-.249321,1.83036-1.019184,3.550576-2.218,4.956-1.205514,1.265453-2.683137,2.240049-4.321,2.85-.835689.269345-1.571385.783148-2.112,1.475-.415555.812728-.773113,1.653826-1.07,2.517-.455974.731645-1.103314,1.324694-1.872,1.715-.837539.493702-1.78126.779356-2.752.833Z"
                  fill="#939393"
                />
                <path
                  d="M82.177,167.355c-1.262324-1.364268-1.806495-3.244403-1.468-5.072.399925-.820352.741765-1.667769,1.023-2.536.106312-.871295-.050404-1.754475-.45-2.536-.727032-1.589883-1.083007-3.324276-1.041-5.072.145892-1.841273.817899-3.601823,1.936-5.072h.4c1.118101,1.470177,1.790108,3.230727,1.936,5.072.042007,1.747724-.313968,3.482117-1.041,5.072-.399596.781525-.556312,1.664705-.45,2.536.281235.868231.623075,1.715648,1.023,2.536.195235.839552.157197,1.716506-.11,2.536-.243252.941807-.708957,1.81149-1.358,2.536Z"
                  fill="#939393"
                />
                <path
                  d="M96.581,161.554c-1.857262-.072298-3.571521-1.016716-4.625-2.548-.296737-.863081-.653956-1.704166-1.069-2.517-.540828-.691627-1.276449-1.205377-2.112-1.475-3.488-1.349-5.958-3.846-6.54-7.806l.283-.282c1.830393.248542,3.550731,1.018112,4.956,2.217c1.265516,1.206246,2.240097,2.684532,2.85,4.323.270132.835022.783805,1.570183,1.475,2.111.812923.415137,1.653991.772683,2.517,1.07.731378.455859,1.324377,1.102798,1.715,1.871.493532.837977.779167,1.781979.833,2.753Z"
                  fill="#939393"
                />
                <path
                  d="M102.664,147.267c-1.364268,1.262324-3.244403,1.806495-5.072,1.468-.820344-.399943-1.667762-.741784-2.536-1.023-.871295-.106312-1.754475.050404-2.536.45-1.589883.727032-3.324276,1.083007-5.072,1.041-1.841273-.145892-3.601823-.817899-5.072-1.936v-.4c1.470177-1.118101,3.230727-1.790108,5.072-1.936c1.747724-.042007,3.482117.313968,5.072,1.041.781288.4003,1.664685.557054,2.536.45.868231-.281235,1.715648-.623075,2.536-1.023.839599-.194725,1.716415-.156693,2.536.11.941807.243252,1.81149.708957,2.536,1.358Z"
                  fill="#939393"
                />
                <path
                  d="M96.864,132.863c-.073549,1.856914-1.017678,3.57065-2.548,4.625-.863084.296727-1.70417.653947-2.517,1.069-.691627.540828-1.205377,1.276449-1.475,2.112-1.349,3.487-3.845,5.958-7.806,6.539l-.282-.282c.248323-1.830455,1.01792-3.550853,2.217-4.956c1.206049-1.265282,2.683954-2.239838,4.322-2.85.835551-.269623,1.571172-.783373,2.112-1.475.415137-.812923.772683-1.653991,1.07-2.517.455583-.731607,1.102593-1.324672,1.871-1.715.837977-.493532,1.781979-.779167,2.753-.833Z"
                  fill="#939393"
                />
                <path
                  d="M290.961,126.78c1.261899,1.364508,1.806008,3.244427,1.468,5.072-.399925.820352-.741765,1.667769-1.023,2.536-.106312.871295.050404,1.754475.45,2.536.728659,1.590861,1.085676,3.326701,1.044,5.076-.145892,1.841273-.817899,3.601823-1.936,5.072h-.4c-1.119174-1.469837-1.792234-3.230416-1.939-5.072-.042007-1.747724.313968-3.482117,1.041-5.072.399596-.781525.556312-1.664705.45-2.536-.281235-.868231-.623075-1.715648-1.023-2.536-.195184-.839557-.157146-1.716497.11-2.536.243252-.941807.708957-1.81149,1.358-2.536Z"
                  fill="#939393"
                />
                <path
                  d="M276.557,132.58c1.856914.073549,3.57065,1.017678,4.625,2.548.296556.86315.653781,1.704248,1.069,2.517.540828.691627,1.276449,1.205377,2.112,1.475c3.487,1.349,5.958,3.845,6.54,7.806l-.283.282c-1.830393-.248542-3.550731-1.018112-4.956-2.217-1.265282-1.206049-2.239838-2.683954-2.85-4.322-.269623-.835551-.783373-1.571172-1.475-2.112-.812923-.415137-1.653991-.772683-2.517-1.07-.731607-.455583-1.324672-1.102593-1.715-1.871-.493532-.837977-.779167-1.781979-.833-2.753Z"
                  fill="#939393"
                />
                <path
                  d="M270.474,146.867c1.364268-1.262324,3.244403-1.806495,5.072-1.468.820008.399927,1.667092.741768,2.535,1.023.871295.106312,1.754475-.050404,2.536-.45c1.589916-.726932,3.324286-1.082902,5.072-1.041c1.841545.146036,3.602376.818019,5.073,1.936v.4c-1.470624,1.117981-3.231455,1.789964-5.073,1.936-1.747714.041902-3.482084-.314068-5.072-1.041-.781525-.399596-1.664705-.556312-2.536-.45-.867911.281223-1.714996.623064-2.535,1.023-.839889.195217-1.71716.15718-2.537-.11-.94158-.243071-1.810979-.708808-2.535-1.358Z"
                  fill="#939393"
                />
                <path
                  d="M276.274,161.272c.072298-1.857262,1.016716-3.571521,2.548-4.625.863081-.296737,1.704166-.653956,2.517-1.069.691627-.540828,1.205377-1.276449,1.475-2.112c1.349-3.487,3.846-5.958,7.806-6.54l.282.283c-.248542,1.830393-1.018112,3.550731-2.217,4.956-1.206049,1.265282-2.683954,2.239838-4.322,2.85-.835551.269623-1.571172.783373-2.112,1.475-.415137.812923-.772683,1.653991-1.07,2.517-.455583.731607-1.102593,1.324672-1.871,1.715-.837977.493532-1.781979.779167-2.753.833Z"
                  fill="#939393"
                />
                <path
                  d="M290.561,167.355c-1.261899-1.364508-1.806008-3.244427-1.468-5.072.399925-.820352.741765-1.667769,1.023-2.536.106312-.871295-.050404-1.754475-.45-2.536-.727032-1.589883-1.083007-3.324276-1.041-5.072.145892-1.841273.817899-3.601823,1.936-5.072h.4c1.118101,1.470177,1.790108,3.230727,1.936,5.072.042007,1.747724-.313968,3.482117-1.041,5.072-.399596.781525-.556312,1.664705-.45,2.536.281235.868231.623075,1.715648,1.023,2.536.195235.839552.157197,1.716506-.11,2.536-.243288.941793-.70899,1.811467-1.358,2.536Z"
                  fill="#939393"
                />
                <path
                  d="M304.966,161.554c-1.857262-.072298-3.571521-1.016716-4.625-2.548-.29674-.86308-.653959-1.704165-1.069-2.517-.54135-.69152-1.277249-1.205222-2.113-1.475-3.495741-1.133491-6.035789-4.1657-6.539-7.806l.282-.282c1.830502.248159,3.550944,1.017775,4.956,2.217c1.266274,1.205613,2.240978,2.684085,2.85,4.323.270404.835149.784435,1.570325,1.476,2.111.812757.415491,1.653851.773048,2.517,1.07.730846.456196,1.323441,1.103071,1.714,1.871.494313.837699.780325,1.781813.834,2.753Z"
                  fill="#939393"
                />
                <path
                  d="M311.049,147.267c-1.364268,1.262324-3.244403,1.806495-5.072,1.468-.820344-.399943-1.667762-.741784-2.536-1.023-.871295-.106312-1.754475.050404-2.536.45-1.589883.727032-3.324276,1.083007-5.072,1.041-1.841273-.145892-3.601823-.817899-5.072-1.936v-.4c1.470177-1.118101,3.230727-1.790108,5.072-1.936c1.747724-.042007,3.482117.313968,5.072,1.041.781288.4003,1.664685.557054,2.536.45.868231-.281235,1.715648-.623075,2.536-1.023.839599-.194725,1.716415-.156693,2.536.11.941807.243252,1.81149.708957,2.536,1.358Z"
                  fill="#939393"
                />
                <path
                  d="M305.248,132.863c-.072298,1.857262-1.016716,3.571521-2.548,4.625-.863087.296721-1.704173.653941-2.517,1.069-.691627.540828-1.205377,1.276449-1.475,2.112-1.349,3.487-3.845,5.958-7.806,6.539l-.282-.282c.248378-1.83044,1.017968-3.550822,2.217-4.956c1.206049-1.265282,2.683954-2.239838,4.322-2.85.835551-.269623,1.571172-.783373,2.112-1.475.415137-.812923.772683-1.653991,1.07-2.517.455859-.731378,1.102798-1.324377,1.871-1.715.837977-.493532,1.781979-.779167,2.753-.833Z"
                  fill="#939393"
                />
              </g>
            </g>
          </g>
          <clipPath id="eBN9jzcwViv272">
            <rect
              width="378.507"
              height="188.591"
              rx="0"
              ry="0"
              fill="none"
            />
          </clipPath>
        </g>
      </g>
      <g
        id="eBN9jzcwViv274_to"
        transform="translate(151.175375,303.248571)"
      >
        <g
          id="eBN9jzcwViv274"
          transform="scale(0.148306,0.148306) translate(-121.430008,-93.453906)"
          opacity="0"
          clip-path="url(#eBN9jzcwViv324)"
        >
          <g>
            <g>
              <g>
                <path
                  d="M242.86,142.388c.001594,1.82266-.118674,3.643387-.36,5.45-.02.25-.05.49-.09.73-.07.47-.14.94-.23,1.41-.06.37-.13.74-.21,1.1-.314181,1.523896-.71144,3.029476-1.19,4.51-.13.41-.27.81-.41,1.21-.18.51-.37,1.01-.57,1.51-.15.37-.3.73-.46,1.1s-.33.75-.5,1.12c-.04.08-.07.15-.11.23-.19.39-.38.78-.58,1.17-.21.41-.42.82-.65,1.23s-.45.81-.69,1.21-.47.79-.73,1.18-.5.78-.76,1.16-.53.76-.8,1.14c-.82,1.12-1.69,2.21-2.61,3.25-.56.63-1.13,1.25-1.72,1.85l-.18.18c-.31.31-.62.61-.93.91-.77.74-1.58,1.45-2.41,2.14-.28.22-.56.45-.84.67-.37.29-.74.57-1.12.85q-.525.39-1.05.75c-1.1.77-2.24,1.49-3.41,2.17-.25.14-.49.28-.74.41-.28.16-.57.31-.85.46-.82.43-1.65.83-2.49,1.22-2.255589,1.011327-4.585836,1.84714-6.97,2.5-.34.09-.68.18-1.03.27s-.7.17-1.05.25-.7.15-1.05.22c-.48.1-.95.19-1.43.27-.33.06-.66.11-1,.16-.39.06-.78.12-1.17.16-.28.04-.57.07-.86.1-.68.08-1.36.14-2.05.18-.28.02-.56.03-.85.04-.062973.008311-.126502.011655-.19.01-.3.02-.59.03-.9.04-.4,0-.8.01-1.2.01s-.8-.01-1.2-.01c-.3-.01-.59-.02-.89-.04-.066823.001656-.133676-.001687-.2-.01-.28-.01-.57-.02-.84-.04-.34-.02-.69-.05-1.03-.08s-.68-.06-1.02-.1c-.24-.02-.47-.05-.71-.08q-.66-.075-1.32-.18c-.34-.05-.67-.1-1-.16-1.35-.23-2.67-.51-3.97-.85-.48-.13-.97-.26-1.44-.4-.4-.12-.8-.24-1.19-.37q-.855-.27-1.68-.57c-.44-.16-.88-.33-1.31-.5-.01,0-.02-.01-.04-.02-.44-.17-.88-.35-1.31-.55-.038141-.008863-.075075-.022293-.11-.04-.41-.18-.82-.37-1.23-.56l-.06-.03c-.44-.21-.88-.42-1.31-.65-.52-.26-1.02-.53-1.52-.81-.35-.19-.7-.39-1.04-.6-.39-.23-.78-.47-1.17-.71-.021578-.018997-.045032-.03575-.07-.05-.39-.25-.77-.5-1.15-.76-.83-.56-1.64-1.15-2.42-1.76l-1.02-.81c-1.506356-1.245415-2.93253-2.584749-4.27-4.01-.31-.33-.61-.66-.91-.99-.09-.11-.19-.22-.28-.32-.55-.64-1.08-1.29-1.6-1.96-.58-.75-1.14-1.52-1.67-2.31-.24-.35-.47-.71-.7-1.06-.29-.45-.56-.9-.83-1.36-.21-.36-.42-.72-.62-1.09-.030524-.047845-.057272-.097997-.08-.15-.28-.51-.54-1.02-.8-1.54-.02-.04-.04-.09-.06-.13-.28-.57-.54-1.14-.79-1.71-.24-.55-.47-1.09-.68-1.65-.016141-.035584-.029514-.07236-.04-.11-.23-.58-.44-1.18-.64-1.78-.1-.29-.2-.59-.29-.9-.18-.59-.35-1.19-.51-1.78-.416307-1.566293-.740198-3.1557-.97-4.76-.04-.24-.07-.48-.09-.73-.07-.51-.13-1.03-.17-1.55q-.18-1.92-.18-3.9c.000443-1.650907.097274-3.300381.29-4.94h-48.9c.188801,1.639865.282291,3.289304.28,4.94.004886,1.822436-.112042,3.64316-.35,5.45-.02.25-.05.49-.09.73-.7332,5.031295-2.351516,9.893013-4.78,14.36-4.639315,8.448725-11.827617,15.217067-20.54,19.34-5.499232,2.622002-11.449756,4.166491-17.53,4.55-.31.02-.62.04-.94.04-.032654.008269-.066355.011639-.1.01-.3.02-.59.03-.9.04h-.14c-.35,0-.71.01-1.06.01-.4,0-.8-.01-1.2-.01-.3-.01-.59-.02-.89-.04-.19-.01-.38-.01-.57-.03-.16,0-.32-.01-.47-.02l-.38-.03c-.38-.03-.75-.06-1.13-.1-21.34-2.02-38.43-17.91-41.35-38.12-.04-.24-.07-.48-.09-.73-.508471-3.828685-.478177-7.709719.09-11.53h-1.87c-3.943646.10783-7.23517-2.987185-7.37-6.93c0-22.34,11.49-38.26,23.3-48.78.29-.26.57-.51.86-.76.65-.58,1.31-1.12,1.96-1.66-2.787624-2.81804-4.36309-6.61423-4.39-10.578c0-8.73,7.55-15.85,16.85-15.85h65.01c9.28,0,16.86,7.1,16.86,15.86-.102511,6.194307-3.828822,11.752461-9.52,14.2-.950282.434118-1.937566.782178-2.95,1.04-.12.3-.24.6-.33.9-.753593,2.223734-1.184641,4.543982-1.28,6.89-.169334,5.189628.447651,10.375,1.83,15.38h31.81c13.36-6.64,21.95-15.77,25.55-27.15c1.525353-4.984594,2.194833-10.191667,1.98-15.4-.45-14.52-6.58-27.87-9.56-33.56-.05-.09-.1-.18-.14-.26-7.65,5.79-9.74,15.77-9.75,15.9-.440336,1.945531-2.185567,3.314995-4.18,3.28-.258341-.006843-.51577-.033588-.77-.08-1.0763-.144578-2.047557-.720557-2.690657-1.595627s-.902765-1.974008-.719343-3.044373c.13-.69,3.29-15.47,15.99-22.69.127958-.397461.291973-.782395.49-1.15.133896-.263568.291194-.514576.47-.75C168.17,3.968,181.3,0.708,188.09,0.128c1.795709-.205278,3.610215-.181757,5.4.07c1.487852.188792,2.888356.807377,4.03,1.78c1.699046,1.480227,3.195299,3.178221,4.45,5.05c6.45,9.62,5.61,22.03,4.87,27.28-.2,1.42-.4,2.32-.44,2.49-.833163,3.288885-3.817651,5.573819-7.21,5.52h-4.9c6.01,9.36,11.29,21.42,15.5,35.45c7.192494,1.231999,13.872755,4.525233,19.23,9.48c8.75,8.1,11.75,18.39,11.84,20.48v.01c.1139,3.074193-1.831206,5.848829-4.76,6.79l-2.69.95c2.385476,3.006359,4.368855,6.310869,5.9,9.83c1.465006,3.349658,2.486955,6.876056,3.04,10.49.33685,2.180557.507341,4.383579.51,6.59"
                  fill="#373091"
                />
                <path
                  d="M229.02,87.248c-5.357245-4.954767-12.037506-8.248001-19.23-9.48-4.21-14.03-9.49-26.09-15.5-35.45h4.9c3.392349.053819,6.376837-2.231115,7.21-5.52.04-.17.24-1.07.44-2.49.74-5.25,1.58-17.66-4.87-27.28-1.254701-1.871779-2.750954-3.569773-4.45-5.05-1.141882-.971901-2.542364-1.589781-4.03-1.778-1.789785-.251757-3.604291-.275278-5.4-.07-6.79.58-19.92,3.84-31.41,19.39-.178806.235424-.336104.486432-.47.75-.198027.367605-.362042.752539-.49,1.15-12.7,7.22-15.86,22-15.99,22.69-.183422,1.070365.076242,2.169304.719343,3.044373s1.614357,1.451049,2.690657,1.595627c.25423.046412.511659.073157.77.08c1.994433.034995,3.739664-1.334469,4.18-3.28.01-.13,2.1-10.11,9.75-15.9.04.08.09.17.14.26c2.98,5.69,9.11,19.04,9.56,33.56.214833,5.208333-.454647,10.415406-1.98,15.4-3.6,11.38-12.19,20.51-25.55,27.15h-31.81c-1.382349-5.005-1.999334-10.190372-1.83-15.38.095359-2.346018.526407-4.666266,1.28-6.89.09-.3.21-.6.33-.9c1.012434-.257822,1.999718-.605882,2.95-1.04c5.691178-2.447539,9.417489-8.005693,9.52-14.2c0-8.76-7.58-15.86-16.86-15.86h-65.01c-9.3,0-16.85,7.12-16.85,15.85.026389,3.964464,1.601894,7.761466,4.39,10.58-.65.54-1.31,1.08-1.96,1.66-.29.25-.57.5-.86.76C11.49,91.118,0,107.038,0,129.378c.13483,3.942815,3.426354,7.03783,7.37,6.93h3.71l1.07-7.99h-3.65c.4-20.95,12.44-35.46,23.74-44.57.46-.36.91-.72,1.36-1.07c1.606197.502803,3.277076.768931,4.96.79h60.35c-.03.1-.05.2-.07.3-2.54,10.4.35,22.14,2.02,27.4.594614,1.732434,2.238673,2.883679,4.07,2.85h36.12c.672011.005513,1.336121-.14511,1.94-.44c16.02-7.7,26.36-18.6,30.72-32.42c1.483373-4.775274,2.268166-9.740018,2.33-14.74.39-20.56-9.92-39.32-11.98-42.86c3.251304-4.43622,7.316919-8.213374,11.98-11.13.32-.19.64-.38.95-.55.27-.16.55-.31.82-.45.24-.13.49-.25.73-.37.38-.19.76-.37,1.12-.53.38-.17.74-.32,1.1-.47.827858-.33895,1.672261-.635993,2.53-.89.22-.07.43-.13.64-.19.26-.08.51-.14.76-.2.31-.08.62-.15.92-.21.59-.13,1.16-.23,1.69-.3.27-.04.52-.08.77-.1.985138-.120493,1.977896-.167289,2.97-.14.13,0,.26,0,.37.01.25.01.44.03.58.04q.315.285.6.57c7.87,7.84,6.34,21.47,5.68,25.41-.01.09-.03.18-.04.26h-11.9c-1.574818-.02112-3.034174.823771-3.8,2.2-.723732,1.346119-.565891,2.995567.4,4.18c4.73,5.97,11.34,16.66,17.22,34.63q1.11,3.33,2.16,7.02c.493471,1.615574,1.917369,2.770513,3.6,2.92c18.93,2.14,25.07,18.49,26.24,22.09l-4.9,1.75-.5.18l1.03,1.68l3.27,5.34l1.04-.37l1.32-.46l2.69-.95c2.928794-.941171,4.8739-3.715807,4.76-6.79v-.01c-.09-2.09-3.09-12.38-11.84-20.48M38.58,59.738h64.99c2.922173-.180676,5.703102,1.275712,7.218855,3.780554s1.515753,5.64405,0,8.148892-4.296682,3.96123-7.218855,3.780554h-64.99c-2.922173.180676-5.703102-1.275712-7.218855-3.780554s-1.515753-5.64405,0-8.148892s4.296682-3.96123,7.218855-3.780554"
                  fill="#312683"
                />
                <path
                  d="M232.09,115.938c-9.959132-13.384028-26.572345-20.066911-43.025378-17.307524s-29.976947,14.496659-35.024622,30.397524c-.87057,2.740831-1.466829,5.561335-1.78,8.42-.197686,1.665965-.294529,3.342353-.29,5.02.004996,7.119507,1.712481,14.134597,4.98,20.46c6.669503,12.848912,19.173941,21.649022,33.52,23.59c1.21.16,2.43.28,3.66.34.066324.008313.133177.011656.2.01.3.02.59.03.89.04.4,0,.8.01,1.2.01s.8-.01,1.2-.01c.31-.01.6-.02.9-.04.063498.001655.127027-.001689.19-.01c16.370337-.846271,30.94662-10.632687,37.927376-25.464179s5.233104-32.301114-4.547376-45.455821M210.11,172.7c-13.405153,6.073117-29.208892,2.591712-38.821359-8.551957s-10.737092-27.287198-2.762602-39.656045s23.142861-18.007896,37.260599-13.852136s23.81189,17.113451,23.813362,31.830138c.06321,13.047205-7.579995,24.902211-19.49,30.23"
                />
                <path
                  d="M196.42,119.358c-9.351813-.003236-17.784436,5.628098-21.364715,14.267428s-1.602909,18.584734,5.009822,25.197465s16.558134,8.590101,25.197465,5.009822s14.270664-12.012902,14.267428-21.364715c-.002208-12.762386-10.347614-23.107792-23.11-23.11m12.06,23.11c.003323,6.655744-5.384268,12.05676-12.04,12.07h-.02c-6.663335-.006615-12.063385-5.406665-12.07-12.07c0-.1,0-.2.01-.3.159142-6.544711,5.513357-11.765737,12.06-11.76h.02c6.538441.002071,11.879535,5.22329,12.03,11.76.01.1.01.2.01.3"
                />
                <rect
                  width="58.9"
                  height="8.42"
                  rx="0"
                  ry="0"
                  transform="translate(96.49 129.028)"
                  fill="#251f72"
                />
                <path
                  d="M99.31,137.448c-.313171-2.858665-.90943-5.679169-1.78-8.42-5.243284-16.500658-19.585504-28.45901-36.76-30.65-.05-.01-.09-.01-.13-.02-1.824289-.229634-3.661318-.343196-5.5-.34-5.016034-.005501-9.996668.839821-14.73,2.5-.19.07-.37.13-.56.2-19.434969,7.123235-31.38299,26.716313-28.817036,47.255894s18.966958,36.591092,39.557036,38.714106c.38.04.75.07,1.13.1.28.02.57.04.85.05.19.02.38.02.57.03.3.02.59.03.89.04.4,0,.8.01,1.2.01.35,0,.71-.01,1.06-.01.38-.01.76-.03,1.14-.05c6.706193-.334312,13.248224-2.19125,19.13-5.43c7.710274-4.253872,13.992919-10.689583,18.06-18.5c3.282107-6.31994,4.990471-13.33864,4.98-20.46-.000456-1.677506-.097282-3.353601-.29-5.02m-44.17,38.2c-18.324808,0-33.18-14.855192-33.18-33.18s14.855192-33.18,33.18-33.18s33.18,14.855192,33.18,33.18c.002388,8.800615-3.492585,17.241465-9.71556,23.46444s-14.663825,9.717948-23.46444,9.71556"
                />
                <path
                  d="M55.14,119.358c-9.350054-.002022-17.780473,5.629025-21.359518,14.266963s-1.601742,18.581323,5.009745,25.19281s16.554873,8.58879,25.19281,5.009745s14.268985-12.009464,14.266963-21.359518c.001061-6.129478-2.433395-12.008214-6.76759-16.34241s-10.212932-6.768651-16.34241-6.76759m12.07,23.11c.004631,6.625146-5.335089,12.013977-11.96,12.07h-.11c-3.201407.000796-6.271921-1.270605-8.535658-3.534342s-3.535138-5.334251-3.534342-8.535658c0-.1,0-.2.01-.3.166478-6.54151,5.516372-11.758322,12.06-11.76h.11c6.506889.046361,11.799366,5.254689,11.95,11.76.01.1.01.2.01.3"
                />
                <path
                  d="M101.66,142.388c.004886,1.822436-.112042,3.64316-.35,5.45-.02.25-.05.49-.09.73-.7332,5.031295-2.351516,9.893013-4.78,14.36-4.639315,8.448725-11.827617,15.217067-20.54,19.34-5.499232,2.622002-11.449756,4.166491-17.53,4.55-.31.02-.62.04-.94.04-.032654.008269-.066355.011639-.1.01-.3.02-.59.03-.9.04h-.14c-.35,0-.71.01-1.06.01-.4,0-.8-.01-1.2-.01-.3-.01-.59-.02-.89-.04-.19-.01-.38-.01-.57-.03-.16,0-.32-.01-.47-.02l-.38-.03c-.38-.03-.75-.06-1.13-.1-21.34-2.02-38.43-17.91-41.35-38.12-.04-.24-.07-.48-.09-.73-.508471-3.828685-.478177-7.709719.09-11.53.02-.2.05-.39.08-.59.387303-2.517432,1.003182-4.994339,1.84-7.4.36-1.02.75-2.02,1.18-3.01c2.052544-4.721083,4.915765-9.046374,8.46-12.78.56-.61,1.16-1.2,1.76-1.77c0,0,.11-.11.34-.31.081694-.088355.16851-.171833.26-.25c3.85475-3.530938,8.276574-6.387545,13.08-8.45c12.173185-5.190692,25.94048-5.172625,38.1.05.041899.015953.082098.036053.12.06c4.713853,2.04778,9.053336,4.867092,12.84,8.342.21.19.4.37.6.56.6.57,1.19,1.15,1.75,1.75l.03.03c3.537833,3.730851,6.394384,8.052907,8.44,12.77.53,1.22,1.01,2.46,1.42,3.72.728741,2.207288,1.270649,4.471928,1.62,6.77.08.55.16,1.1.22,1.65.188801,1.639865.282291,3.289304.28,4.94"
                  fill="#404040"
                />
                <path
                  d="M27.356,142.172c-.001618,11.275153,6.789126,21.440982,17.205545,25.756918s22.407039,1.93197,30.380349-6.040195s10.358995-19.962444,6.044554-30.379482-14.479294-17.209241-25.754448-17.209241c-15.39549,0-27.876,12.48051-27.876,27.876"
                  fill="#a8969b"
                />
                <path
                  d="M68.3,129.118c-2.797907-2.821952-6.437567-4.657576-10.37-5.23-.887381-.130856-1.783026-.197695-2.68-.2-4.905292-.010374-9.612809,1.932968-13.082321,5.400603s-5.4154,8.1741-5.407679,13.079397c-.003698,1.283976.130404,2.564641.4,3.82.189001.876571.439624,1.738712.75,2.58c2.355821,6.332172,7.967761,10.883015,14.65,11.88.890776.130491,1.789721.197327,2.69.2c4.896626-.014437,9.588434-1.966661,13.05-5.43c1.246153-1.241545,2.307039-2.65606,3.15-4.2.428329-.788964.799289-1.607748,1.11-2.45.447498-1.195992.765971-2.436361.95-3.7.130493-.894131.197328-1.7964.2-2.7-.0052-4.894549-1.950663-9.587396-5.41-13.05m-4.61,14.32c-.250266,1.811727-1.094326,3.489296-2.4,4.77-.115784.127523-.239353.247753-.37.36-.304006.281277-.631909.53557-.98.76-1.389221.925209-3.020885,1.419231-4.69,1.42-.421589-.000468-.842625-.030542-1.26-.09-1.657414-.241148-3.20606-.968489-4.45-2.09q-.2-.165-.36-.33c-.18-.18-.36-.37-.52-.56-1.292256-1.544579-1.997088-3.496148-1.99-5.51.000493-.404987.030573-.809397.09-1.21.616088-4.213176,4.23202-7.335059,8.49-7.33.411627.000484.822687.030561,1.23.09c4.188888.62251,7.29256,4.215116,7.3,8.45-.000462.42491-.030535.849271-.09,1.27"
                  fill="#d3cbcd"
                />
                <path
                  d="M55.446,120.308c1.27389,1.515095,1.811418,3.516546,1.468,5.466-.401154.887337-.742907,1.800348-1.023,2.733-.107163.935124.048679,1.8816.45,2.733.729881,1.727808,1.0847,3.590864,1.041,5.466-.138726,1.963641-.807848,3.852804-1.936,5.466h-.4c-1.128152-1.613196-1.797274-3.502359-1.936-5.466-.0437-1.875136.311119-3.738192,1.041-5.466.401321-.8514.557163-1.797876.45-2.733-.280093-.932652-.621846-1.845663-1.023-2.733-.195676-.905589-.157823-1.846066.11-2.733.237519-1.002932.702119-1.937948,1.358-2.733Z"
                  fill="#939393"
                />
                <path
                  d="M39.928,126.57c1.970747.173018,3.764284,1.208146,4.9,2.828.343472.91124.74737,1.798545,1.209,2.656.585154.737145,1.364876,1.295871,2.251,1.613c3.667,1.538,6.331,4.206,7.1,8.364l-.283.282c-1.938859-.344011-3.747901-1.208093-5.234-2.5-1.356243-1.295078-2.422665-2.862844-3.129-4.6-.318118-.88587-.87707-1.665424-1.614-2.251-.857681-.460887-1.744958-.864438-2.656-1.208-.7785-.502309-1.416489-1.194324-1.854-2.011-.541211-.876914-.874078-1.86628-.973-2.892Z"
                  fill="#939393"
                />
                <path
                  d="M33.382,141.972c1.515095-1.27389,3.516546-1.811418,5.466-1.468.887334.401162,1.800345.742915,2.733,1.023.935124.107163,1.8816-.048679,2.733-.45c1.727834-.729794,3.590871-1.084609,5.466-1.041c1.963641.138726,3.852804.807848,5.466,1.936v.4c-1.613196,1.128152-3.502359,1.797274-5.466,1.936-1.875129.043609-3.738166-.311206-5.466-1.041-.8514-.401321-1.797876-.557163-2.733-.45-.932652.280093-1.845663.621846-2.733,1.023-.905589.195676-1.846066.157823-2.733-.11-1.002932-.237519-1.937948-.702119-2.733-1.358Z"
                  fill="#939393"
                />
                <path
                  d="M39.645,157.49c.171165-1.971083,1.206275-3.765224,2.827-4.9.911157-.343672,1.798449-.747564,2.656-1.209.736853-.585649,1.295787-1.36518,1.614-2.251c1.537-3.668,4.2-6.33,8.363-7.1l.283.283c-.344492,1.938704-1.208515,3.747624-2.5,5.234-1.295097,1.356219-2.862858,2.422638-4.6,3.129-.886019.317834-1.665646.876837-2.251,1.614-.461625.857458-.865522,1.744762-1.209,2.656-.501507.778092-1.192446,1.41604-2.008,1.854-.876502.542089-1.866077.875027-2.892.973Z"
                  fill="#939393"
                />
                <path
                  d="M55.046,164.036c-1.27389-1.515095-1.811418-3.516546-1.468-5.466.401151-.887338.742904-1.800349,1.023-2.733.107163-.935124-.048679-1.8816-.45-2.733-.729881-1.727808-1.0847-3.590864-1.041-5.466.138726-1.963641.807848-3.852804,1.936-5.466h.4c1.128152,1.613196,1.797274,3.502359,1.936,5.466.0437,1.875136-.311119,3.738192-1.041,5.466-.401321.8514-.557163,1.797876-.45,2.733.280096.932651.621849,1.845662,1.023,2.733.195676.905589.157823,1.846066-.11,2.733-.237519,1.002932-.702119,1.937948-1.358,2.733Z"
                  fill="#939393"
                />
                <path
                  d="M70.565,157.773c-1.971083-.171165-3.765224-1.206275-4.9-2.827-.343675-.911156-.747566-1.798447-1.209-2.656-.585649-.736853-1.36518-1.295787-2.251-1.614-3.667-1.537-6.331-4.205-7.1-8.363l.283-.283c1.938565.344924,3.747375,1.208895,5.234,2.5c1.356127,1.295176,2.422531,2.862916,3.129,4.6.317834.886019.876837,1.665646,1.614,2.251.857459.461622,1.744763.865519,2.656,1.209.778471.502342,1.416453,1.194349,1.854,2.011.541211.876914.874078,1.86628.973,2.892Z"
                  fill="#939393"
                />
                <path
                  d="M77.11,142.372c-1.515095,1.27389-3.516546,1.811418-5.466,1.468-.887159-.401585-1.800199-.743349-2.733-1.023-.935124-.107163-1.8816.048679-2.733.45-1.727808.729881-3.590864,1.0847-5.466,1.041-1.963641-.138726-3.852804-.807848-5.466-1.936v-.4c1.613196-1.128152,3.502359-1.797274,5.466-1.936c1.875136-.0437,3.738192.311119,5.466,1.041.8514.401321,1.797876.557163,2.733.45.932654-.280088,1.845665-.62184,2.733-1.023.905589-.195676,1.846066-.157823,2.733.11c1.002932.237519,1.937948.702119,2.733,1.358Z"
                  fill="#939393"
                />
                <path
                  d="M70.848,126.853c-.171165,1.971083-1.206275,3.765224-2.827,4.9-.911157.343672-1.798449.747564-2.656,1.209-.736853.585649-1.295787,1.36518-1.614,2.251-1.537,3.667-4.2,6.331-8.363,7.1l-.283-.283c.344492-1.938704,1.208515-3.747624,2.5-5.234c1.295078-1.356243,2.862844-2.422665,4.6-3.129.886019-.317834,1.665646-.876837,2.251-1.614.461625-.857458.865522-1.744762,1.209-2.656.502342-.778471,1.194349-1.416453,2.011-1.854.876502-.542089,1.866077-.875027,2.892-.973Z"
                  fill="#939393"
                />
                <path
                  d="M242.86,142.388c.001594,1.82266-.118674,3.643387-.36,5.45-.02.25-.05.49-.09.73-.07.47-.14.94-.23,1.41-.06.37-.13.74-.21,1.1-.314181,1.523896-.71144,3.029476-1.19,4.51-.13.41-.27.81-.41,1.21-.18.51-.37,1.01-.57,1.51-.15.37-.3.73-.46,1.1s-.33.75-.5,1.12c-.04.08-.07.15-.11.23-.19.39-.38.78-.58,1.17-.21.41-.42.82-.65,1.23s-.45.81-.69,1.21-.47.79-.73,1.18-.5.78-.76,1.16-.53.76-.8,1.14c-.813419,1.127582-1.684581,2.212363-2.61,3.25-.56.63-1.13,1.25-1.72,1.85l-.18.18c-.31.31-.62.61-.93.91-.77.74-1.58,1.45-2.41,2.14-.28.22-.56.45-.84.67-.37.29-.74.57-1.12.85q-.525.39-1.05.75c-1.1.77-2.24,1.49-3.41,2.17-.25.14-.49.28-.74.41-.28.16-.57.31-.85.46-.82.43-1.65.83-2.49,1.22-2.255589,1.011327-4.585836,1.84714-6.97,2.5-.34.09-.68.18-1.03.27s-.7.17-1.05.25-.7.15-1.05.22c-.48.1-.95.19-1.43.27-.33.06-.66.11-1,.16-.39.06-.78.12-1.17.16-.28.04-.57.07-.86.1-.68.08-1.36.14-2.05.18-.28.02-.56.03-.85.04-.062973.008311-.126502.011655-.19.01-.3.02-.59.03-.9.04-.4,0-.8.01-1.2.01s-.8-.01-1.2-.01c-.3-.01-.59-.02-.89-.04-.066823.001656-.133676-.001687-.2-.01-.28-.01-.57-.02-.84-.04-.34-.02-.69-.05-1.03-.08s-.68-.06-1.02-.1c-.24-.02-.47-.05-.71-.08q-.66-.075-1.32-.18c-.34-.05-.67-.1-1-.16-1.35-.23-2.67-.51-3.97-.85-.48-.13-.97-.26-1.44-.4-.4-.12-.8-.24-1.19-.37q-.855-.27-1.68-.57c-.44-.16-.88-.33-1.31-.5-.01,0-.02-.01-.04-.02-.44-.17-.88-.35-1.31-.55-.038141-.008863-.075075-.022293-.11-.04-.41-.18-.82-.37-1.23-.56l-.06-.03c-.44-.21-.88-.42-1.31-.65-.52-.26-1.02-.53-1.52-.81-.35-.19-.7-.39-1.04-.6-.39-.23-.78-.47-1.17-.71-.021578-.018997-.045032-.03575-.07-.05-.39-.25-.77-.5-1.15-.76-.83-.56-1.64-1.15-2.42-1.76l-1.02-.81c-1.506356-1.245415-2.93253-2.584749-4.27-4.01-.31-.33-.61-.66-.91-.99-.09-.11-.19-.22-.28-.32-.55-.64-1.08-1.29-1.6-1.96-.59-.75-1.15-1.52-1.67-2.31-.24-.35-.47-.71-.7-1.06-.29-.45-.56-.9-.83-1.36-.21-.36-.42-.72-.62-1.09-.030524-.047845-.057272-.097997-.08-.15-.28-.51-.54-1.02-.8-1.54-.02-.04-.04-.09-.06-.13-.28-.57-.54-1.14-.79-1.71-.24-.55-.47-1.09-.68-1.65-.016141-.035584-.029514-.07236-.04-.11-.23-.58-.44-1.18-.64-1.78-.1-.29-.2-.59-.29-.9-.18-.59-.35-1.19-.51-1.78-.416307-1.566293-.740198-3.1557-.97-4.76-.04-.24-.07-.48-.09-.73-.07-.51-.13-1.03-.17-1.55q-.18-1.92-.18-3.9c.000443-1.650907.097274-3.300381.29-4.94s.01-.09.03-.25c.05-.5.12-.99.2-1.48.34859-2.270178.883735-4.507756,1.6-6.69.42-1.26.89-2.51,1.42-3.72c2.049113-4.722945,4.912711-9.048805,8.46-12.78.56-.61,1.16-1.2,1.76-1.77.2-.19.39-.37.6-.56c3.85475-3.530938,8.276574-6.387545,13.08-8.45c5.21842-2.244861,10.796193-3.538552,16.47-3.82.42-.02.84-.03,1.26-.04s.84-.02,1.26-.02c6.572334-.016649,13.0776,1.321169,19.11,3.93.041901.015947.082102.036047.12.06c4.208044,1.821878,8.118382,4.265839,11.6,7.25.42.35.83.72,1.24,1.09.21.19.4.37.6.56.6.57,1.19,1.15,1.76,1.75.9.95,1.76,1.94,2.56,2.97c2.385476,3.006359,4.368855,6.310869,5.9,9.83c1.465006,3.349658,2.486955,6.876056,3.04,10.49.33685,2.180557.507341,4.383579.51,6.59"
                  fill="#404040"
                />
                <path
                  d="M168.547,142.172c-.001618,11.275153,6.789126,21.440982,17.205545,25.756918s22.407039,1.93197,30.380349-6.040195s10.358995-19.962444,6.044554-30.379482-14.479294-17.209241-25.754448-17.209241c-15.39549,0-27.876,12.48051-27.876,27.876"
                  fill="#a8969b"
                />
                <path
                  d="M209.49,129.118c-2.797907-2.821952-6.437567-4.657576-10.37-5.23-.887381-.130856-1.783026-.197695-2.68-.2-4.905292-.010374-9.612809,1.932968-13.082321,5.400603s-5.4154,8.1741-5.407679,13.079397c-.003698,1.283976.130404,2.564641.4,3.82.188992.876574.439614,1.738715.75,2.58.929387,2.502825,2.389481,4.774839,4.28,6.66c2.798478,2.819415,6.438389,4.651656,10.37,5.22.890776.130491,1.789721.197327,2.69.2c4.896626-.014437,9.588434-1.966661,13.05-5.43c1.246153-1.241545,2.307039-2.65606,3.15-4.2.428329-.788964.799289-1.607748,1.11-2.45.447498-1.195992.765971-2.436361.95-3.7.130497-.894131.197332-1.7964.2-2.7-.0052-4.894549-1.950663-9.587396-5.41-13.05m-4.61,14.32c-.250926,1.812313-1.090705,3.491871-2.39,4.78-.12.12-.24.24-.37.35-.307951.276587-.635469.530581-.98.76-1.392877.925353-3.02776,1.419297-4.7,1.42-.421589-.000471-.842624-.030545-1.26-.09-1.657414-.241148-3.20606-.968489-4.45-2.09q-.195-.165-.36-.33c-.18-.18-.36-.37-.52-.56-1.292256-1.544579-1.997088-3.496148-1.99-5.51.000493-.404987.030573-.809397.09-1.21.616088-4.213176,4.23202-7.335059,8.49-7.33.411627.000484.822687.030561,1.23.09c4.188709.625591,7.293749,4.214864,7.31,8.45-.003868.425139-.037282.849495-.1,1.27"
                  fill="#d3cbcd"
                />
                <path
                  d="M196.637,120.308c1.27389,1.515095,1.811418,3.516546,1.468,5.466-.401154.887337-.742907,1.800348-1.023,2.733-.107163.935124.048679,1.8816.45,2.733.729881,1.727808,1.0847,3.590864,1.041,5.466-.138726,1.963641-.807848,3.852804-1.936,5.466h-.4c-1.128152-1.613196-1.797274-3.502359-1.936-5.466-.0437-1.875136.311119-3.738192,1.041-5.466.401321-.8514.557163-1.797876.45-2.733-.280093-.932652-.621846-1.845663-1.023-2.733-.195676-.905589-.157823-1.846066.11-2.733.237519-1.002932.702119-1.937948,1.358-2.733Z"
                  fill="#939393"
                />
                <path
                  d="M181.118,126.57c1.970747.173018,3.764284,1.208146,4.9,2.828.343478.911238.747375,1.798542,1.209,2.656.585154.737145,1.364876,1.295871,2.251,1.613c3.667,1.538,6.331,4.206,7.1,8.364l-.283.282c-1.938859-.344011-3.747901-1.208093-5.234-2.5-1.356243-1.295078-2.422665-2.862844-3.129-4.6-.318118-.88587-.87707-1.665424-1.614-2.251-.85768-.46089-1.744957-.86444-2.656-1.208-.7785-.502309-1.416489-1.194324-1.854-2.011-.541243-.876899-.874113-1.866272-.973-2.892Z"
                  fill="#939393"
                />
                <path
                  d="M174.573,141.972c1.515095-1.27389,3.516546-1.811418,5.466-1.468.887334.401162,1.800345.742915,2.733,1.023.935124.107163,1.8816-.048679,2.733-.45c1.727808-.729881,3.590864-1.0847,5.466-1.041c1.963641.138726,3.852804.807848,5.466,1.936v.4c-1.613196,1.128152-3.502359,1.797274-5.466,1.936-1.875136.0437-3.738192-.311119-5.466-1.041-.8514-.401321-1.797876-.557163-2.733-.45-.932653.28009-1.845664.621843-2.733,1.023-.905589.195676-1.846066.157823-2.733-.11-1.002932-.237519-1.937948-.702119-2.733-1.358Z"
                  fill="#939393"
                />
                <path
                  d="M180.835,157.49c.171165-1.971083,1.206275-3.765224,2.827-4.9.911157-.343672,1.798449-.747564,2.656-1.209.736853-.585649,1.295787-1.36518,1.614-2.251c1.537-3.668,4.2-6.33,8.363-7.1l.283.283c-.344492,1.938704-1.208515,3.747624-2.5,5.234-1.295097,1.356219-2.862858,2.422638-4.6,3.129-.886019.317834-1.665646.876837-2.251,1.614-.461622.857459-.865519,1.744763-1.209,2.656-.502342.778471-1.194349,1.416453-2.011,1.854-.876502.542089-1.866077.875027-2.892.973Z"
                  fill="#939393"
                />
                <path
                  d="M196.237,164.036c-1.27389-1.515095-1.811418-3.516546-1.468-5.466.401151-.887338.742904-1.800349,1.023-2.733.107163-.935124-.048679-1.8816-.45-2.733-.729881-1.727808-1.0847-3.590864-1.041-5.466.138726-1.963641.807848-3.852804,1.936-5.466h.4c1.128152,1.613196,1.797274,3.502359,1.936,5.466.0437,1.875136-.311119,3.738192-1.041,5.466-.401321.8514-.557163,1.797876-.45,2.733.280096.932651.621849,1.845662,1.023,2.733.195676.905589.157823,1.846066-.11,2.733-.237519,1.002932-.702119,1.937948-1.358,2.733Z"
                  fill="#939393"
                />
                <path
                  d="M211.755,157.773c-1.971083-.171165-3.765224-1.206275-4.9-2.827-.343675-.911156-.747566-1.798447-1.209-2.656-.585649-.736853-1.36518-1.295787-2.251-1.614-3.667-1.537-6.331-4.205-7.1-8.363l.283-.283c1.938565.344924,3.747375,1.208895,5.234,2.5c1.356127,1.295176,2.422531,2.862916,3.129,4.6.317834.886019.876837,1.665646,1.614,2.251.857459.461622,1.744763.865519,2.656,1.209.778471.502342,1.416453,1.194349,1.854,2.011.541211.876914.874078,1.86628.973,2.892Z"
                  fill="#939393"
                />
                <path
                  d="M218.3,142.372c-1.515095,1.27389-3.516546,1.811418-5.466,1.468-.88716-.401582-1.8002-.743346-2.733-1.023-.935124-.107163-1.8816.048679-2.733.45-1.727808.729881-3.590864,1.0847-5.466,1.041-1.963641-.138726-3.852804-.807848-5.466-1.936v-.4c1.613196-1.128152,3.502359-1.797274,5.466-1.936c1.875136-.0437,3.738192.311119,5.466,1.041.8514.401321,1.797876.557163,2.733.45.932653-.28009,1.845664-.621843,2.733-1.023.905589-.195676,1.846066-.157823,2.733.11c1.002932.237519,1.937948.702119,2.733,1.358Z"
                  fill="#939393"
                />
                <path
                  d="M212.038,126.853c-.171165,1.971083-1.206275,3.765224-2.827,4.9-.911156.343675-1.798447.747566-2.656,1.209-.736853.585649-1.295787,1.36518-1.614,2.251-1.537,3.667-4.205,6.331-8.363,7.1l-.283-.283c.344492-1.938704,1.208515-3.747624,2.5-5.234c1.295078-1.356243,2.862844-2.422665,4.6-3.129.886019-.317834,1.665646-.876837,2.251-1.614.461625-.857458.865522-1.744762,1.209-2.656.502342-.778471,1.194349-1.416453,2.011-1.854.876502-.542089,1.866077-.875027,2.892-.973Z"
                  fill="#939393"
                />
                <path
                  d="M123.06,66.888c0,.12,0,.24-.01.36-.101822,3.999975-1.801776,7.792458-4.72,10.53-2.069278,1.970811-4.621813,3.360907-7.4,4.03-1.07449.266318-2.173704.420476-3.28.46-.24.01-.48.02-.73.02h-74.02c-.22,0-.44,0-.66-.02-2.858096-.097993-5.641977-.935224-8.08-2.43-.29-.18-.58-.37-.86-.57-3.96998-2.75221-6.39137-7.23104-6.52-12.06-.01-.11-.01-.21-.01-.32.016001-4.122545,1.722094-8.058125,4.72-10.888c2.66749-2.524931,6.103313-4.084428,9.76-4.43.54-.05,1.09-.08,1.65-.08h74.02c.56,0,1.11.03,1.65.08c8.14.79,14.49,7.35,14.49,15.32"
                  fill="#a5a48b"
                />
                <path
                  d="M206.84,34.308h-8.38c-.06-.08-.13-.16-.19-.25-1.05-1.36-2.08-2.81-3.08-4.33-3.751719-5.761586-7.009972-11.829832-9.74-18.14c2.282535-1.201743,4.673067-2.18608,7.14-2.94c3.042403-.94773,6.195958-1.492373,9.38-1.62c6.45,9.62,5.61,22.03,4.87,27.28"
                  fill="#ffb073"
                />
                <path
                  d="M157.98,29.908c-.05-.09-.1-.18-.14-.26-7.65,5.79-9.74,15.77-9.75,15.9-.440336,1.945531-2.185567,3.314995-4.18,3.28-.258341-.006843-.51577-.033588-.77-.08-1.0763-.144578-2.047557-.720557-2.690657-1.595627s-.902765-1.974008-.719343-3.044373c.13-.69,3.29-15.47,15.99-22.69.127958-.397461.291973-.782395.49-1.15Z"
                  fill="#404040"
                />
                <g opacity="0.11">
                  <g>
                    <g clip-path="url(#eBN9jzcwViv315)">
                      <g>
                        <path
                          d="M142.63,137.448h-41.25c.188801,1.639865.282291,3.289304.28,4.94.004886,1.822436-.112042,3.64316-.35,5.45-.02.25-.05.49-.09.73-.7332,5.031295-2.351516,9.893013-4.78,14.36-4.639315,8.448725-11.827617,15.217067-20.54,19.34-5.499232,2.622002-11.449756,4.166491-17.53,4.55-.31.02-.62.04-.94.04-.032654.008269-.066355.011639-.1.01-.3.02-.59.03-.9.04h-.14c-.35,0-.71.01-1.06.01-.4,0-.8-.01-1.2-.01-.3-.01-.59-.02-.89-.04-.19-.01-.38-.01-.57-.03-.16,0-.32-.01-.47-.02l-.38-.03c-.38-.03-.75-.06-1.13-.1-21.34-2.02-38.43-17.91-41.35-38.12-.04-.24-.07-.48-.09-.73-.508471-3.828685-.478177-7.709719.09-11.53h-1.87c-3.943646.10783-7.23517-2.987185-7.37-6.93c0-22.34,11.49-38.26,23.3-48.78-4.109674-3.043701-6.532494-7.855948-6.53-12.97c0-.14,0-.28.01-.42-.01-.11-.01-.21-.01-.32.016001-4.122545,1.722094-8.058125,4.72-10.888c2.66749-2.524931,6.103313-4.084428,9.76-4.43.54-.05,1.09-.08,1.65-.08h46.15c.05.08.11.17.17.26q2.61,3.885,5.41,7.99c3.45,5.05,7.08,10.31,10.88,15.71c1.59,2.26,3.2,4.54,4.85,6.84q2.94,4.14,6.01,8.35c3.69,5.09,7.5,10.23,11.38,15.38q3.015,4.005,6.1,8c3.9,5.05,7.86,10.07,11.86,15.01q3.435,4.26,6.92,8.42"
                          fill="#423c3e"
                        />
                      </g>
                      <clipPath id="eBN9jzcwViv315">
                        <rect
                          width="142.63"
                          height="135.43"
                          rx="0"
                          ry="0"
                          transform="translate(0 51.488)"
                          fill="none"
                        />
                      </clipPath>
                    </g>
                  </g>
                </g>
                <g opacity="0.11">
                  <g>
                    <g clip-path="url(#eBN9jzcwViv322)">
                      <g>
                        <path
                          d="M190.53,186.558q-.66-.075-1.32-.18c-.34-.05-.67-.1-1-.16-1.35-.23-2.67-.51-3.97-.85-.48-.13-.97-.26-1.44-.4-.4-.12-.8-.24-1.19-.37q-.855-.27-1.68-.57c-.44-.16-.88-.33-1.31-.5-.01,0-.02-.01-.04-.02-.44-.17-.88-.35-1.31-.55-.038141-.008863-.075075-.022293-.11-.04-.41-.18-.82-.37-1.23-.56l-.06-.03c-.44-.21-.88-.42-1.31-.65-.52-.26-1.02-.53-1.52-.81-.35-.19-.7-.39-1.04-.6-.39-.23-.78-.47-1.17-.71-.021578-.018997-.045032-.03575-.07-.05-.39-.25-.77-.5-1.15-.76-.83-.56-1.64-1.15-2.42-1.76l-1.02-.81c-1.506356-1.245415-2.93253-2.584749-4.27-4.01-.31-.33-.61-.66-.91-.99-.09-.11-.19-.22-.28-.32-.55-.64-1.08-1.29-1.6-1.96-.59-.75-1.15-1.52-1.67-2.31-.24-.35-.47-.71-.7-1.06-.29-.45-.56-.9-.83-1.36-.21-.36-.42-.72-.62-1.09-.030524-.047845-.057272-.097997-.08-.15-.28-.51-.54-1.02-.8-1.54-.02-.04-.04-.09-.06-.13-.28-.57-.54-1.14-.79-1.71-.24-.55-.47-1.09-.68-1.65-.016141-.035584-.029514-.07236-.04-.11-.23-.58-.44-1.18-.64-1.78-.1-.29-.2-.59-.29-.9-.18-.59-.35-1.19-.51-1.78-.416307-1.566293-.740198-3.1557-.97-4.76-.04-.24-.07-.48-.09-.73-.07-.51-.13-1.03-.17-1.55.75.87,1.51,1.74,2.27,2.61c12.85,14.61,25.78,27.7,38.03,37.62.017531.016709.037833.030244.06.04"
                          fill="#423c3e"
                        />
                      </g>
                      <clipPath id="eBN9jzcwViv322">
                        <rect
                          width="40.36"
                          height="40.27"
                          rx="0"
                          ry="0"
                          transform="translate(150.17 146.288)"
                          fill="none"
                        />
                      </clipPath>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <clipPath id="eBN9jzcwViv324">
            <rect
              width="242.86"
              height="186.918"
              rx="0"
              ry="0"
              fill="none"
            />
          </clipPath>
        </g>
      </g>
      <g
        id="eBN9jzcwViv326_to"
        transform="translate(152.180754,302.677524)"
      >
        <g
          id="eBN9jzcwViv326"
          transform="scale(0.163314,0.163312) translate(-139.590953,-85.640775)"
          opacity="0"
          clip-path="url(#eBN9jzcwViv392)"
        >
          <g>
            <g>
              <g>
                <circle
                  r="12.643"
                  transform="translate(53.709 117.667)"
                  fill="none"
                  stroke="#92c13a"
                  stroke-width="4"
                  stroke-miterlimit="10"
                />
                <path
                  d="M225.71,64.383c-4.686912-.001525-9.353644.613758-13.88,1.83-3.697066.990997-7.27492,2.382571-10.67,4.15-20.202883,10.453692-31.572415,32.552124-28.331873,55.067342s20.380613,40.510354,42.711544,44.842292s44.956262-5.949178,56.380329-25.619634c.970201-1.662207,1.844951-3.378319,2.62-5.14c7.340936-16.528624,5.823767-35.648673-4.031973-50.812747s-26.712543-24.314279-44.798027-24.317253m39.8,76.55c-9.809338,16.802109-29.129439,25.614755-48.248124,22.00784s-33.89987-18.853083-36.91308-38.074283s6.393423-38.259169,23.491204-47.543557c6.718674-3.628276,14.234232-5.528644,21.87-5.53c16.462564.004157,31.669695,8.799551,39.882708,23.067082s8.181477,31.834966-.082708,46.072918"
                  fill="#404040"
                />
                <path
                  d="M226.12,71.063c-19.040121-.000808-36.205653,11.468702-43.49143,29.059712s-3.256791,37.838786,10.208037,51.300754s33.71346,17.486653,51.302922,10.197138s29.055325-24.457484,29.050471-43.497604c.000796-12.483065-4.958414-24.454938-13.786211-33.28086s-20.800725-13.782589-33.283789-13.77914m33.75,77.04c-2.106157,2.372871-4.455712,4.517971-7.01,6.4h-.01c-5.124857,3.803609-11.007912,6.460363-17.25,7.79h-.01c-20.609709,4.42623-41.539444-5.998132-50.423567-25.114198s-3.357948-41.835717,13.313567-54.735802c1.84864-1.434066,3.804355-2.724503,5.85-3.86c3.356337-1.86079,6.939447-3.279244,10.66-4.22.61-.16,1.21-.3,1.82-.42h.01c3.056227-.657096,6.173937-.985629,9.3-.98c3.125424-.003417,6.24255.321703,9.3.97h.01c6.137548,1.291973,11.935768,3.857225,17.02,7.53h.01c2.541345,1.830447,4.887093,3.918162,7,6.23c2.118646,2.314823,3.988861,4.845311,5.58,7.55c1.604109,2.702618,2.914881,5.568884,3.91,8.55v.01c1.003697,2.9824,1.687538,6.063039,2.04,9.19v.007c.192702,1.69987.289522,3.409243.29,5.12c0,1.45-.07,2.89-.2,4.31-.304814,3.146639-.934844,6.253226-1.88,9.27-.22.69-.45,1.37-.7,2.04-.845354,2.299538-1.882331,4.524022-3.1,6.65-1.565125,2.758565-3.418859,5.343066-5.53,7.71"
                  fill="#b84c42"
                />
                <path
                  d="M226.12,163.293v-90.33"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <path
                  d="M216.81,73.933v.01l2.64,12.42.01.02.01.03l2.37,11.21h.01l.85,4.01.33,1.56.79,3.73l2.29,10.75v.04h.01v.02l2.26,10.63l1.12,5.29l6.09,28.64"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <path
                  d="M207.92,76.823l7.27,16.34h.01l4.23,9.51.7,1.57l1.5,3.37l4.48,10.06v.01l.01.01v.02h.01v.02l.01.01l4.4,9.89l2.2,4.94l11.91,26.75.01.02"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <path
                  d="M252.91,154.583l-.05-.08h-.01l-17.18-23.64-3.18-4.38-6.35-8.74-.01-.01v-.01h-.01v-.02h-.01l-.02-.02-6.48-8.93-2.09-2.88-1.08-1.49-4.7-6.46v-.01l-9.56-13.16c-.006664-.006669-.013331-.013336-.02-.02l-2.35-3.23"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <path
                  d="M192.86,87.763l21.01,18.91l4.02,3.62l8.2,7.39.02.02h.01v.01h.01v.01l8.03,7.23l4.02,3.62l21.69,19.53.12.1"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <path
                  d="M187.36,95.333l24.47,14.13l4.68,2.7l9.6,5.54v.01h.02v.01l9.36,5.4l4.68,2.7l25.23,14.57.19.11"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <path
                  d="M183.56,103.883l26.86,8.73l5.14,1.67l10.55,3.42v.01h.02l10.28,3.34l5.14,1.67l23.03,7.48l4.62,1.5.27.09"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <path
                  d="M181.61,113.033l28.09,2.95l5.39.57l10.99,1.16h.05l10.74,1.13l5.39.56l10.84,1.14l17.98,1.89.37.04"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <path
                  d="M181.61,122.383l28.1-2.95l5.39-.57l10.98-1.15h.03v-.01h.04l10.73-1.13l5.39-.56l4.45-.47l24.27-2.55.46-.05"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <path
                  d="M183.56,131.543l26.89-8.74l5.14-1.67l10.49-3.42h.05v-.01h.02l10.29-3.34l5.13-1.67.99-.33h.01l26.38-8.57.52-.17"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <line
                  x1="0"
                  y1="45.165"
                  x2="78.227"
                  y2="0"
                  transform="translate(187.363 94.92)"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <line
                  x1="0"
                  y1="60.442"
                  x2="67.128"
                  y2="0"
                  transform="translate(192.862 87.212)"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <line
                  x1="0"
                  y1="73.078"
                  x2="53.094"
                  y2="0"
                  transform="translate(199.815 80.836)"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <line
                  x1="0"
                  y1="82.52"
                  x2="36.74"
                  y2="0"
                  transform="translate(207.917 76.072)"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <line
                  x1="0"
                  y1="88.355"
                  x2="18.78"
                  y2="0"
                  transform="translate(216.814 73.128)"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <path
                  d="M236.94,117.667c0,6.050279-4.904721,10.955-10.955,10.955s-10.955-4.904721-10.955-10.955s4.904721-10.955,10.955-10.955c2.905447,0,5.691894,1.154184,7.746355,3.208645s3.208645,4.840908,3.208645,7.746355"
                  fill="#a8969b"
                />
                <path
                  d="M106.57,112.153c-.586834-5.551495-2.04823-10.975199-4.33-16.07-.15-.33-.31-.67-.46-1-.048906-.142901-.112584-.280311-.19-.41-5.012143-10.366779-13.217428-18.852467-23.41-24.21-22.767774-11.882927-50.769095-5.883038-66.669188,14.285317s-15.198554,48.796671,1.670316,68.16202s45.13046,23.98651,67.288872,11.002663c7.933488-4.672972,14.534239-11.304712,19.17-19.26c3.790119-6.512051,6.152346-13.755531,6.93-21.25.200175-1.856605.30032-3.722635.3-5.59.001114-1.890669-.099029-3.780042-.3-5.66M99.11,123.4c-.741267,6.182375-2.738847,12.147889-5.87,17.53-11.210575,19.299041-34.652333,27.772972-55.611878,20.103067s-33.395065-29.272715-29.501311-51.249263s22.994363-37.991859,45.313189-37.993804c25.409058.017099,46.002901,20.610942,46.02,46.02.00361,1.868919-.113299,3.736127-.35,5.59"
                  fill="#404040"
                />
                <path
                  d="M74.48,75.833c-18.431429-8.992646-40.564068-5.01465-54.710512,9.833359s-17.049344,37.147143-7.17579,55.122075s30.250087,27.48677,50.369526,23.512675s35.349099-20.519053,37.646776-40.898109c.201012-1.752804.301177-3.515708.3-5.28-.015599-17.985949-10.270026-34.393808-26.43-42.29m24.33,46.6c-.04.33-.07.65-.11.97-.32388,2.817661-.919998,5.597314-1.78,8.3-1.91437,6.063184-5.090674,11.652389-9.32,16.4-4.23179,4.768708-9.421274,8.591821-15.23,11.22-17.855688,8.032412-38.853274,3.646298-52.000469-10.8622s-15.449963-35.835332-5.7028-52.815851s29.324517-25.74772,48.483269-21.711949c3.0609.635127,6.044694,1.597317,8.9,2.87.45.19.9.4,1.34.61c2.375298,1.148906,4.647053,2.500584,6.79,4.04h.01c2.53584,1.833506,4.87797,3.920984,6.99,6.23l.01.01c2.115405,2.313881,3.985388,4.840704,5.58,7.54v.01c1.600075,2.704728,2.910646,5.570556,3.91,8.55v.01c1.00369,2.982402,1.687531,6.06304,2.04,9.19v.007c.192702,1.69987.289522,3.409243.29,5.12c0,1.45-.07,2.89-.2,4.31"
                  fill="#b84c42"
                />
                <line
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="90.329"
                  transform="translate(53.842 72.959)"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <line
                  x1="0"
                  y1="0"
                  x2="18.78"
                  y2="88.355"
                  transform="translate(44.538 73.937)"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <line
                  x1="0"
                  y1="0"
                  x2="36.74"
                  y2="82.52"
                  transform="translate(35.641 76.828)"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <line
                  x1="0"
                  y1="0"
                  x2="53.094"
                  y2="73.078"
                  transform="translate(27.539 81.506)"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <line
                  x1="0"
                  y1="0"
                  x2="67.128"
                  y2="60.442"
                  transform="translate(20.586 87.766)"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <line
                  x1="0"
                  y1="0"
                  x2="78.227"
                  y2="45.165"
                  transform="translate(15.087 95.334)"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <line
                  x1="0"
                  y1="0"
                  x2="85.908"
                  y2="27.913"
                  transform="translate(11.282 103.881)"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <line
                  x1="0"
                  y1="0"
                  x2="89.834"
                  y2="9.442"
                  transform="translate(9.337 113.032)"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <line
                  x1="0"
                  y1="9.442"
                  x2="89.834"
                  y2="0"
                  transform="translate(9.337 112.946)"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <line
                  x1="0"
                  y1="27.913"
                  x2="85.908"
                  y2="0"
                  transform="translate(11.282 103.626)"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <line
                  x1="0"
                  y1="45.165"
                  x2="78.227"
                  y2="0"
                  transform="translate(15.087 94.92)"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <line
                  x1="0"
                  y1="60.442"
                  x2="67.128"
                  y2="0"
                  transform="translate(20.586 87.212)"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <line
                  x1="0"
                  y1="73.078"
                  x2="53.094"
                  y2="0"
                  transform="translate(27.539 80.836)"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <line
                  x1="0"
                  y1="82.52"
                  x2="36.74"
                  y2="0"
                  transform="translate(35.641 76.072)"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <line
                  x1="0"
                  y1="88.355"
                  x2="18.78"
                  y2="0"
                  transform="translate(44.538 73.128)"
                  fill="none"
                  stroke="#a8969b"
                  stroke-miterlimit="10"
                />
                <path
                  d="M64.664,117.667c0,6.050279-4.904721,10.955-10.955,10.955s-10.955-4.904721-10.955-10.955s4.904721-10.955,10.955-10.955s10.955,4.904721,10.955,10.955"
                  fill="#a8969b"
                />
                <path
                  d="M242.35,117.663c.000465.581175-.029576,1.161974-.09,1.74-.116797,1.128946-.354836,2.24203-.71,3.32-.704872,2.162879-1.852586,4.155201-3.37,5.85-.755549.847758-1.596683,1.615167-2.51,2.29-1.841811,1.346306-3.942658,2.296284-6.17,2.79-1.1104.243781-2.243189.371136-3.38.38h-.13c-2.247276.002932-4.470746-.46015-6.53-1.36-2.105948-.927498-3.995971-2.282865-5.55-3.98-1.555479-1.697596-2.734581-3.704796-3.46-5.89-.365125-1.09401-.613179-2.223662-.74-3.37-.060418-.58806-.090458-1.178845-.09-1.77c0-.57.03-1.13.08-1.68.121191-1.145469.362519-2.275015.72-3.37.354597-1.097941.827368-2.154132,1.41-3.15.574629-1.002645,1.258822-1.93838,2.04-2.79.274692-.308082.565077-.601805.87-.88.532008-.510286,1.10015-.98151,1.7-1.41.932517-.675488,1.934941-1.248781,2.99-1.71c1.04895-.464515,2.145433-.813243,3.27-1.04.807719-.164735,1.626705-.268362,2.45-.31.28-.01.56-.02.84-.02h.13c.4,0,.79.02,1.18.05h.01c.005523,0,.01.004477.01.01.740484.049815,1.476009.1568,2.2.32c1.118556.248372,2.207882.613716,3.25,1.09c1.039725.468561,2.025502,1.048627,2.94,1.73.914319.68105,1.75849,1.451524,2.52,2.3.75648.850412,1.420224,1.778984,1.98,2.77.303821.529302.574346,1.077031.81,1.64h.01c.211124.481415.391486.975741.54,1.48.351828,1.078332.586514,2.191415.7,3.32.05.54.08,1.09.08,1.65"
                  fill="#92c13a"
                />
                <path
                  d="M47.38,115.413l.49-.89c-.188181.282292-.352101.580024-.49.89m177.77-14.09l-.75-1.96-3.57-9.39-1.36-3.56-.01-.03-.01-.02-3-7.9-.8-2.11c.03-.01.07-.02.1-.03l-.76-1.96-.46-1.19-.24-.61-2.46-6.35-.23-.59-.09-.22-17.35-45.32-6.33-16.53c-.908839-2.137022-2.997842-3.532178-5.32-3.553h-18.64c-3.106374-.00221-5.626688,2.513627-5.63,5.62-.051289,1.508308.525384,2.970314,1.592535,4.037465s2.529157,1.643824,4.037465,1.592535h14.79l3.4,8.83l6.96,18.1h-81.67l-2.36-6.2-.01-.02q.96-.15,1.89-.3c.17-.03.33-.05.49-.08c4.6-.75,8.4-1.43,9.16-1.69c2.37-.3,4.73-2.07,4.73-4.74v-2.66c.01416-.553218-.199378-1.087998-.59069-1.47931s-.926092-.60485-1.47931-.59069h-36.39c-.953979-.039505-1.88106.321465-2.557152.995658s-1.039669,1.600256-1.002848,2.554342-.59,12.43,4.74,11.54c.86-.15,2.14-.36,3.75-.64c1.69-.3,3.74-.68,6.02-1.14l.05.12l3.5,9.06L82.78,63.763l-.2.29-3.44,5.01-.96,1.4-3.7,5.37-.54.79-.55.79-1.44,2.1.18.09-.66.95L68.45,84.9v.01l-.02.02-4.12,5.93-6.95,10.32v.01l-.01.01-3.51,5.2c.05685-.001657.113736.001689.17.01.732781.037189,1.461606.1308,2.18.28l.63.15c.081278.018704.161411.042076.24.07.473227.12164.937632.275328,1.39.46.747247.279526,1.466989.62768,2.15,1.04.703901.413737,1.369829.888922,1.99,1.42h.01c.540699.460716,1.048598.958592,1.52,1.49l4.74-7.13.01-.01.01-.01.01-.01v-.01l5.09-7.66l6.94-10.12.38-.55c1.308588,1.201759,2.544128,2.480709,3.7,3.83v.01c1.912156,2.209986,3.594174,4.60904,5.02,7.16v.01c.877863,1.567597,1.659313,3.18727,2.34,4.85.04.09.08.18.11.26.13.29.24.58.35.88.25.66.48,1.31.7,1.99v.01c.769747,2.391106,1.33511,4.843245,1.69,7.33h-30.54c.231941.602955.422385,1.221063.57,1.85v.01c.19189.80786.312354,1.631031.36,2.46v.01q.03.45.03.9c0,.53-.03,1.05-.08,1.56-.089094.818334-.246306,1.627808-.47,2.42-.195719.697415-.443069,1.379299-.74,2.04h68.16c1.658908.127871,3.252379-.672713,4.14-2.08l43.04-50.28l14.96-17.48l4.88,12.53.27.7l1.07,2.75h-.01l.15.4.16.42l2.48,6.43.2.53.49,1.26.63,1.64c.01-.01.03-.01.04-.02l.99,2.61l2.2,5.78.47,1.23l1.77,4.65l1.31,3.44v.01l3,7.87.75,1.98.01.01c.024387-.040921.054718-.077992.09-.11.030558-.039097.063984-.075865.1-.11.08-.09.16-.18.24-.26s.16-.17.24-.25c.16016-.170143.330472-.330436.51-.48.17-.16.35-.32.53-.46.098963-.085491.202445-.165607.31-.24.040815-.039543.084247-.076293.13-.11.17-.13.35-.26.53-.39s.36-.24.55-.36.37-.23.56-.34.39-.21.58-.31c.08-.04.17-.08.25-.12h.01c.1-.05.19-.1.29-.15.22-.1.44-.19.66-.28.35-.14.71-.27,1.07-.38.29-.09.58-.17.88-.24h.01c.424376-.112549.855159-.199374,1.29-.26.46-.07.91-.11,1.38-.14Zm-118.69,10.83c-.566162-5.542848-1.989797-10.964131-4.22-16.07-.15-.33-.31-.67-.46-1-.048906-.142901-.112584-.280311-.19-.41-3.264774-6.91798-7.961753-13.063592-13.78-18.03l1.01-1.46l13.49-19.55l22.2,56.52Zm63.44-46.82l-35.33,41.5-22.79-57.71h71.91Z"
                  fill="#92c13a"
                />
                <path
                  d="M194.158,20.08h-12.1l-3.4-8.83h-14.79c-1.508308.051289-2.970314-.525384-4.037465-1.592535s-1.643824-2.529157-1.592535-4.037465c.003312-3.106373,2.523626-5.62221,5.63-5.62h18.64c2.32144.020306,4.410247,1.414152,5.32,3.55Z"
                  fill="#404040"
                />
                <path
                  d="M121.248,22.49v2.66c0,2.67-2.36,4.44-4.73,4.74-.76.26-4.56.94-9.16,1.69-.16.03-.32.05-.49.08l-1.88.32-11.2,1.87-6.07,1.02c-1.61.28-2.89.49-3.75.64-5.33.89-4.74-11.54-4.74-11.54-.036821-.954086.326755-1.880149,1.002848-2.554342s1.603173-1.035163,2.557152-.995658h36.39c.553218-.01416,1.087998.199378,1.47931.59069s.60485.926092.59069,1.47931"
                  fill="#404040"
                />
                <g opacity="0.11">
                  <g>
                    <g clip-path="url(#eBN9jzcwViv376)">
                      <g>
                        <path
                          d="M47.38,115.413l.49-.89c-.188181.282292-.352101.580024-.49.89M169.9,65.333l-35.33,41.5-22.79-57.71h29.07c-7.04-3.81-13.95-7.47-20.64-10.94h-12.86l-2.36-6.2l1.88-.32c.17-.03.33-.05.49-.08-7.95-4.05-15.47-7.78-22.39-11.16h-2.18c-.953979-.039505-1.88106.321465-2.557152.995658s-1.039669,1.600256-1.002848,2.554342-.59,12.43,4.74,11.54c.86-.15,2.14-.36,3.75-.64l6.07-1.02l3.5,9.06-14.51,20.85-.2.29-3.44,5.01-.96,1.4-3.7,5.37-.54.79-.55.79-1.44,2.1.18.09-.66.95L68.45,84.9v.01l-.02.02-4.12,5.93-6.95,10.32v.01l-.01.01-3.51,5.2c.05685-.001657.113736.001689.17.01.732781.037189,1.461606.1308,2.18.28l.63.15c.081278.018704.161411.042076.24.07.473227.12164.937632.275328,1.39.46.747247.279526,1.466989.62768,2.15,1.04.703901.413737,1.369829.888922,1.99,1.42h.01c.540699.460716,1.048598.958592,1.52,1.49l4.74-7.13.01-.01.01-.01.01-.01v-.01l5.09-7.66l6.94-10.12.38-.55c1.308588,1.201759,2.544128,2.480709,3.7,3.83v.01c1.912156,2.209986,3.594174,4.60904,5.02,7.16v.01c.877863,1.567597,1.659313,3.18727,2.34,4.85.04.09.08.18.11.26.13.29.24.58.35.88.25.66.48,1.31.7,1.99v.01c.769747,2.391106,1.33511,4.843245,1.69,7.33h-30.54c.231941.602955.422385,1.221063.57,1.85v.01c.19189.80786.312354,1.631031.36,2.46v.01q.03.45.03.9c0,.53-.03,1.05-.08,1.56-.089094.818334-.246306,1.627808-.47,2.42-.195719.697415-.443069,1.379299-.74,2.04h68.16c1.658908.127871,3.252379-.672713,4.14-2.08l43.04-50.28q-4.89-2.9-9.78-5.71m-63.33,46.82c-.586834-5.551495-2.04823-10.975199-4.33-16.07-.15-.33-.31-.67-.46-1-.048906-.142901-.112584-.280311-.19-.41-3.264774-6.91798-7.961753-13.063592-13.78-18.03l1.01-1.46l13.49-19.55l22.2,56.52Z"
                          fill="#423c3e"
                        />
                      </g>
                      <clipPath id="eBN9jzcwViv376">
                        <rect
                          width="132.3"
                          height="102.98"
                          rx="0"
                          ry="0"
                          transform="translate(47.38 20.423)"
                          fill="none"
                        />
                      </clipPath>
                    </g>
                  </g>
                </g>
                <g opacity="0.11">
                  <g>
                    <g clip-path="url(#eBN9jzcwViv383)">
                      <g>
                        <path
                          d="M242.35,117.663c.000465.581175-.029576,1.161974-.09,1.74-.116797,1.128946-.354836,2.24203-.71,3.32-.704872,2.162879-1.852586,4.155201-3.37,5.85-.755549.847758-1.596683,1.615167-2.51,2.29-1.841811,1.346306-3.942658,2.296284-6.17,2.79-1.1104.243781-2.243189.371136-3.38.38h-.13c-2.247276.002932-4.470746-.46015-6.53-1.36-2.105948-.927498-3.995971-2.282865-5.55-3.98-1.555479-1.697596-2.734581-3.704796-3.46-5.89-.365125-1.09401-.613179-2.223662-.74-3.37-.060418-.58806-.090458-1.178845-.09-1.77c0-.57.03-1.13.08-1.68.121191-1.145469.362519-2.275015.72-3.37.354597-1.097941.827368-2.154132,1.41-3.15.574629-1.002645,1.258822-1.93838,2.04-2.79.274692-.308082.565077-.601805.87-.88l-3-7.87v-.01l-1.31-3.44-1.77-4.65-.47-1.23c2.35,1.51,4.69,3.04,7,4.57h.01c2.23,1.48,4.45,2.96,6.64,4.46h.01c.85.57,1.71,1.16,2.55,1.74l.75,1.96c.28-.01.56-.02.84-.02h.13c.4,0,.79.02,1.18.05h.01c.005523,0,.01.004477.01.01.66.46,1.32.93,1.97,1.39h.01c.89.62,1.77,1.25,2.65,1.87.81.58,1.62,1.15,2.42,1.73s1.62,1.17,2.42,1.75c.88.64,1.76,1.28,2.63,1.93.54.39,1.07.78,1.6,1.18h.01c.211124.481415.391486.975741.54,1.48.351828,1.078332.586514,2.191415.7,3.32.05.54.08,1.09.08,1.65"
                          fill="#423c3e"
                        />
                      </g>
                      <clipPath id="eBN9jzcwViv383">
                        <rect
                          width="34.16"
                          height="45.44"
                          rx="0"
                          ry="0"
                          transform="translate(208.19 88.593)"
                          fill="none"
                        />
                      </clipPath>
                    </g>
                  </g>
                </g>
                <g opacity="0.11">
                  <g>
                    <g clip-path="url(#eBN9jzcwViv390)">
                      <g>
                        <path
                          d="M274.54,139.513c-.775049,1.761681-1.649799,3.477793-2.62,5.14-10.629714,18.333619-31.09126,28.650905-52.152362,26.296686s-38.739553-16.93481-45.058813-37.162993-.084489-42.279234,15.891175-56.203693c2.06,1.26,4.12,2.53,6.17,3.79q.24.165.48.3c.41.26.82.52,1.23.77-16.656215,12.906389-22.171968,35.616866-13.291317,54.725461s29.796654,29.535008,50.401317,25.124539h.01c6.242088-1.329637,12.125143-3.986391,17.25-7.79h.01c2.554288-1.882029,4.903843-4.027129,7.01-6.4c2.111141-2.366934,3.964875-4.951435,5.53-7.71c1.217669-2.125978,2.254646-4.350462,3.1-6.65.1.09.2.18.29.27l1.22,1.13q2.34,2.19,4.53,4.37"
                          fill="#423c3e"
                        />
                      </g>
                      <clipPath id="eBN9jzcwViv390">
                        <rect
                          width="102.26"
                          height="93.66"
                          rx="0"
                          ry="0"
                          transform="translate(172.28 77.583)"
                          fill="none"
                        />
                      </clipPath>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <clipPath id="eBN9jzcwViv392">
            <rect
              width="279.14"
              height="171.243"
              rx="0"
              ry="0"
              fill="none"
            />
          </clipPath>
        </g>
      </g>
      <g
        id="eBN9jzcwViv394_to"
        transform="translate(151.182479,301.334683)"
      >
        <g
          id="eBN9jzcwViv394"
          transform="scale(0.170459,0.17046) translate(-101.529999,-89.485)"
          opacity="0"
          clip-path="url(#eBN9jzcwViv435)"
        >
          <g>
            <g>
              <g>
                <path
                  d="M201.14,152.04c.001663,14.856482-12.033525,26.905098-26.89,26.92h-.03c-.17,0-.34-.01-.51-.02-.04026.001654-.080569-.001705-.12-.01-.17,0-.34-.01-.51-.02h-.04c-4.719852-.201852-9.300524-1.658554-13.27-4.22-.09-.06-.18-.12-.27-.17-.01-.01-.03-.02-.04-.03-.24-.15-.47-.3-.7-.46l-.51-.36c-.23-.17-.46-.34-.69-.52-.090696-.057627-.177546-.121094-.26-.19-.17-.13-.34-.26-.51-.41-.038969-.023348-.075781-.05012-.11-.08-.948635-.818653-1.84068-1.700675-2.67-2.64h-105.71c-5.110745,5.813123-12.479716,9.140457-20.22,9.13-.46,0-.93-.01-1.38-.03-14.578914-.754587-25.901451-12.988605-25.527255-27.582237s12.308827-26.231313,26.907255-26.237763c.42,0,.83.01,1.24.03.26.01.52.03.78.05.025722-.010041.054278-.010041.08,0c9.895205.773007,18.563707,6.924722,22.56,16.01h6.73c-.01-.11-.03-.22-.05-.33h-4.75v-.07h4.74c-2.6-17.35-20.77-32.62-40.51-32.62-2.198093,0-3.98-1.781907-3.98-3.98s1.781907-3.98,3.98-3.98c24.62,0,46.45,18.63,48.51,40.46h66.1c2.21-17.73,16.79-36.45,35.67-39.24.02,0,.05-.01.07-.01l-1.53-6.52-.08-.35-.06-.25-9.61-40.89-5.82-24.78h-10.74v-7.96h9.54c2.002014.054463,3.91449-.829641,5.17-2.39c1.183704-1.597112,1.621057-3.627158,1.2-5.57-.4-2.79-3.58-5.17-6.77-5.17h-9.14v-7.55h9.54c7.16,0,13.53,4.77,14.72,11.53.810209,4.253367-.360197,8.64423-3.18,11.93-.840173.892968-1.775769,1.691075-2.79,2.38l7.09,30.36l16.37,70.08.07.3c-.07,0-.13.01-.2.01c10.840168,3.761422,18.108622,13.975788,18.11,25.45"
                  fill="#089da7"
                />
                <path
                  d="M59.41,140.8h-4.74v.07h4.75c.002372-.023799-.00106-.047817-.01-.07"
                  fill="#0d8184"
                />
                <path
                  d="M151.67,162.28h-102.07c-1.184952,2.702238-2.714295,5.239938-4.55,7.55h111.17c-1.839226-2.307616-3.368855-4.845792-4.55-7.55m31.49-36L166.79,56.2L159.7,25.84c1.014231-.688925,1.949827-1.487032,2.79-2.38c2.819803-3.28577,3.990209-7.676633,3.18-11.93C164.48,4.77,158.11,0,150.95,0h-9.54v7.55h9.14c3.19,0,6.37,2.38,6.77,5.17.421057,1.942842-.016296,3.972888-1.2,5.57-1.25551,1.560359-3.167986,2.444463-5.17,2.39h-9.54v7.96h10.74l5.82,24.78l9.61,40.89.06.25.08.35l1.53,6.52c-.02,0-.05.01-.07.01-18.88,2.79-33.46,21.51-35.67,39.24h-66.1c-2.06-21.83-23.89-40.46-48.51-40.46-2.198093,0-3.98,1.781907-3.98,3.98s1.781907,3.98,3.98,3.98c19.74,0,37.91,15.27,40.51,32.62h6.19v.07h-6.18c.02.11.04.22.05.33h-8.11c.651599,2.599756.98074,5.269829.98,7.95h96.58c.003198-2.680542.335688-5.35054.99-7.95h-8.5c1.98-14.32,14.31-30.23,29.43-32.22l.64,2.7v.03l3.17,13.4v.01l.67,2.85c2.50468-.770332,5.093622-1.233723,7.71-1.38.07,0,.13-.01.2-.01Z"
                  fill="#0d8184"
                />
                <path
                  d="M54.85,149.15c-.284389-2.74383-.996332-5.426269-2.11-7.95-3.996293-9.085278-12.664795-15.236993-22.56-16.01-.025722-.010041-.054278-.010041-.08,0-.26-.02-.52-.04-.78-.05-.41-.02-.82-.03-1.24-.03-14.598428.00645-26.533059,11.64413-26.907255,26.237763s10.948341,26.82765,25.527255,27.582237c.45.02.92.03,1.38.03c7.142255.005574,13.993729-2.828522,19.045005-7.877922s7.887917-11.899822,7.884995-19.042078c.002372-.965611-.05105-1.930552-.16-2.89M28.08,172.13c-8.130601-.000001-15.460422-4.898291-18.570933-12.410374s-1.389007-16.158236,4.361626-21.906008s14.397641-7.464974,21.908176-4.350725s12.405176,10.446507,12.401131,18.577107c.001594,5.330421-2.115886,10.442833-5.886001,14.211072s-8.88358,5.883175-14.213999,5.878928"
                />
                <path
                  d="M28.08,138.04c-7.731986,0-14,6.268014-14,14s6.268014,14,14,14s14-6.268014,14-14c.001593-3.713519-1.472892-7.275399-4.098746-9.901254s-6.187735-4.100339-9.901254-4.098746m7.31,14c.002655,1.937812-.765278,3.797166-2.134582,5.168345s-3.227604,2.141657-5.165418,2.141655h-.01c-1.939139.001328-3.799238-.768404-5.170417-2.139583s-2.140911-3.231278-2.139583-5.170417c-.00165-.043573.001705-.087192.01-.13.059627-3.987259,3.312301-7.186464,7.3-7.18h.01c3.983586-.000454,7.229891,3.196867,7.29,7.18.008295.042808.01165.086427.01.13"
                />
                <path
                  d="M183.03,126.59c-2.696881-.934474-5.526079-1.430766-8.38-1.47h-.11c-.02-.01-.03,0-.05,0h-.09c-.05962-.008312-.119827-.011656-.18-.01-6.488294-.009073-12.759571,2.335994-17.65,6.6-.09485.070783-.185037.147609-.27.23-2.880583,2.569095-5.175688,5.726995-6.73,9.26-1.121478,2.521624-1.836988,5.204785-2.12,7.95-.10895.959448-.162372,1.924389-.16,2.89.006699,6.549042,2.395169,12.872091,6.72,17.79.82932.939325,1.721365,1.821347,2.67,2.64.034219.02988.071031.056652.11.08.17.15.34.28.51.41.082454.068906.169304.132373.26.19.23.18.46.35.69.52l.51.36c.23.16.46.31.7.46.01.01.03.02.04.03.09.05.18.11.27.17c3.969476,2.561446,8.550148,4.018148,13.27,4.22h.04c.17.01.34.02.51.02.039431.008295.07974.011654.12.01.17.01.34.02.51.02h.03c13.139708-.017402,24.348112-9.515855,26.520707-22.474715s-5.325132-25.593457-17.740707-29.895285m-8.81,45.54c-8.13151.004045-15.4644-4.89168-18.578063-12.403443s-1.394627-16.159554,4.355219-21.909401s14.397639-7.468881,21.909401-4.355219s12.407488,10.446553,12.403443,18.578063c-.001656,11.094714-8.995286,20.088344-20.09,20.09"
                />
                <path
                  d="M174.22,138.04c-5.66338-.004045-10.771356,3.404379-12.941441,8.635499s-.974774,11.254409,3.02841,15.260455s10.025618,5.20566,15.258287,3.039313s8.644743-7.271886,8.644744-12.935267v-.13c-.067501-7.678874-6.31083-13.86865-13.99-13.87m7.3,14c.011044,3.739828-2.810437,6.881048-6.53,7.27-.255651.028539-.512768.041896-.77.04-4.030146-.016983-7.293017-3.279854-7.31-7.31-.00165-.043573.001705-.087192.01-.13.026162-2.115558.976021-4.113916,2.6-5.47c1.31731-1.104136,2.981157-1.709493,4.7-1.71.257232-.001896.514349.011461.77.04c3.661559.397922,6.455413,3.457449,6.52,7.14.008295.042808.01165.086427.01.13"
                />
                <path
                  d="M56.17,152.04c.002754,1.100432-.070756,2.199732-.22,3.29-.01.15-.03.3-.05.44-.04.29-.09.57-.14.86-.04.22-.08.45-.13.66-.188126.922896-.428513,1.834364-.72,2.73-.08.25-.16.49-.25.73-.1.31-.22.61-.34.92-.08.2-.17.41-.26.61c0,.02-.01.03-.02.05-.1.22-.2.45-.3.68-.03.05-.04.09-.07.14-.11.23-.23.47-.35.71s-.25.49-.39.74-.27.49-.42.73-.28.48-.44.71-.3.48-.46.71l-.48.69c-.49.67-1.02,1.33-1.58,1.96-.13.14-.26.29-.39.43-.21.23-.43.47-.65.69l-.11.11c-.19.19-.38.37-.56.55-.47.45-.96.88-1.46,1.29-.17.14-.34.28-.51.41-.22.17-.45.34-.68.51-.21.16-.42.31-.63.46-.67.46-1.36.9-2.06,1.31-.16.08-.3.17-.45.25-.17.09-.35.19-.52.28-.49.26-.99.5-1.5.73-1.364705.616361-2.77571,1.12459-4.22,1.52-.2.05-.41.1-.62.16s-.42.1-.64.15-.42.09-.63.13c-.29.06-.58.12-.87.17l-.6.09c-.24.04-.47.08-.71.1l-.52.06c-.41.05-.82.09-1.24.11-.17.01-.34.02-.51.02-.039431.008295-.07974.011654-.12.01-.18.01-.35.02-.54.02-.24,0-.49.01-.73.01s-.48-.01-.72-.01c-.19,0-.36-.01-.54-.02-.04026.001654-.080569-.001705-.12-.01-.17,0-.35-.01-.51-.02-.21-.01-.42-.03-.62-.05l-.62-.06c-.15-.01-.29-.03-.43-.05-.27-.03-.53-.06-.8-.11l-.6-.09c-.82-.14-1.62-.31-2.4-.52-.3-.08-.59-.15-.88-.24-.24-.07-.48-.14-.72-.22-.34-.11-.68-.23-1.01-.35-.27-.09-.53-.2-.79-.3-.01,0-.02-.01-.03-.01-.26-.11-.53-.21-.79-.34-.02417-.003284-.047743-.01002-.07-.02-.25-.11-.49-.22-.74-.34-.015037-.002504-.028974-.009473-.04-.02-.26-.12-.53-.25-.79-.39-.31-.16-.62-.32-.92-.49-.21-.11-.42-.24-.63-.36-.23-.14-.47-.29-.71-.43-.011395-.012352-.024951-.022519-.04-.03-.23-.15-.46-.3-.69-.46-.51-.34-1-.7-1.47-1.07-.2-.16-.41-.32-.61-.49-.913065-.75174-1.778096-1.559992-2.59-2.42-.18-.2-.37-.4-.55-.6-.051314-.067926-.108176-.131477-.17-.19-.33-.39-.65-.78-.96-1.19-.360008-.449376-.697103-.916637-1.01-1.4-.15-.21-.29-.43-.43-.64-.17-.27-.34-.54-.5-.82-.13-.22-.25-.44-.37-.66-.020428-.027751-.03723-.057995-.05-.09-.17-.31-.33-.62-.49-.93-.008335-.027262-.018355-.05398-.03-.08-.17-.34-.33-.69-.48-1.03s-.29-.66-.41-1c-.008157-.024081-.018188-.047486-.03-.07-.14-.35-.26-.71-.38-1.08q-.09-.255-.18-.54c-.11-.36-.21-.72-.31-1.08-.250858-.947513-.44454-1.909247-.58-2.88-.030462-.145049-.050513-.292091-.06-.44-.04-.31-.08-.62-.1-.93-.07-.78-.11-1.56-.11-2.36-.000742-.999396.059369-1.99791.18-2.99s0-.06.01-.15c.03-.3.08-.6.12-.9.215596-1.370277.539954-2.721212.97-4.04.26-.77.54-1.52.86-2.25.485116-1.125462,1.049882-2.214892,1.69-3.26.98395-1.605794,2.133569-3.103985,3.43-4.47.34-.37.7-.73,1.06-1.07.12-.12.24-.23.37-.34c2.328214-2.139048,5.002943-3.86697,7.91-5.11c3.154542-1.361261,6.528307-2.14373,9.96-2.31.25-.02.51-.02.76-.03s.51-.01.76-.01c.42,0,.83.01,1.24.03.26.01.52.03.78.05.025722-.010041.054278-.010041.08,0c3.261755.219422,6.461598.997396,9.46,2.3.02.01.05.02.07.03c2.546324,1.104128,4.912645,2.583922,7.02,4.39q.375.315.75.66c.13.11.24.22.36.34.36.34.72.69,1.07,1.05.54.58,1.06,1.18,1.54,1.8c1.325712,1.674054,2.446969,3.500293,3.34,5.44.08.17.16.34.23.51.887842,2.023814,1.506449,4.15532,1.84,6.34.06.36.1.73.14,1.1.112017.959278.168778,1.924204.17,2.89"
                  fill="#404040"
                />
                <path
                  d="M11.223,151.906c0,9.311521,7.548479,16.86,16.86,16.86s16.86-7.548479,16.86-16.86-7.548479-16.86-16.86-16.86c-4.47155,0-8.759957,1.776316-11.92182,4.93818s-4.93818,7.45027-4.93818,11.92182"
                  fill="#a8969b"
                />
                <path
                  d="M35.99,144.01c-1.692425-1.704841-3.892829-2.813817-6.27-3.16-.539716-.079369-1.08448-.119474-1.63-.12-2.959594.000476-5.797755,1.176748-7.89,3.27l-.01.01c-2.09404,2.092535-3.273475,4.929651-3.28,7.89v.01c-.001428.77299.07902,1.543957.24,2.3.115505.530415.26924,1.051776.46,1.56c1.425588,3.829888,4.818664,6.583412,8.86,7.19c3.492023.517518,7.022146-.655478,9.51-3.16h.01c.750258-.75256,1.389964-1.607746,1.9-2.54.26371-.477506.487795-.975844.67-1.49.27278-.720372.467233-1.468011.58-2.23.079369-.539716.119474-1.08448.12-1.63v-.01c-.005071-2.958677-1.180644-5.795152-3.27-7.89m-2.73,7.9c-.000094.254513-.020155.508626-.06.76-.149917,1.097338-.65993,2.113846-1.45,2.89h-.01c-.059635.07965-.13035.150365-.21.21-.184791.167985-.38202.321757-.59.46-.84437.561519-1.835967.860737-2.85.86-.254235.00263-.508301-.014085-.76-.05-1.001983-.149801-1.937612-.59153-2.69-1.27-.08-.06-.15-.13-.22-.19-.11-.11-.21-.23-.31-.34-.779664-.934734-1.207727-2.11279-1.21-3.33v-.01c.000509-.244544.020573-.488655.06-.73.161268-1.106711.677064-2.131286,1.47-2.92v-.01c.972628-.965848,2.289293-1.505464,3.66-1.5.250772.001725.501218.018421.75.05c1.101512.159359,2.120298.675778,2.9,1.47.970983.962639,1.518046,2.272712,1.52,3.64Z"
                  fill="#d3cbcd"
                />
                <path
                  d="M28.292,138.682c1.041.777,1.909,2.04,1.468,3.306-.26.551-.9,1.1-1.024,1.653-.097772.590397.066932,1.194067.451,1.653.789609.984027,1.140387,2.249181.970223,3.499315s-.84633,2.375505-1.870223,3.112685h-.4c-1.023893-.73718-1.70006-1.86255-1.870223-3.112685s.180614-2.515288.970223-3.499315c.384068-.458933.548772-1.062603.451-1.653-.123-.551-.764-1.1-1.024-1.653-.441-1.268.427-2.526,1.468-3.306h.4"
                  fill="#939393"
                />
                <path
                  d="M18.883,142.414c1.285-.186,2.792.092,3.376,1.3.2.574.142,1.417.444,1.894.348674.486213.89202.796228,1.488.849c1.254126.136775,2.397039.782619,3.161247,1.786374s1.082634,2.277322.880753,3.522626l-.282.283c-1.245305.201575-2.518748-.117125-3.522305-.881515s-1.649151-1.907382-1.785695-3.161485c-.053533-.595986-.363815-1.13916-.85-1.488-.477-.3-1.32-.239-1.893-.444-1.209-.585-1.484-2.089-1.3-3.376l.283-.283"
                  fill="#939393"
                />
                <path
                  d="M14.868,151.706c.777-1.041,2.04-1.909,3.306-1.468.551.26,1.1.9,1.653,1.024.590397.097772,1.194067-.066932,1.653-.451.983392-.790129,2.248121-1.141728,3.498213-.972516s2.375838.844386,3.113787,1.867516v.4c-.73718,1.023893-1.86255,1.70006-3.112685,1.870223s-2.515288-.180614-3.499315-.970223c-.458933-.384068-1.062603-.548772-1.653-.451-.551.123-1.1.764-1.653,1.024-1.268.441-2.526-.427-3.306-1.468v-.4"
                  fill="#939393"
                />
                <path
                  d="M18.6,161.115c-.187-1.285.092-2.792,1.3-3.376.574-.206,1.417-.142,1.894-.444.486213-.348674.796228-.89202.849-1.488.136522-1.254307.782259-2.397477,1.786045-3.161898s2.277495-1.082979,3.522955-.881102l.282.283c.20158,1.24515-.116988,2.518449-.881165,3.521975s-1.906914,1.649228-3.160835,1.786025c-.595986.053533-1.13916.363815-1.488.85-.3.477-.239,1.32-.444,1.893-.585,1.209-2.089,1.484-3.376,1.3l-.283-.283"
                  fill="#939393"
                />
                <path
                  d="M27.892,165.13c-1.041-.777-1.909-2.04-1.468-3.306.26-.551.9-1.1,1.024-1.653.098595-.589953-.064999-1.19357-.448-1.653-.789609-.984027-1.140387-2.249181-.970223-3.499315s.84633-2.375505,1.870223-3.112685h.4c1.023893.73718,1.70006,1.86255,1.870223,3.112685s-.180614,2.515288-.970223,3.499315c-.384068.458933-.548772,1.062603-.451,1.653.123.551.764,1.1,1.024,1.653.441,1.268-.428,2.526-1.468,3.306h-.4"
                  fill="#939393"
                />
                <path
                  d="M37.3,161.4c-1.285.186-2.792-.093-3.376-1.3-.2-.574-.142-1.417-.444-1.894-.348674-.486213-.89202-.796228-1.488-.849-1.254126-.136775-2.397039-.782619-3.161247-1.786374s-1.082634-2.277322-.880753-3.522626l.282-.283c1.245305-.201575,2.518748.117125,3.522305.881515s1.649151,1.907382,1.785695,3.161485c.053533.595986.363815,1.13916.85,1.488.477.3,1.32.239,1.893.444c1.209.585,1.484,2.089,1.3,3.376l-.283.283"
                  fill="#939393"
                />
                <path
                  d="M41.316,152.106c-.777,1.04-2.04,1.909-3.306,1.468-.551-.26-1.1-.9-1.653-1.025-.591671-.09844-1.196837.066273-1.657.451-.984027.789609-2.249181,1.140387-3.499315.970223s-2.375505-.84633-3.112685-1.870223v-.4c.737949-1.02313,1.863694-1.698303,3.113787-1.867516s2.514821.182387,3.498213.972516c.458933.384068,1.062603.548772,1.653.451.551-.124,1.1-.764,1.653-1.024c1.268-.441,2.526.427,3.306,1.468v.4"
                  fill="#939393"
                />
                <path
                  d="M37.584,142.7c.186,1.285-.092,2.792-1.3,3.376-.574.206-1.417.142-1.894.444-.486213.348674-.796228.89202-.849,1.488-.136522,1.254307-.782259,2.397477-1.786045,3.161898s-2.277495,1.082979-3.522955.881102l-.283-.283c-.201575-1.245305.117125-2.518748.881515-3.522305s1.907382-1.649151,3.161485-1.785695c.595986-.053533,1.13916-.363815,1.488-.85.3-.477.239-1.32.444-1.893.585-1.209,2.089-1.484,3.376-1.3l.283.283"
                  fill="#939393"
                />
                <path
                  d="M183.23,126.58c-.07,0-.13.01-.2.01-2.616378.146277-5.20532.609668-7.71,1.38l-.67-2.85v-.01l-3.17-13.4v-.03l-2.3-10.24-1.46-6.53-.08-.35-.06-.25-9.61-40.89-5.82-24.78h-10.74v-7.96h9.54c2.002014.054463,3.91449-.829641,5.17-2.39c1.183704-1.597112,1.621057-3.627158,1.2-5.57-.4-2.79-3.58-5.17-6.77-5.17h-9.14v-7.55h9.54c7.16,0,13.53,4.77,14.72,11.53.810209,4.253367-.360197,8.64423-3.18,11.93-.840173.892968-1.775769,1.691075-2.79,2.38l7.09,30.36l16.37,70.08Z"
                  fill="#414c4c"
                />
                <path
                  d="M203.06,152.04c.001065,1.100049-.069082,2.199014-.21,3.29-.02.15-.03.3-.06.44-.04.29-.08.57-.14.86-.03.22-.08.45-.12.66-.192828.921791-.433149,1.833006-.72,2.73-.08.25-.17.49-.25.73-.11.31-.23.61-.35.92l-.27.66c-.1.22-.2.45-.31.68-.02.05-.04.09-.06.14-.12.23-.23.47-.35.71s-.26.49-.4.74-.27.49-.41.73-.29.48-.45.71-.3.48-.46.71-.32.46-.48.69c-.49.67-1.02,1.33-1.58,1.96-.34.38-.68.76-1.04,1.12l-.11.11c-.19.19-.37.37-.56.55-.47.45-.96.88-1.46,1.29-.17.14-.34.28-.51.41-.22.17-.44.34-.67.51s-.43.31-.64.46c-.66.46-1.35.9-2.06,1.31-.15.08-.3.17-.45.25-.17.09-.34.19-.51.28-.5.26-1,.5-1.51.73-1.361919.614764-2.769475,1.122955-4.21,1.52-.21.05-.42.1-.63.16l-.63.15c-.21.05-.43.09-.64.13-.29.06-.57.12-.86.17l-.61.09c-.23.04-.47.08-.7.1l-.52.06c-.42.05-.83.09-1.24.11-.17.01-.34.02-.52.02-.036114.007858-.073061.011217-.11.01-.19.01-.36.02-.55.02-.24,0-.48.01-.72.01s-.49-.01-.73-.01h-.03c-.17,0-.34-.01-.51-.02-.04026.001654-.080569-.001705-.12-.01-.17,0-.34-.01-.51-.02h-.04c-.19-.01-.38-.03-.58-.05l-.62-.06c-.14-.01-.28-.03-.43-.05-.26-.03-.53-.06-.79-.11l-.61-.09c-.82-.14-1.61-.31-2.4-.52-.29-.08-.59-.15-.87-.24-.24-.07-.49-.14-.72-.22-.35-.11-.68-.23-1.02-.35-.26-.09-.53-.2-.79-.3-.01,0-.01-.01-.02-.01-.27-.11-.54-.21-.8-.34-.021249-.002071-.041758-.008908-.06-.02-.25-.11-.5-.22-.75-.34-.01,0-.02-.01-.03-.02-.27-.12-.54-.25-.8-.39-.31-.16-.61-.32-.91-.49-.22-.11-.43-.24-.63-.36-.15-.09-.3-.18-.44-.26-.09-.06-.18-.12-.27-.17-.01-.01-.03-.02-.04-.03-.24-.15-.47-.3-.7-.46l-.51-.36c-.23-.17-.46-.34-.69-.52-.090696-.057627-.177546-.121094-.26-.19-.17-.13-.34-.26-.51-.41-.038969-.023348-.075781-.05012-.11-.08-.912107-.749252-1.773966-1.557662-2.58-2.42-.07-.07-.14-.15-.2-.22-.12-.13-.24-.25-.35-.38-.06-.07-.12-.13-.17-.19-.34-.39-.66-.78-.97-1.19-.360004-.449379-.697099-.91664-1.01-1.4-.15-.21-.28-.43-.42-.64-.18-.27-.34-.54-.51-.82-.12-.22-.25-.44-.37-.66-.020474-.027721-.03728-.057971-.05-.09q-.255-.465-.48-.93c-.011324-.027625-.024695-.054366-.04-.08-.17-.34-.33-.69-.48-1.03-.02-.05-.04-.09-.06-.14-.12-.29-.24-.57-.35-.86-.00998-.022257-.016716-.04583-.02-.07q-.21-.525-.39-1.08c-.06-.17-.12-.35-.17-.54-.11-.36-.22-.72-.31-1.08-.254192-.947312-.451213-1.909046-.59-2.88-.02-.14-.04-.29-.05-.44-.05-.31-.08-.62-.11-.93-.07-.78-.11-1.56-.11-2.36.000927-.965804.057689-1.930748.17-2.89c0-.03.01-.07.01-.1c0,0,.01-.06.02-.15q.045-.45.12-.9c.210822-1.37122.535272-2.72254.97-4.04.25-.77.53-1.52.85-2.25.07-.17.15-.34.23-.51c1.217177-2.661841,2.869858-5.101995,4.89-7.22.34-.37.7-.73,1.07-1.07.12-.12.23-.23.36-.34q.36-.33.72-.63c.084963-.082391.17515-.159217.27-.23c2.084767-1.749743,4.41661-3.181873,6.92-4.25c3.154896-1.360183,6.528463-2.142607,9.96-2.31.26-.02.51-.02.76-.03h.28c.02,0,.03-.01.05,0c.036114-.007858.073061-.011217.11-.01h.33c2.768552-.002679,5.523207.391325,8.18,1.17c1.148404.329766,2.274118.733954,3.37,1.21.03.01.05.02.08.03c2.543204,1.104259,4.906207,2.584085,7.01,4.39.26.21.5.43.75.66.13.11.24.22.37.34.36.34.72.69,1.06,1.05.54.58,1.06,1.18,1.55,1.8c1.44096,1.82153,2.640866,3.821374,3.57,5.95.883339,2.025444,1.501774,4.156353,1.84,6.34.201174,1.320452.301464,2.654312.3,3.99"
                  fill="#404040"
                />
                <path
                  d="M158.117,151.906c0,9.311521,7.548479,16.86,16.86,16.86s16.86-7.548479,16.86-16.86-7.548479-16.86-16.86-16.86c-4.47155,0-8.759957,1.776316-11.92182,4.93818s-4.93818,7.45027-4.93818,11.92182"
                  fill="#a8969b"
                />
                <path
                  d="M182.88,144.02v-.01c-2.091094-2.097962-4.930812-3.277995-7.892926-3.279871s-5.803324,1.174559-7.897074,3.269871v.01c-2.100495,2.089028-3.284114,4.927554-3.29,7.89v.01c-.003087.773611.080773,1.545119.25,2.3.107499.53133.257994,1.053047.45,1.56.559072,1.516157,1.443071,2.891647,2.59,4.03h.01c1.686056,1.708049,3.884476,2.817795,6.26,3.16c3.495017.517385,7.028093-.655358,9.52-3.16.750343-.75489,1.393058-1.609599,1.91-2.54.255529-.481553.479339-.979278.67-1.49.269459-.72073.46056-1.468369.57-2.23.079369-.539716.119474-1.08448.12-1.63v-.01c-.0006-2.956632-1.177055-5.791638-3.27-7.88m-2.73,7.89c-.000089.254513-.020151.508626-.06.76-.146449,1.0963-.652979,2.112877-1.44,2.89h-.01c-.06561.077669-.139365.148072-.22.21-.182806.170327-.380233.324253-.59.46-.840057.562759-1.828867.862187-2.84.86-.254252.003277-.508369-.013441-.76-.05-1.004979-.149694-1.943846-.591309-2.7-1.27-.07-.06-.15-.13-.21-.19-.11-.11-.22-.23-.32-.34-.780872-.933359-1.205998-2.113085-1.2-3.33v-.01c.002061-.244114.018758-.487885.05-.73.160559-1.109048.680468-2.134815,1.48-2.92v-.01c.971508-.967537,2.288906-1.507454,3.66-1.5.247437.002055.494536.018751.74.05c1.104441.159265,2.126436.675531,2.91,1.47.964246.966335,1.507074,2.274875,1.51,3.64Z"
                  fill="#d3cbcd"
                />
                <path
                  d="M175.186,138.682c1.041.777,1.909,2.04,1.468,3.306-.26.551-.9,1.1-1.024,1.653-.097772.590397.066932,1.194067.451,1.653.790129.983392,1.141728,2.248121.972516,3.498213s-.844386,2.375838-1.867516,3.113787h-.4c-1.02313-.737949-1.698303-1.863694-1.867516-3.113787s.182387-2.514821.972516-3.498213c.384068-.458933.548772-1.062603.451-1.653-.123-.551-.764-1.1-1.024-1.653-.441-1.268.427-2.526,1.468-3.306h.4"
                  fill="#939393"
                />
                <path
                  d="M165.777,142.414c1.285-.186,2.792.092,3.376,1.3.205.574.142,1.417.444,1.894.348674.486213.89202.796228,1.488.849c1.254126.136775,2.397039.782619,3.161247,1.786374s1.082634,2.277322.880753,3.522626l-.282.283c-1.245305.201575-2.518748-.117125-3.522305-.881515s-1.649151-1.907382-1.785695-3.161485c-.053533-.595986-.363815-1.13916-.85-1.488-.477-.3-1.32-.239-1.893-.444-1.209-.585-1.484-2.089-1.3-3.376l.283-.283"
                  fill="#939393"
                />
                <path
                  d="M161.762,151.706c.777-1.041,2.04-1.909,3.306-1.468.551.26,1.1.9,1.653,1.024.590397.097772,1.194067-.066932,1.653-.451.983392-.790129,2.248121-1.141728,3.498213-.972516s2.375838.844386,3.113787,1.867516v.4c-.73718,1.023893-1.86255,1.70006-3.112685,1.870223s-2.515288-.180614-3.499315-.970223c-.458933-.384068-1.062603-.548772-1.653-.451-.551.123-1.1.764-1.653,1.024-1.268.441-2.526-.428-3.306-1.468v-.4"
                  fill="#939393"
                />
                <path
                  d="M165.494,161.115c-.186-1.285.092-2.792,1.3-3.376.574-.206,1.417-.142,1.894-.444.486213-.348674.796228-.89202.849-1.488.136522-1.254307.782259-2.397477,1.786045-3.161898s2.277495-1.082979,3.522955-.881102l.283.283c.201575,1.245305-.117125,2.518748-.881515,3.522305s-1.907382,1.649151-3.161485,1.785695c-.595986.053533-1.13916.363815-1.488.85-.3.477-.239,1.32-.444,1.893-.585,1.209-2.089,1.484-3.376,1.3l-.283-.283"
                  fill="#939393"
                />
                <path
                  d="M174.786,165.13c-1.041-.777-1.909-2.04-1.468-3.306.26-.551.9-1.1,1.024-1.653.097772-.590397-.066932-1.194067-.451-1.653-.790129-.983392-1.141728-2.248121-.972516-3.498213s.844386-2.375838,1.867516-3.113787h.4c1.02313.737949,1.698303,1.863694,1.867516,3.113787s-.182387,2.514821-.972516,3.498213c-.384068.458933-.548772,1.062603-.451,1.653.123.551.764,1.1,1.024,1.653.441,1.268-.428,2.526-1.468,3.306h-.4"
                  fill="#939393"
                />
                <path
                  d="M184.2,161.4c-1.285.186-2.792-.093-3.376-1.3-.205-.574-.142-1.417-.444-1.894-.348674-.486213-.89202-.796228-1.488-.849-1.254126-.136775-2.397039-.782619-3.161247-1.786374s-1.082634-2.277322-.880753-3.522626l.282-.283c1.245305-.201575,2.518748.117125,3.522305.881515s1.649151,1.907382,1.785695,3.161485c.053533.595986.363815,1.13916.85,1.488.477.3,1.32.239,1.893.444c1.209.585,1.484,2.089,1.3,3.376l-.283.283"
                  fill="#939393"
                />
                <path
                  d="M188.21,152.106c-.777,1.04-2.04,1.909-3.306,1.468-.551-.26-1.1-.9-1.653-1.025-.589718-.09662-1.192303.067987-1.651.451-.984027.789609-2.249181,1.140387-3.499315.970223s-2.375505-.84633-3.112685-1.870223v-.4c.737949-1.02313,1.863694-1.698303,3.113787-1.867516s2.514821.182387,3.498213.972516c.458933.384068,1.062603.548772,1.653.451.551-.124,1.1-.764,1.653-1.024c1.268-.441,2.526.427,3.306,1.468v.4"
                  fill="#939393"
                />
                <path
                  d="M184.478,142.7c.187,1.285-.092,2.792-1.3,3.376-.574.206-1.417.142-1.894.444-.486213.348674-.796228.89202-.849,1.488-.136522,1.254307-.782259,2.397477-1.786045,3.161898s-2.277495,1.082979-3.522955.881102l-.282-.283c-.20158-1.24515.116988-2.518449.881165-3.521975s1.906914-1.649228,3.160835-1.786025c.595986-.053533,1.13916-.363815,1.488-.85.3-.477.239-1.32.444-1.893.585-1.209,2.089-1.484,3.376-1.3l.283.283"
                  fill="#939393"
                />
                <g opacity="0.11">
                  <g>
                    <g clip-path="url(#eBN9jzcwViv433)">
                      <g>
                        <path
                          d="M119.01,150.65q0,5.9-.38,11.63-.255,3.81-.66,7.55h-68.81c-.21.23-.43.47-.65.69l-.11.11c-.19.19-.38.37-.56.55-.47.45-.96.88-1.46,1.29-.17.14-.34.28-.51.41-.22.17-.45.34-.68.51-.21.16-.42.31-.63.46-.67.46-1.36.9-2.06,1.31-.16.08-.3.17-.45.25-.17.09-.35.19-.52.28-.49.26-.99.5-1.5.73-1.364705.616361-2.77571,1.12459-4.22,1.52-.2.05-.41.1-.62.16s-.42.1-.64.15-.42.09-.63.13c-.29.06-.58.12-.87.17l-.6.09c-.24.04-.47.08-.71.1l-.52.06c-.41.05-.82.09-1.24.11-.17.01-.34.02-.51.02-.039431.008295-.07974.011654-.12.01-.18.01-.35.02-.54.02-.24,0-.49.01-.73.01s-.48-.01-.72-.01c-.19,0-.36-.01-.54-.02-.04026.001654-.080569-.001705-.12-.01-.17,0-.35-.01-.51-.02-.21-.01-.42-.03-.62-.05l-.62-.06c-.15-.01-.29-.03-.43-.05-.27-.03-.53-.06-.8-.11l-.6-.09c-.82-.14-1.62-.31-2.4-.52-.3-.08-.59-.15-.88-.24-.24-.07-.48-.14-.72-.22-.34-.11-.68-.23-1.01-.35-.27-.09-.53-.2-.79-.3-.01,0-.02-.01-.03-.01-.26-.11-.53-.21-.79-.34-.02417-.003284-.047743-.01002-.07-.02-.25-.11-.49-.22-.74-.34-.015037-.002504-.028974-.009473-.04-.02-.26-.12-.53-.25-.79-.39-.31-.16-.62-.32-.92-.49-.21-.11-.42-.24-.63-.36-.23-.14-.47-.29-.71-.43-.011395-.012352-.024951-.022519-.04-.03-.23-.15-.46-.3-.69-.46-.51-.34-1-.7-1.47-1.07-.2-.16-.41-.32-.61-.49-.913065-.75174-1.778096-1.559992-2.59-2.42-.18-.2-.37-.4-.55-.6-.051314-.067926-.108176-.131477-.17-.19-.33-.39-.65-.78-.96-1.19-.360008-.449376-.697103-.916637-1.01-1.4-.15-.21-.29-.43-.43-.64-.17-.27-.34-.54-.5-.82-.13-.22-.25-.44-.37-.66-.020428-.027751-.03723-.057995-.05-.09-.17-.31-.33-.62-.49-.93-.008335-.027262-.018355-.05398-.03-.08-.17-.34-.33-.69-.48-1.03s-.29-.66-.41-1c-.008157-.024081-.018188-.047486-.03-.07-.14-.35-.26-.71-.38-1.08q-.09-.255-.18-.54c-.11-.36-.21-.72-.31-1.08-.250858-.947513-.44454-1.909247-.58-2.88-.030462-.145049-.050513-.292091-.06-.44-.04-.31-.08-.62-.1-.93-.07-.78-.11-1.56-.11-2.36-.000742-.999396.059369-1.99791.18-2.99s0-.06.01-.15c.03-.3.08-.6.12-.9.215596-1.370277.539954-2.721212.97-4.04.26-.77.54-1.52.86-2.25.485116-1.125462,1.049882-2.214892,1.69-3.26.98395-1.605794,2.133569-3.103985,3.43-4.47.34-.37.7-.73,1.06-1.07.12-.12.24-.23.37-.34c2.328214-2.139048,5.002943-3.86697,7.91-5.11c3.154542-1.361261,6.528307-2.14373,9.96-2.31.25-.02.51-.02.76-.03s.51-.01.76-.01c.42,0,.83.01,1.24.03.26.01.52.03.78.05.025722-.010041.054278-.010041.08,0c3.261755.219422,6.461598.997396,9.46,2.3.02.01.05.02.07.03c2.546324,1.104128,4.912645,2.583922,7.02,4.39q.375.315.75.66c.13.11.24.22.36.34.36.34.72.69,1.07,1.05.54.58,1.06,1.18,1.54,1.8c1.325712,1.674054,2.446969,3.500293,3.34,5.44h5.68c-.01-.11-.03-.22-.05-.33h-4.75v-.07h4.74c-2.6-17.35-20.77-32.62-40.51-32.62-2.198093,0-3.98-1.781907-3.98-3.98s1.781907-3.98,3.98-3.98c24.62,0,46.45,18.63,48.51,40.46h51.32q.24,4.2.27,8.47c.01.5.01,1,.01,1.5"
                          fill="#423c3e"
                        />
                      </g>
                      <clipPath id="eBN9jzcwViv433">
                        <rect
                          width="119.01"
                          height="78.75"
                          rx="0"
                          ry="0"
                          transform="translate(0 100.22)"
                          fill="none"
                        />
                      </clipPath>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <clipPath id="eBN9jzcwViv435">
            <rect
              width="203.06"
              height="178.97"
              rx="0"
              ry="0"
              fill="none"
            />
          </clipPath>
        </g>
      </g>
    </svg>
  </div>
</template>

<style>
#eBN9jzcwViv3_ts {
  animation: eBN9jzcwViv3_ts__ts 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv3_ts__ts {
  0% {
    transform: translate(250px, 359.717066px) scale(0, 1);
  }
  15.625% {
    transform: translate(250px, 359.717066px) scale(0, 1);
  }
  20.3125% {
    transform: translate(250px, 359.717066px) scale(-1, 1);
  }
  48.4375% {
    transform: translate(250px, 359.717066px) scale(-1, 1);
  }
  93.75% {
    transform: translate(250px, 359.717066px) scale(-1, 1);
  }
  100% {
    transform: translate(250px, 359.717066px) scale(0, 1);
  }
}
#eBN9jzcwViv4_ts {
  animation: eBN9jzcwViv4_ts__ts 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv4_ts__ts {
  0% {
    transform: translate(249.999917px, 363.685791px) scale(-1, 0);
  }
  34.375% {
    transform: translate(249.999917px, 363.685791px) scale(-1, 0);
  }
  39.0625% {
    transform: translate(249.999917px, 363.685791px) scale(-1, 0.44);
  }
  90% {
    transform: translate(249.999917px, 363.685791px) scale(-1, 0.44);
  }
  93.75% {
    transform: translate(249.999917px, 363.685791px) scale(-1, 0);
  }
  100% {
    transform: translate(249.999917px, 363.685791px) scale(-1, 0);
  }
}
#eBN9jzcwViv5_ts {
  animation: eBN9jzcwViv5_ts__ts 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv5_ts__ts {
  0% {
    transform: translate(249.999978px, 326.305353px) scale(0, 1);
  }
  15.625% {
    transform: translate(249.999978px, 326.305353px) scale(0, 1);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  20.3125% {
    transform: translate(249.999978px, 326.305353px) scale(-0.723029, 1);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  37.5% {
    transform: translate(249.999978px, 326.305353px) scale(-0.723029, 1);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  42.1875% {
    transform: translate(249.999978px, 326.305353px) scale(0, 1);
  }
  100% {
    transform: translate(249.999978px, 326.305353px) scale(0, 1);
  }
}
#eBN9jzcwViv6_ts {
  animation: eBN9jzcwViv6_ts__ts 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv6_ts__ts {
  0% {
    transform: translate(249.999978px, 296.305353px) scale(0, 1);
  }
  15.625% {
    transform: translate(249.999978px, 296.305353px) scale(0, 1);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  20.3125% {
    transform: translate(249.999978px, 296.305353px) scale(-0.723029, 1);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  37.5% {
    transform: translate(249.999978px, 296.305353px) scale(-0.723029, 1);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  42.1875% {
    transform: translate(249.999978px, 296.305353px) scale(0, 0);
  }
  100% {
    transform: translate(249.999978px, 296.305353px) scale(0, 0);
  }
}
#eBN9jzcwViv7_ts {
  animation: eBN9jzcwViv7_ts__ts 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv7_ts__ts {
  0% {
    transform: translate(249.999978px, 266.305353px) scale(0, 1);
  }
  15.625% {
    transform: translate(249.999978px, 266.305353px) scale(0, 1);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  20.3125% {
    transform: translate(249.999978px, 266.305353px) scale(-0.723029, 1);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  37.5% {
    transform: translate(249.999978px, 266.305353px) scale(-0.723029, 1);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  42.1875% {
    transform: translate(249.999978px, 266.305353px) scale(0, 0);
  }
  100% {
    transform: translate(249.999978px, 266.305353px) scale(0, 0);
  }
}
#eBN9jzcwViv8_ts {
  animation: eBN9jzcwViv8_ts__ts 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv8_ts__ts {
  0% {
    transform: translate(249.999907px, 236.305353px) scale(0, 1);
  }
  15.625% {
    transform: translate(249.999907px, 236.305353px) scale(0, 1);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  20.3125% {
    transform: translate(249.999907px, 236.305353px) scale(-0.723029, 1);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  37.5% {
    transform: translate(249.999907px, 236.305353px) scale(-0.723029, 1);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  42.1875% {
    transform: translate(249.999907px, 236.305353px) scale(0, 0);
  }
  100% {
    transform: translate(249.999907px, 236.305353px) scale(0, 0);
  }
}
#eBN9jzcwViv10 {
  animation: eBN9jzcwViv10__sz 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv10__sz {
  0% {
    width: 25.164873px;
    height: 0px;
  }
  18.75% {
    width: 25.164873px;
    height: 0px;
  }
  23.4375% {
    width: 25.164873px;
    height: 69.962442px;
  }
  100% {
    width: 25.164873px;
    height: 69.962442px;
  }
}
#eBN9jzcwViv10_ts {
  animation: eBN9jzcwViv10_ts__ts 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv10_ts__ts {
  0% {
    transform: translate(174.338506px, 350.02528px) rotate(-180deg) scale(0.666176, 0.857603);
  }
  32.8125% {
    transform: translate(174.338506px, 350.02528px) rotate(-180deg) scale(0.666176, 0.857603);
  }
  35.9375% {
    transform: translate(174.338506px, 350.02528px) rotate(-180deg) scale(1.25, 0.857603);
  }
  81.25% {
    transform: translate(174.338506px, 350.02528px) rotate(-180deg) scale(1.25, 0.857603);
  }
  87.5% {
    transform: translate(174.338506px, 350.02528px) rotate(-180deg) scale(1.25, 0);
  }
  100% {
    transform: translate(174.338506px, 350.02528px) rotate(-180deg) scale(1.25, 0);
  }
}
#eBN9jzcwViv11 {
  animation: eBN9jzcwViv11__sz 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv11__sz {
  0% {
    width: 25.164873px;
    height: 0px;
  }
  21.875% {
    width: 25.164873px;
    height: 0px;
  }
  26.5625% {
    width: 25.164873px;
    height: 92.117215px;
  }
  100% {
    width: 25.164873px;
    height: 92.117215px;
  }
}
#eBN9jzcwViv11_ts {
  animation: eBN9jzcwViv11_ts__ts 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv11_ts__ts {
  0% {
    transform: translate(224.338523px, 350.025258px) rotate(-180deg) scale(0.666176, 0.857603);
  }
  32.8125% {
    transform: translate(224.338523px, 350.025258px) rotate(-180deg) scale(0.666176, 0.857603);
  }
  35.9375% {
    transform: translate(224.338523px, 350.025258px) rotate(-180deg) scale(1.25, 0.857603);
  }
  81.25% {
    transform: translate(224.338523px, 350.025258px) rotate(-180deg) scale(1.25, 0.857603);
  }
  87.5% {
    transform: translate(224.338523px, 350.025258px) rotate(-180deg) scale(1.25, 0);
  }
  100% {
    transform: translate(224.338523px, 350.025258px) rotate(-180deg) scale(1.25, 0);
  }
}
#eBN9jzcwViv12 {
  animation: eBN9jzcwViv12__sz 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv12__sz {
  0% {
    width: 25.164873px;
    height: 0px;
  }
  25% {
    width: 25.164873px;
    height: 0px;
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  29.6875% {
    width: 25.164873px;
    height: 149.999475px;
  }
  100% {
    width: 25.164873px;
    height: 149.999475px;
  }
}
#eBN9jzcwViv12_ts {
  animation: eBN9jzcwViv12_ts__ts 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv12_ts__ts {
  0% {
    transform: translate(273.580329px, 350.025277px) rotate(-180deg) scale(0.666176, 0.857603);
  }
  32.8125% {
    transform: translate(273.580329px, 350.025277px) rotate(-180deg) scale(0.666176, 0.857603);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  35.9375% {
    transform: translate(273.580329px, 350.025277px) rotate(-180deg) scale(1.25, 0.857603);
  }
  81.25% {
    transform: translate(273.580329px, 350.025277px) rotate(-180deg) scale(1.25, 0.857603);
  }
  87.5% {
    transform: translate(273.580329px, 350.025277px) rotate(-180deg) scale(1.25, 0);
  }
  100% {
    transform: translate(273.580329px, 350.025277px) rotate(-180deg) scale(1.25, 0);
  }
}
#eBN9jzcwViv13 {
  animation: eBN9jzcwViv13__sz 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv13__sz {
  0% {
    width: 25.164873px;
    height: 0px;
  }
  28.125% {
    width: 25.164873px;
    height: 0px;
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  32.8125% {
    width: 25.164873px;
    height: 116.60407px;
  }
  100% {
    width: 25.164873px;
    height: 116.60407px;
  }
}
#eBN9jzcwViv13_ts {
  animation: eBN9jzcwViv13_ts__ts 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv13_ts__ts {
  0% {
    transform: translate(325.449488px, 350.025228px) rotate(-180deg) scale(0.666176, 0.857603);
  }
  32.8125% {
    transform: translate(325.449488px, 350.025228px) rotate(-180deg) scale(0.666176, 0.857603);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  35.9375% {
    transform: translate(325.449488px, 350.025228px) rotate(-180deg) scale(1.25, 0.857603);
  }
  81.25% {
    transform: translate(325.449488px, 350.025228px) rotate(-180deg) scale(1.25, 0.857603);
  }
  87.5% {
    transform: translate(325.449488px, 350.025228px) rotate(-180deg) scale(1.25, 0);
  }
  100% {
    transform: translate(325.449488px, 350.025228px) rotate(-180deg) scale(1.25, 0);
  }
}
#eBN9jzcwViv14 {
  animation: eBN9jzcwViv14_c_o 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv14_c_o {
  0% {
    opacity: 0;
  }
  32.8125% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  35.9375% {
    opacity: 1;
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  75% {
    opacity: 1;
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  81.25% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#eBN9jzcwViv26 {
  animation: eBN9jzcwViv26_c_o 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv26_c_o {
  0% {
    opacity: 0;
  }
  32.8125% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  35.9375% {
    opacity: 1;
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  75% {
    opacity: 1;
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  81.25% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#eBN9jzcwViv42 {
  animation: eBN9jzcwViv42_c_o 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv42_c_o {
  0% {
    opacity: 0;
  }
  32.8125% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  35.9375% {
    opacity: 1;
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  75% {
    opacity: 1;
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  81.25% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#eBN9jzcwViv68 {
  animation: eBN9jzcwViv68_c_o 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv68_c_o {
  0% {
    opacity: 0;
  }
  32.8125% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  35.9375% {
    opacity: 1;
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  75% {
    opacity: 1;
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  81.25% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#eBN9jzcwViv89 {
  animation: eBN9jzcwViv89_c_o 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv89_c_o {
  0% {
    opacity: 0;
  }
  6.25% {
    opacity: 1;
  }
  12.5% {
    opacity: 1;
  }
  17.1875% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#eBN9jzcwViv94_ts {
  animation: eBN9jzcwViv94_ts__ts 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv94_ts__ts {
  0% {
    transform: translate(319.382454px, 309.388723px) scale(0, 0);
  }
  42.1875% {
    transform: translate(319.382454px, 309.388723px) scale(0, 0);
  }
  46.875% {
    transform: translate(319.382454px, 309.388723px) scale(1, 1);
  }
  80.78125% {
    transform: translate(319.382454px, 309.388723px) scale(1, 1);
  }
  85.9375% {
    transform: translate(319.382454px, 309.388723px) scale(0, 0);
  }
  100% {
    transform: translate(319.382454px, 309.388723px) scale(0, 0);
  }
}
#eBN9jzcwViv100_ts {
  animation: eBN9jzcwViv100_ts__ts 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv100_ts__ts {
  0% {
    transform: translate(194.586327px, 309.388723px) scale(0, 0);
  }
  53.125% {
    transform: translate(194.586327px, 309.388723px) scale(0, 0);
  }
  57.8125% {
    transform: translate(194.586327px, 309.388723px) scale(1, 1);
  }
  80.78125% {
    transform: translate(194.586327px, 309.388723px) scale(1, 1);
  }
  85.9375% {
    transform: translate(194.586327px, 309.388723px) scale(0, 0);
  }
  100% {
    transform: translate(194.586327px, 309.388723px) scale(0, 0);
  }
}
#eBN9jzcwViv106_ts {
  animation: eBN9jzcwViv106_ts__ts 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv106_ts__ts {
  0% {
    transform: translate(236.70978px, 308.67752px) scale(0.102782, 0);
  }
  56.25% {
    transform: translate(236.70978px, 308.67752px) scale(0.102782, 0);
  }
  59.375% {
    transform: translate(236.70978px, 308.67752px) scale(0.102782, 0.1);
  }
  80.78125% {
    transform: translate(236.70978px, 308.67752px) scale(0.102782, 0.1);
  }
  85.9375% {
    transform: translate(236.70978px, 308.67752px) scale(0, 0);
  }
  100% {
    transform: translate(236.70978px, 308.67752px) scale(0, 0);
  }
}
#eBN9jzcwViv121_ts {
  animation: eBN9jzcwViv121_ts__ts 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv121_ts__ts {
  0% {
    transform: translate(352.338838px, 308.67752px) scale(0.102782, 0);
  }
  50% {
    transform: translate(352.338838px, 308.67752px) scale(0.102782, 0);
  }
  53.125% {
    transform: translate(352.338838px, 308.67752px) scale(0.102782, 0.1);
  }
  80.78125% {
    transform: translate(352.338838px, 308.67752px) scale(0.102782, 0.1);
  }
  85.9375% {
    transform: translate(352.338838px, 308.67752px) scale(0.102782, 0);
  }
  100% {
    transform: translate(352.338838px, 308.67752px) scale(0.102782, 0);
  }
}
#eBN9jzcwViv136_ts {
  animation: eBN9jzcwViv136_ts__ts 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv136_ts__ts {
  0% {
    transform: translate(282.813442px, 308.67752px) scale(0.102782, 0);
  }
  54.6875% {
    transform: translate(282.813442px, 308.67752px) scale(0.102782, 0);
  }
  57.8125% {
    transform: translate(282.813442px, 308.67752px) scale(0.102782, 0.1);
  }
  81.25% {
    transform: translate(282.813442px, 308.67752px) scale(0.102782, 0.1);
  }
  85.9375% {
    transform: translate(282.813442px, 308.67752px) scale(0.102782, 0);
  }
  100% {
    transform: translate(282.813442px, 308.67752px) scale(0.102782, 0);
  }
}
#eBN9jzcwViv151_ts {
  animation: eBN9jzcwViv151_ts__ts 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv151_ts__ts {
  0% {
    transform: translate(149.606197px, 308.67752px) scale(0.102782, 0);
  }
  62.5% {
    transform: translate(149.606197px, 308.67752px) scale(0.102782, 0);
  }
  65.625% {
    transform: translate(149.606197px, 308.67752px) scale(0.102782, 0.1);
  }
  80.78125% {
    transform: translate(149.606197px, 308.67752px) scale(0.102782, 0.1);
  }
  85.9375% {
    transform: translate(149.606197px, 308.67752px) scale(0, 0);
  }
  100% {
    transform: translate(149.606197px, 308.67752px) scale(0, 0);
  }
}
#eBN9jzcwViv166_ts {
  animation: eBN9jzcwViv166_ts__ts 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv166_ts__ts {
  0% {
    transform: translate(254.704712px, 309.388723px) scale(0, 0);
  }
  43.75% {
    transform: translate(254.704712px, 309.388723px) scale(0, 0);
  }
  48.4375% {
    transform: translate(254.704712px, 309.388723px) scale(1, 1);
  }
  80.78125% {
    transform: translate(254.704712px, 309.388723px) scale(1, 1);
  }
  85.9375% {
    transform: translate(254.704712px, 309.388723px) scale(0, 0);
  }
  100% {
    transform: translate(254.704712px, 309.388723px) scale(0, 0);
  }
}
#eBN9jzcwViv229_to {
  animation: eBN9jzcwViv229_to__to 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv229_to__to {
  0% {
    transform: translate(157.014118px, 301.09568px);
  }
  64.0625% {
    transform: translate(157.014118px, 301.09568px);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  85.9375% {
    transform: translate(342.995448px, 301.09568px);
  }
  100% {
    transform: translate(342.995448px, 301.09568px);
  }
}
#eBN9jzcwViv229 {
  animation: eBN9jzcwViv229_c_o 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv229_c_o {
  0% {
    opacity: 0;
  }
  64.0625% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  68.4375% {
    opacity: 1;
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  81.25% {
    opacity: 1;
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  84.375% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#eBN9jzcwViv274_to {
  animation: eBN9jzcwViv274_to__to 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv274_to__to {
  0% {
    transform: translate(151.175375px, 303.248571px);
  }
  57.8125% {
    transform: translate(151.175375px, 303.248571px);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  75% {
    transform: translate(348.541724px, 303.248571px);
  }
  100% {
    transform: translate(348.541724px, 303.248571px);
  }
}
#eBN9jzcwViv274 {
  animation: eBN9jzcwViv274_c_o 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv274_c_o {
  0% {
    opacity: 0;
  }
  57.8125% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  62.1875% {
    opacity: 1;
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  70.3125% {
    opacity: 1;
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  75% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#eBN9jzcwViv326_to {
  animation: eBN9jzcwViv326_to__to 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv326_to__to {
  0% {
    transform: translate(152.180754px, 302.677524px);
  }
  40.625% {
    transform: translate(152.180754px, 302.677524px);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  57.8125% {
    transform: translate(347.536349px, 302.677524px);
  }
  100% {
    transform: translate(347.536349px, 302.677524px);
  }
}
#eBN9jzcwViv326 {
  animation: eBN9jzcwViv326_c_o 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv326_c_o {
  0% {
    opacity: 0;
  }
  40.625% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  45% {
    opacity: 1;
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  53.125% {
    opacity: 1;
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  57.8125% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#eBN9jzcwViv394_to {
  animation: eBN9jzcwViv394_to__to 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv394_to__to {
  0% {
    transform: translate(151.182479px, 301.334683px);
  }
  50% {
    transform: translate(151.182479px, 301.334683px);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  68.75% {
    transform: translate(347.829901px, 301.334683px);
  }
  100% {
    transform: translate(347.829901px, 301.334683px);
  }
}
#eBN9jzcwViv394 {
  animation: eBN9jzcwViv394_c_o 6400ms linear infinite normal forwards;
}
@keyframes eBN9jzcwViv394_c_o {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  54.375% {
    opacity: 1;
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  62.5% {
    opacity: 1;
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  67.1875% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

@font-face {
  font-family: 'eBN9jzcwViv1:::Montserrat';
  font-style: normal;
  font-weight: 300;
  src: url(data:font/ttf;charset=utf-8;base64,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)
    format('truetype');
}
@font-face {
  font-family: 'eBN9jzcwViv1:::Montserrat';
  font-style: normal;
  font-weight: 800;
  src: url(data:font/ttf;charset=utf-8;base64,AAEAAAAQAQAABAAAR0RFRgBiABUAAAGkAAAALkdQT1OOeJesAAADqAAAAXpHU1VCI34khgAAAdQAAAAyT1MvMnh5Xi0AAALEAAAAYFNUQVTmSMwnAAACgAAAAERjbWFwAbgChAAAAyQAAACEZ2FzcAAAABAAAAEUAAAACGdseWYqt7o1AAAHiAAAA7poZWFkGBWy5wAAAggAAAA2aGhlYQkaAiAAAAGAAAAAJGhtdHgoOgHwAAACQAAAAEBsb2NhCQQIFwAAAVwAAAAibWF4cAAkALYAAAEcAAAAIG5hbWU1a1xCAAAFJAAAAmJwb3N0/58AMgAAATwAAAAgcHJlcGgGjIUAAAEMAAAAB7gB/4WwBI0AAAEAAf//AA8AAQAAABAAWQAHAFkACQABAAAAAAAAAAAAAAAAAAMAAwADAAAAAAAA/5wAMgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAvAGIAhgCfANkA5QD0AQwBRgGHAZgBrQHHAd0B3QAAAAEAAAPI/wUAAAYe/1b87AX5AAEAAAAAAAAAAAAAAAAAAAAQAAEAAgAeAAAAAAAAAA4AAQACAAAADAAAAAwAAQAAAAIAAgABAAsAAQANAA0AAQAAAAEAAAAOADAAMAAAAAAAA0RGTFQAGGN5cmwAFGxhdG4AFAAAAAAABAAAAAD//wAAAAAAAAABAAAACAAASibegV8PPPUAAwPoAAAAANYL/kYAAAAA3ZxwxP9W/v0F+QP9AAAABgACAAAAAAAAAksAKAMS//IC4gAiAzoARgKgAEYDAgAiAVMARgJiAEYDJgBGA04AIgKHABUCewAEAv7/8gK1/+wBGwAbASMAAAABAAEACAACAAAAFAACAAAAJAACd2dodAEAAABpdGFsARMAAQAEABAAAQAAAAABCAMgAAAAAwABAAIBFAAAAAAAAQAAAAQCcgMgAAUAAAKKAlgAAABLAooCWAAAAV4AMgE2AAAAAAAAAAAAAAAAoAAC/0AAIHsAAAAAAAAAAFVMQQAAwAAA+wIDyP8FAAAEVQEOIAABlwAAAAACBQK8AAAAIAADAAAAAgAAAAMAAAAUAAMAAQAAABQABABwAAAAGAAQAAMACAAgAC4AQQBFAEcASQBMAE8AVABWAFn//wAAACAALgBBAEMARwBJAEwATgBTAFYAWf///+//4P/A/7//vv+9/7v/uv+3/7b/tAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAKACoAOAADREZMVAAUY3lybAAUbGF0bgAUAAQAAAAA//8AAQAAAAFrZXJuAAgAAAABAAAAAQAEAAIACAABAAgAAgDoAAQAAAEUAPIADAAJAAAAAAAA//b/9gAA/+L/6P/sAAAAAAAAAAAAAAAAAAD//gAAAAAAAP/2AB3/3QAA/9T/2QAfAAAAAAAAAAAAAAAA//r/9gAKAAAAAP/x//T/+v/5//3//gALAAAAAAAAAAD/9gAA//EAAAAUAAD/8f/o/9n/7//x/+QAAP/ZAAD//f/i/9T/7//x//n/5P/ZAAAAAP/2/90ACv/+/+//7//eAAAAAAAAAAAAAAAAAAAAAAAKAAAAAP/1AAf/v//+/7n/0QAeAAAAAP/sAB//3gAK/9n/2QAAAAIAAQABAA4AAAABAAEADgADAAIAAQABAAIAAQABAAEAAgAFAAQABwAGAAgAAQABAA4AAgAEAAAAAwAJAAEACgABAAAABQAIAAYABwALAAAAAAAMAJYAAwABBAkAAACwARwAAwABBAkAAQAoAPQAAwABBAkAAgAOAOYAAwABBAkAAwA8AKoAAwABBAkABAAoAPQAAwABBAkABQAaAJAAAwABBAkABgAoAGgAAwABBAkADgA0ADQAAwABBAkBAAAMACgAAwABBAkBCAASABYAAwABBAkBEwAMAAoAAwABBAkBFAAKAAAAUgBvAG0AYQBuAEkAdABhAGwAaQBjAEUAeAB0AHIAYQBCAG8AbABkAFcAZQBpAGcAaAB0AGgAdAB0AHAAOgAvAC8AcwBjAHIAaQBwAHQAcwAuAHMAaQBsAC4AbwByAGcALwBPAEYATABNAG8AbgB0AHMAZQByAHIAYQB0AC0ARQB4AHQAcgBhAEIAbwBsAGQAVgBlAHIAcwBpAG8AbgAgADgALgAwADAAMAA4AC4AMAAwADAAOwBVAEwAQQA7AE0AbwBuAHQAcwBlAHIAcgBhAHQALQBFAHgAdAByAGEAQgBvAGwAZABSAGUAZwB1AGwAYQByAE0AbwBuAHQAcwBlAHIAcgBhAHQAIABFAHgAdAByAGEAQgBvAGwAZABDAG8AcAB5AHIAaQBnAGgAdAAgADIAMAAxADEAIABUAGgAZQAgAE0AbwBuAHQAcwBlAHIAcgBhAHQAIABQAHIAbwBqAGUAYwB0ACAAQQB1AHQAaABvAHIAcwAgACgAaAB0AHQAcABzADoALwAvAGcAaQB0AGgAdQBiAC4AYwBvAG0ALwBKAHUAbABpAGUAdABhAFUAbABhAC8ATQBvAG4AdABzAGUAcgByAGEAdAApAAAAAgAoAAACIwK8AAMABwAAMxEhESUhESEoAfv+VQFb/qUCvP1ERgIwAAL/8gAAAyACvAAHAAsAACMBMwEjAzMDJzchFw4BNcMBNs7yTvIhMwFWMwK8/UQCW/2liJKSAAEAIv/yAtACygAhAAAFIi4CNTQ+AjMyFhcHJiYjIg4CFRQeAjMyNjcXBgYBo1ONZzo6Z41TYZkzfiJRMitIMx0dM0grMlEifjOZDjVihVBQhWI1REByKCocNUotLUo1HCoocj9FAAIARgAAAxgCvAAKABUAADMRITIWFhUUBgYjJzMyNjY1NCYmIyNGAUt0sGNjsHSFfTxZMjJZPH0CvFacbGudVp4tVzw9Vi0AAAIARgAAAngCvAADAAsAABMhFSEXIRUhESEVIfwBRf67DgFu/c4CJf6fAa2UgJkCvJkAAgAi//IC2gLKACEAJQAABSIuAjU0PgIzMhYXByYmIyIOAhUUHgIzMjY3FwYGNxEzEQGkU45nOjpoj1VjnDN+JFMzLUo0HR00SSwsVCtvPJ4rrw41YoVQUIViNUI+cicnHDVJLixKNR0dI4srLnMBCP7eAAABAEYAAAEMArwAAwAAMxEzEUbGArz9RAABAEYAAAJaArwABQAAMxEzESEVRsYBTgK8/eGdAAABAEYAAALgArwACwAAMxEzASMRMxEjATMRRqMBgk3Co/5+TQK8/i4B0v1EAdL+LgACACL/8gMsAsoAEwAnAAAFIi4CNTQ+AjMyHgIVFA4CJzI+AjU0LgIjIg4CFRQeAgGnVI5pOjppjlRVjWg7O2iNVShFMx0dM0UoKEUzHR0zRQ42Y4RPT4RjNjZjhE9PhWI2pBw1Si0uSTUcHDVJLi1KNRwAAAEAFf/yAnICygAtAAAFIiYnNxYWMzI2NjU0LgU1NDY2MzIWFwcmJiMiBgYVFB4FFRQGBgE8Vp8yQS97PSkyFyxGVVVGLEWKZ0WFND0yYi4pMhYrR1VVRitFiQ4rIpIeJw8ZERgcEhIcLUk4P2Y+Hx6TGxsRHBIXGxESGy1JNz1nPgABAAQAAAJ3ArwABwAAMxEjNSEVIxHb1wJz1gIfnZ394QAAAf/yAAADDAK8AAcAACEBMxMjATMBAR3+1db8fgECxP7UArz9ogJe/UQAAf/sAAACyQK8AAsAADMRFwEzEyMTMwE3Efcu/sfR4nnjwP7ILAEodwIL/oUBe/31d/7YAAEAG//3AP8A2AALAAAXIiY1NDYzMhYVFAaNMEJCMDBCQglAMTM9PTMxQAAAAA==)
    format('truetype');
}
</style>
